// Dra. Malu / CaptaZap v57 — figurinhas recebidas + biblioteca simples da empresa.
import { useState, useRef, useEffect, useMemo, useCallback } from "react";
import {
  FaPaperPlane,
  FaUserCircle,
  FaWhatsapp,
  FaInstagram,
  FaFacebookMessenger,
  FaTelegramPlane,
  FaEllipsisV,
  FaRegClock,
  FaPaperclip,
  FaLock,
  FaBuilding,
  FaPhoneAlt,
  FaBolt,
  FaMicrophone,
  FaRegSmile,
  FaCommentDots,
  FaFileAlt,
  FaStop,
  FaTimes,
  FaEye,
  FaUsers,
  FaCheckCircle,
  FaSyncAlt,
  FaReply,
  FaThumbtack,
} from "react-icons/fa";

import MessageBubble from "./MessageBubble";

const LIMITE_MENSAGEM = 1000;
const DRA_MALU_AVATAR_URL = "/dra-malu-avatar.webp";

const EMOJIS_RAPIDOS_GRUPOS = [
  {
    titulo: "Mais usados",
    emojis: ["👀", "😉", "🥹", "🫣", "🙄", "🥺", "😊", "🙏", "💙", "🦷", "✨", "✅", "📅", "⏰", "📍", "💰"],
  },
  {
    titulo: "Rostos",
    emojis: [
      "😀",
      "😃",
      "😄",
      "😁",
      "😊",
      "🙂",
      "😉",
      "😍",
      "🥰",
      "😘",
      "😅",
      "😂",
      "🤔",
      "😮",
      "😬",
      "😢",
      "😔",
    ],
  },
  {
    titulo: "Olhares e expressões",
    emojis: ["👀", "👁️", "😉", "🫣", "🙄", "🥹", "🥺", "😏", "🤨", "🧐", "😳", "😎", "🤩", "😒", "😌", "🤭", "🤫", "🤥", "😶", "🫠", "😜", "😝", "😛", "🤪", "😇", "😴", "🥱", "😤", "😡", "🤯", "😱", "😨", "😰", "😭", "😩", "😫", "🤗", "🤔", "🤐", "😷", "🤒", "🤕", "🤢", "🤮", "🥴"],
  },
  {
    titulo: "Pessoas e gestos",
    emojis: ["🙋", "🙋‍♀️", "🙋‍♂️", "🙆", "🙅", "🤷", "🤦", "💁", "🙇", "🫶", "🫰", "🫵", "👆", "👇", "👉", "👈", "🤌", "🤏", "👐", "🤲", "🤜", "🤛", "👊", "✊", "🖐️", "✋", "🤚", "🖖", "🤟", "🤘", "✍️"],
  },
  {
    titulo: "Animais e natureza",
    emojis: ["🐶", "🐱", "🐭", "🐰", "🦊", "🐻", "🐼", "🐨", "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🐔", "🐣", "🦋", "🐝", "🌻", "🌹", "🌷", "🌸", "🌼", "🌴", "🍀", "🌈", "☀️", "🌙", "🔥", "❄️"],
  },
  {
    titulo: "Comidas e bebidas",
    emojis: ["🍎", "🍌", "🍓", "🍉", "🍇", "🍍", "🥑", "🥦", "🍞", "🥐", "🧀", "🍕", "🍔", "🍟", "🌮", "🍝", "🍣", "🍰", "🎂", "🍫", "🍬", "☕", "🧃", "🥤", "🍹", "🍽️"],
  },
  {
    titulo: "Símbolos e objetos",
    emojis: ["✔️", "❌", "❗", "❓", "⚠️", "🚫", "💯", "🔴", "🟢", "🟡", "🔵", "🔒", "🔓", "🔑", "💻", "📱", "📷", "🎥", "🎵", "🎁", "🎈", "🏆", "🥇", "💳", "💵", "💸", "🛒", "🚗", "🏠", "📦", "📧", "📩", "🔍", "👓"],
  },
  {
    titulo: "Mãos",
    emojis: [
      "👍",
      "👎",
      "👏",
      "🙌",
      "🙏",
      "🤝",
      "💪",
      "👌",
      "✌️",
      "🤞",
      "👋",
      "☝️",
    ],
  },
  {
    titulo: "Corações",
    emojis: [
      "💙",
      "❤️",
      "💚",
      "💛",
      "🧡",
      "💜",
      "🤍",
      "💖",
      "💕",
      "💞",
      "💓",
      "💗",
    ],
  },
  {
    titulo: "Atendimento",
    emojis: [
      "💬",
      "📞",
      "📲",
      "📌",
      "📍",
      "📝",
      "📋",
      "✅",
      "☑️",
      "🔔",
      "⭐",
      "✨",
    ],
  },
  {
    titulo: "Agenda",
    emojis: [
      "📅",
      "🗓️",
      "⏰",
      "⌚",
      "⏳",
      "🚨",
      "🔁",
      "➡️",
      "⬅️",
      "📢",
      "💡",
      "🎯",
    ],
  },
  {
    titulo: "Clínica",
    emojis: [
      "🦷",
      "😁",
      "😬",
      "🏥",
      "👩‍⚕️",
      "👨‍⚕️",
      "💉",
      "🪥",
      "✨",
      "💎",
      "🌟",
      "🎉",
    ],
  },
];

const EMOJIS_RAPIDOS = EMOJIS_RAPIDOS_GRUPOS.flatMap((grupo) => grupo.emojis);

const API_BASE_RAW = String(
  import.meta.env?.VITE_API_BASE_URL ||
    import.meta.env?.VITE_API_URL ||
    import.meta.env?.VITE_BACKEND_URL ||
    "",
).trim();

const API_BASE = API_BASE_RAW.replace(/\/+$/, "");
const MAX_ARQUIVO_BYTES = 25 * 1024 * 1024;
const MAX_MENSAGENS_RENDER_CHAT = Number(
  import.meta.env?.VITE_CAPTAZAP_MAX_MENSAGENS_RENDER || 300,
);

function isIOSCaptaZap() {
  if (typeof navigator === "undefined") return false;

  const ua = String(navigator.userAgent || "");
  const platform = String(navigator.platform || "");

  return (
    /iPad|iPhone|iPod/i.test(ua) ||
    (platform === "MacIntel" && Number(navigator.maxTouchPoints || 0) > 1)
  );
}

function getPlataformaAudioCaptaZap() {
  if (typeof navigator === "undefined") return "desconhecida";
  if (isIOSCaptaZap()) return "ios";

  const ua = String(navigator.userAgent || "");
  if (/Android/i.test(ua)) return "android";

  return "desktop";
}

function escolherMimeAudioCaptaZap() {
  const tiposIOS = [
    "audio/mp4;codecs=mp4a.40.2",
    "audio/mp4",
    "audio/aac",
    "audio/x-m4a",
    "audio/webm;codecs=opus",
    "audio/webm",
    "audio/ogg;codecs=opus",
    "audio/ogg",
  ];

  const tiposPadrao = [
    "audio/webm;codecs=opus",
    "audio/webm",
    "audio/ogg;codecs=opus",
    "audio/ogg",
    "audio/mp4;codecs=mp4a.40.2",
    "audio/mp4",
    "audio/aac",
    "audio/x-m4a",
  ];

  const tipos = isIOSCaptaZap() ? tiposIOS : tiposPadrao;

  if (!window.MediaRecorder?.isTypeSupported) return "";

  return tipos.find((tipo) => MediaRecorder.isTypeSupported(tipo)) || "";
}

function normalizarMimeAudioCaptaZap(value = "") {
  const mime = String(value || "")
    .toLowerCase()
    .split(";")[0]
    .trim();

  if (mime === "audio/x-m4a") return "audio/mp4";
  if (mime === "audio/m4a") return "audio/mp4";
  if (mime === "audio/aac") return "audio/aac";
  if (mime === "audio/mp4") return "audio/mp4";
  if (mime === "audio/ogg") return "audio/ogg";
  if (mime === "audio/webm") return "audio/webm";
  if (mime === "audio/mpeg") return "audio/mpeg";
  if (mime === "audio/mp3") return "audio/mpeg";
  if (mime === "audio/wav") return "audio/wav";

  return isIOSCaptaZap() ? "audio/mp4" : "audio/webm";
}

function getExtensaoAudioCaptaZap(mime = "") {
  const normalizado = normalizarMimeAudioCaptaZap(mime);

  if (normalizado.includes("mp4")) return "m4a";
  if (normalizado.includes("aac")) return "aac";
  if (normalizado.includes("ogg")) return "ogg";
  if (normalizado.includes("mpeg")) return "mp3";
  if (normalizado.includes("wav")) return "wav";
  if (normalizado.includes("webm")) return "webm";

  return isIOSCaptaZap() ? "m4a" : "webm";
}

function criarMediaRecorderAudioCaptaZap(stream) {
  if (!window.MediaRecorder) {
    throw new Error("Este navegador não suporta gravação de áudio.");
  }

  const mimeType = escolherMimeAudioCaptaZap();

  if (mimeType) {
    return new MediaRecorder(stream, { mimeType });
  }

  return new MediaRecorder(stream);
}

export default function ChatPanel({
  conversa,
  empresaId,
  usuarios = [],
  followUpRegras = [],
  dentistas = [],
  procedimentos = [],
  onSend,
  currentUserId = null,
  currentUserName = "",
  usuarioOperadorId = null,
  usuarioOperadorNome = "",
  usuarioVisualizadorId = null,
  usuarioVisualizadorNome = "",
  responsavelOperacionalId = null,
  responsavelOperacionalNome = "",
  modoVisualizacao = "",
  somenteVisualizacao = false,
  isSupervisao = false,
  envioBloqueado = false,
  inputDisabled = false,
  disabled = false,
  carregandoMensagens = false,
  loadingMensagens = false,
  mensagensCarregando = false,
  conversaFixada = false,
  fixandoConversa = false,
  onToggleFixarConversa = null,
  onIniciarLigacao = null,
  onLoadOlderMessages = null,
}) {
  // Identidade autenticada de quem está usando o CaptaZap. Ela permanece
  // separada do responsável atual para preservar a autoria após transferências.
  const usuarioAutenticadoId = usuarioVisualizadorId || currentUserId || null;
  const usuarioAutenticadoNome = String(
    usuarioVisualizadorNome || currentUserName || "",
  ).trim();

  const [msg, setMsg] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [emojiAberto, setEmojiAberto] = useState(false);
  const [figurinhasAberto, setFigurinhasAberto] = useState(false);
  const [figurinhasEmpresa, setFigurinhasEmpresa] = useState([]);
  const [carregandoFigurinhas, setCarregandoFigurinhas] = useState(false);
  const [erroFigurinhas, setErroFigurinhas] = useState("");
  const [enviandoFigurinha, setEnviandoFigurinha] = useState("");
  const [respostasAberto, setRespostasAberto] = useState(false);
  const [tipoMensagemRapidaSelecionado, setTipoMensagemRapidaSelecionado] =
    useState("");
  const [mensagensRapidas, setMensagensRapidas] = useState([]);
  const [loadingMensagensRapidas, setLoadingMensagensRapidas] = useState(false);
  const [erroMensagensRapidas, setErroMensagensRapidas] = useState("");
  const [enviandoMidia, setEnviandoMidia] = useState(false);
  const [gravandoAudio, setGravandoAudio] = useState(false);
  const [erroMidia, setErroMidia] = useState("");
  const [audioPreview, setAudioPreview] = useState(null);
  const [audioGravacaoInicio, setAudioGravacaoInicio] = useState(null);
  const [audioGravacaoMs, setAudioGravacaoMs] = useState(0);
  const [previewMensagem, setPreviewMensagem] = useState(null);
  const [mensagemRespondendo, setMensagemRespondendo] = useState(null);
  // Histórico local da Lead Fria. O painel consulta a fonte oficial no backend
  // para exibir a mensagem da etapa, o ciclo e o status sem depender de dados
  // incompletos trazidos pela lista lateral do CaptaZap.
  const [historicoLeadFriaRemoto, setHistoricoLeadFriaRemoto] = useState([]);
  const [leadContextoIdSelecionado, setLeadContextoIdSelecionado] =
    useState(null);
  const [salvandoLeadContexto, setSalvandoLeadContexto] = useState(false);
  const [erroLeadContexto, setErroLeadContexto] = useState("");
  const [origemAdsRemota, setOrigemAdsRemota] = useState(null);
  const [registrandoLigacaoFollowUp, setRegistrandoLigacaoFollowUp] =
    useState(false);
  const [modalLigacaoFollowUpAberto, setModalLigacaoFollowUpAberto] =
    useState(false);
  const [formLigacaoFollowUp, setFormLigacaoFollowUp] = useState(() => ({
    realizadoEm: getDatetimeLocalNowCaptaZap(),
    resultado: "ligacao_realizada",
    observacao: "",
  }));
  const [erroLigacaoFollowUp, setErroLigacaoFollowUp] = useState("");
  const [gerandoProximaEtapaFollowUp, setGerandoProximaEtapaFollowUp] =
    useState(false);
  const [avatarContato, setAvatarContato] = useState("");
  const [avatarCarregando, setAvatarCarregando] = useState(false);
  const [avatarErro, setAvatarErro] = useState("");
  const [avatarAmpliadoAberto, setAvatarAmpliadoAberto] = useState(false);
  const [mensagemEncaminhar, setMensagemEncaminhar] = useState(null);
  const [encaminhandoMensagem, setEncaminhandoMensagem] = useState(false);
  const [mensagemFixar, setMensagemFixar] = useState(null);
  const [fixandoMensagemWhatsapp, setFixandoMensagemWhatsapp] = useState(false);

  const chatEndRef = useRef(null);
  const mensagensContainerRef = useRef(null);
  const carregandoHistoricoAnteriorRef = useRef(false);
  const inputArquivoRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const audioStreamRef = useRef(null);
  const audioStreamReleaseTimerRef = useRef(null);
  const audioEnvioLockRef = useRef(false);
  const inputMensagemRef = useRef(null);
  const contextoPacienteStorageKeyAnteriorRef = useRef("");
  const leadContextoAtivoRef = useRef({ key: "", leadId: null });

  const isDev = Boolean(import.meta.env?.DEV);

  useEffect(() => {
    // A resposta pertence à conversa atual e pode ser descartada ao trocar de chat.
    setMensagemRespondendo(null);
  }, [conversa?.id, conversa?.conversa_id, empresaId]);

  useEffect(() => {
    // O encaminhamento é uma operação modal independente. Não pode ser fechado
    // por refresh/SSE da conversa enquanto o operador está escolhendo contatos.
    // Só limpamos se a empresa realmente mudar.
    setMensagemEncaminhar(null);
    setMensagemFixar(null);
  }, [empresaId]);

  const telefoneConversaAtual = useMemo(
    () =>
      normalizarTelefoneCaptaZap(
        conversa?.telefone ||
          conversa?.numero ||
          conversa?.phone ||
          conversa?.whatsapp ||
          conversa?.lead?.telefone1 ||
          conversa?.lead?.telefone ||
          conversa?.lead?.celular ||
          conversa?.lead?.whatsapp ||
          "",
      ),
    [
      conversa?.telefone,
      conversa?.numero,
      conversa?.phone,
      conversa?.whatsapp,
      conversa?.lead?.telefone1,
      conversa?.lead?.telefone,
      conversa?.lead?.celular,
      conversa?.lead?.whatsapp,
    ],
  );

  const conversaVisualKey = useMemo(() => {
    const empresaKey =
      empresaId || conversa?.empresa_id || conversa?.empresaId || "sem-empresa";
    const telefoneKey = telefoneConversaAtual || "sem-telefone";
    const conversaKey =
      conversa?.id ||
      conversa?.conversa_id ||
      conversa?.chave_conversa ||
      "sem-id";
    const instanciaKey =
      conversa?.zapi_instance_id ||
      conversa?.zapiInstanceId ||
      conversa?.conexao_instance_id ||
      conversa?.conexaoInstanceId ||
      conversa?.instance_id ||
      conversa?.instanceId ||
      "sem-instancia";

    return `${empresaKey}-${instanciaKey}-${telefoneKey}-${conversaKey}`;
  }, [
    empresaId,
    telefoneConversaAtual,
    conversa?.id,
    conversa?.conversa_id,
    conversa?.chave_conversa,
    conversa?.zapi_instance_id,
    conversa?.zapiInstanceId,
    conversa?.conexao_instance_id,
    conversa?.conexaoInstanceId,
    conversa?.instance_id,
    conversa?.instanceId,
    conversa?.empresa_id,
    conversa?.empresaId,
  ]);

  const avatarInformadoConversa = useMemo(
    () =>
      resolverMidiaUrlCaptaZap(
        getAvatarContatoConversaCaptaZap(conversa),
        API_BASE,
      ),
    [conversa, conversaVisualKey],
  );

  const carregarAvatarContato = useCallback(
    async ({ force = false, abrirAoCarregar = false } = {}) => {
      if (!empresaId || !telefoneConversaAtual) {
        setAvatarErro("Telefone do contato não disponível.");
        return "";
      }

      try {
        setAvatarCarregando(true);
        setAvatarErro("");

        const params = new URLSearchParams({
          empresa_id: String(empresaId),
          phone: String(telefoneConversaAtual),
        });

        if (force) params.set("force", "1");

        const resposta = await requestJson(
          `/whatsapp/captazap/avatar?${params.toString()}`,
        );
        const profileUrl = resolverMidiaUrlCaptaZap(
          resposta?.profileUrl || "",
          API_BASE,
        );

        if (!profileUrl) {
          setAvatarContato("");
          setAvatarErro(
            "Este contato não possui foto visível no WhatsApp ou restringiu a privacidade.",
          );
          return "";
        }

        setAvatarContato(profileUrl);
        if (abrirAoCarregar) setAvatarAmpliadoAberto(true);
        return profileUrl;
      } catch (error) {
        setAvatarErro(
          error?.message || "Não foi possível carregar a foto do perfil.",
        );
        return "";
      } finally {
        setAvatarCarregando(false);
      }
    },
    [empresaId, telefoneConversaAtual],
  );

  useEffect(() => {
    let cancelado = false;

    setAvatarAmpliadoAberto(false);
    setAvatarErro("");

    if (avatarInformadoConversa) {
      setAvatarContato(avatarInformadoConversa);
      return () => {
        cancelado = true;
      };
    }

    setAvatarContato("");

    // O texto do chat tem prioridade. A consulta de foto pode envolver a
    // integração externa do WhatsApp e não deve atrasar a abertura da conversa.
    const timer = window.setTimeout(() => {
      (async () => {
        const profileUrl = await carregarAvatarContato();
        if (cancelado || !profileUrl) return;
        setAvatarContato(profileUrl);
      })();
    }, 700);

    return () => {
      cancelado = true;
      window.clearTimeout(timer);
    };
  }, [
    conversaVisualKey,
    avatarInformadoConversa,
    carregarAvatarContato,
  ]);

  const conversaPertenceEmpresa = useMemo(() => {
    if (!conversa || !empresaId) return false;

    const empresaConversa = conversa.empresa_id || conversa.empresaId;

    if (!empresaConversa && isDev) return true;

    return String(empresaConversa) === String(empresaId);
  }, [conversa, empresaId, isDev]);

  const protocoloIdLeadFriaAtual = useMemo(
    () =>
      Number(
        conversa?.protocolo_id ||
          conversa?.chamado_id ||
          conversa?.id_chamado ||
          conversa?.chamada_id ||
          conversa?.conversa_id ||
          conversa?.id ||
          0,
      ) || null,
    [
      conversa?.protocolo_id,
      conversa?.chamado_id,
      conversa?.id_chamado,
      conversa?.chamada_id,
      conversa?.conversa_id,
      conversa?.id,
    ],
  );

  const recarregarHistoricoLeadFria = useCallback(async () => {
    if (!empresaId || !telefoneConversaAtual) {
      setHistoricoLeadFriaRemoto([]);
      return [];
    }

    const params = new URLSearchParams({
      empresa_id: String(empresaId),
      telefone: String(telefoneConversaAtual),
    });

    if (protocoloIdLeadFriaAtual) {
      params.set("protocolo_id", String(protocoloIdLeadFriaAtual));
    }

    try {
      const resposta = await requestJson(
        `/whatsapp/followup-lead-fria/status?${params.toString()}`,
      );
      const historico =
        resposta?.followups || resposta?.historico || resposta?.dados || [];

      const lista = Array.isArray(historico) ? historico : [];
      setHistoricoLeadFriaRemoto(lista);
      return lista;
    } catch (error) {
      // Não interrompe o chat se a consulta complementar falhar. O painel
      // continua usando os dados já existentes na conversa, quando houver.
      if (isDev) {
        console.warn(
          "CaptaZap | não foi possível carregar a régua Lead Fria:",
          error,
        );
      }
      return [];
    }
  }, [empresaId, telefoneConversaAtual, protocoloIdLeadFriaAtual, isDev]);

  useEffect(() => {
    let cancelado = false;

    async function carregarHistoricoLeadFria() {
      if (!empresaId || !telefoneConversaAtual) {
        if (!cancelado) setHistoricoLeadFriaRemoto([]);
        return;
      }

      const params = new URLSearchParams({
        empresa_id: String(empresaId),
        telefone: String(telefoneConversaAtual),
      });

      if (protocoloIdLeadFriaAtual) {
        params.set("protocolo_id", String(protocoloIdLeadFriaAtual));
      }

      try {
        const resposta = await requestJson(
          `/whatsapp/followup-lead-fria/status?${params.toString()}`,
        );
        const historico =
          resposta?.followups || resposta?.historico || resposta?.dados || [];

        if (!cancelado) {
          setHistoricoLeadFriaRemoto(Array.isArray(historico) ? historico : []);
        }
      } catch (error) {
        if (isDev) {
          console.warn(
            "CaptaZap | falha ao consultar histórico Lead Fria:",
            error,
          );
        }
        if (!cancelado) setHistoricoLeadFriaRemoto([]);
      }
    }

    carregarHistoricoLeadFria();

    return () => {
      cancelado = true;
    };
  }, [
    empresaId,
    telefoneConversaAtual,
    protocoloIdLeadFriaAtual,
    conversaVisualKey,
    isDev,
  ]);

  const conversaRegua = useMemo(() => {
    const historico = Array.isArray(historicoLeadFriaRemoto)
      ? historicoLeadFriaRemoto
      : [];

    if (!historico.length) return conversa;

    const pendente = historico.find((item) =>
      ["pendente", "em_andamento"].includes(
        String(item?.status || "").toLowerCase(),
      ),
    );

    return {
      ...(conversa || {}),
      tipo_regua: "lead_fria",
      tipoRegra: "lead_fria",
      _follow_up_tipo_regua: "lead_fria",
      _followups_historico: historico,
      _follow_up_historico: historico,
      _followup_fluxo_completo: historico,
      chamado_followups: historico,
      _follow_up_pendente: Boolean(pendente),
      _follow_up_id: pendente?.id || null,
      _followup_chamado_id: pendente?.id || null,
      _follow_up_status: pendente?.status || "",
      _follow_up_etapa: pendente?.followup_ordem || null,
      _follow_up_titulo: pendente?.titulo || "",
      _follow_up_texto: pendente?.texto || "",
      _follow_up_canal: pendente?.canal || "whatsapp",
      _follow_up_liberado_em: pendente?.agendado_para || "",
    };
  }, [conversa, historicoLeadFriaRemoto]);

  const leadsVinculadas = useMemo(
    () => getLeadsVinculadasConversa(conversa),
    [conversa],
  );

  const totalLeadsVinculadas = leadsVinculadas.length;
  const telefoneCompartilhado = totalLeadsVinculadas > 1;

  const leadIdsVinculadasSet = useMemo(() => {
    return new Set(
      leadsVinculadas
        .map((lead) => String(getLeadIdGenerico(lead) || ""))
        .filter(Boolean),
    );
  }, [leadsVinculadas]);

  const contextoPacienteStorageKey = useMemo(() => {
    const empresaKey =
      empresaId || conversa?.empresa_id || conversa?.empresaId || "0";
    const telefoneKey = getTelefoneContextoPacienteKeyCaptaZap(
      telefoneConversaAtual ||
        conversa?.telefone ||
        conversa?.numero ||
        conversa?.phone ||
        "",
    );

    return `captazap:lead-contexto:${empresaKey}:${telefoneKey}`;
  }, [
    empresaId,
    conversa?.empresa_id,
    conversa?.empresaId,
    conversa?.telefone,
    conversa?.numero,
    conversa?.phone,
    telefoneConversaAtual,
  ]);

  // O backend/chamado é a fonte da verdade do paciente em contexto.
  // Não usamos mais localStorage para decidir identidade visual, porque isso
  // podia fazer um telefone/conversa herdar nome de outro contato.
  const leadContextoPersistido = null;

  const manterContextoPacienteAtivo = useCallback(
    (leadId) => {
      const leadIdSeguro = leadId ? Number(leadId) || leadId : null;
      if (!leadIdSeguro) return null;

      leadContextoAtivoRef.current = {
        key: contextoPacienteStorageKey,
        leadId: leadIdSeguro,
      };

      setLeadContextoIdSelecionado(leadIdSeguro);
      setErroLeadContexto("");

      return leadIdSeguro;
    },
    [contextoPacienteStorageKey],
  );

  const leadContextoIdEfetivo =
    leadContextoIdSelecionado ||
    (leadContextoAtivoRef.current?.key === contextoPacienteStorageKey
      ? leadContextoAtivoRef.current?.leadId
      : null) ||
    leadContextoPersistido ||
    getLeadContextoIdConversa(conversa) ||
    null;

  const leadContextoAtual = useMemo(() => {
    if (!leadContextoIdEfetivo) return null;

    return (
      leadsVinculadas.find(
        (lead) =>
          String(getLeadIdGenerico(lead)) === String(leadContextoIdEfetivo),
      ) || null
    );
  }, [leadContextoIdEfetivo, leadsVinculadas]);

  const conversaParaPlaceholders = useMemo(() => {
    const leadContexto = leadContextoAtual || null;

    if (!leadContexto) return conversa || {};

    const leadOriginal = conversa?.lead || {};
    const leadMesclada = {
      ...leadOriginal,
      ...leadContexto,
      profissional_nome:
        leadContexto.profissional_nome ||
        leadContexto.nome_profissional ||
        leadContexto.dentista_nome ||
        leadOriginal.profissional_nome ||
        leadOriginal.nome_profissional ||
        leadOriginal.dentista_nome ||
        conversa?.profissional_nome ||
        conversa?.nome_profissional ||
        conversa?.dentista_nome ||
        "",
      nome_profissional:
        leadContexto.nome_profissional ||
        leadContexto.profissional_nome ||
        leadContexto.dentista_nome ||
        leadOriginal.nome_profissional ||
        leadOriginal.profissional_nome ||
        leadOriginal.dentista_nome ||
        conversa?.nome_profissional ||
        conversa?.profissional_nome ||
        conversa?.dentista_nome ||
        "",
      dentista_nome:
        leadContexto.dentista_nome ||
        leadContexto.profissional_nome ||
        leadContexto.nome_profissional ||
        leadOriginal.dentista_nome ||
        leadOriginal.profissional_nome ||
        leadOriginal.nome_profissional ||
        conversa?.dentista_nome ||
        conversa?.profissional_nome ||
        conversa?.nome_profissional ||
        "",
      procedimento_nome:
        leadContexto.procedimento_nome ||
        leadContexto.nome_procedimento ||
        leadOriginal.procedimento_nome ||
        leadOriginal.nome_procedimento ||
        conversa?.procedimento_nome ||
        conversa?.nome_procedimento ||
        "",
      nome_procedimento:
        leadContexto.nome_procedimento ||
        leadContexto.procedimento_nome ||
        leadOriginal.nome_procedimento ||
        leadOriginal.procedimento_nome ||
        conversa?.nome_procedimento ||
        conversa?.procedimento_nome ||
        "",
      data_agendamento:
        leadContexto.data_agendamento ||
        leadContexto.dataAgendamento ||
        leadOriginal.data_agendamento ||
        leadOriginal.dataAgendamento ||
        conversa?.data_agendamento ||
        conversa?.dataAgendamento ||
        "",
      dataAgendamento:
        leadContexto.dataAgendamento ||
        leadContexto.data_agendamento ||
        leadOriginal.dataAgendamento ||
        leadOriginal.data_agendamento ||
        conversa?.dataAgendamento ||
        conversa?.data_agendamento ||
        "",
      id_dentista:
        leadContexto.id_dentista ||
        leadOriginal.id_dentista ||
        conversa?.id_dentista ||
        "",
      id_procedimento:
        leadContexto.id_procedimento ||
        leadOriginal.id_procedimento ||
        conversa?.id_procedimento ||
        "",
    };

    return {
      ...(conversa || {}),
      lead: leadMesclada,
      lead_contexto_id:
        leadContextoIdEfetivo ||
        conversa?.lead_contexto_id ||
        conversa?.leadContextoId ||
        null,
      leadContextoId:
        leadContextoIdEfetivo ||
        conversa?.leadContextoId ||
        conversa?.lead_contexto_id ||
        null,
      nome:
        leadMesclada.nome_lead ||
        leadMesclada.nomeLead ||
        leadMesclada.nome ||
        conversa?.nome ||
        conversa?.telefone ||
        conversa?.numero ||
        "",
      profissional_nome: leadMesclada.profissional_nome,
      nome_profissional: leadMesclada.nome_profissional,
      dentista_nome: leadMesclada.dentista_nome,
      procedimento_nome: leadMesclada.procedimento_nome,
      nome_procedimento: leadMesclada.nome_procedimento,
      data_agendamento: leadMesclada.data_agendamento,
      dataAgendamento: leadMesclada.dataAgendamento,
      id_dentista: leadMesclada.id_dentista,
      id_procedimento: leadMesclada.id_procedimento,
    };
  }, [conversa, leadContextoAtual, leadContextoIdEfetivo]);

  const leadIdOperacional = telefoneCompartilhado
    ? leadContextoAtual
      ? getLeadIdGenerico(leadContextoAtual)
      : null
    : leadContextoAtual
      ? getLeadIdGenerico(leadContextoAtual)
      : getLeadContextoSeguroConversa(conversa) || null;

  const getLeadIdOperacionalAtual = useCallback(() => {
    const leadValida = leadContextoAtual || null;
    const leadValidaId = leadValida ? getLeadIdGenerico(leadValida) : null;

    if (telefoneCompartilhado) return leadValidaId || null;

    return leadValidaId || getLeadContextoSeguroConversa(conversa) || null;
  }, [conversa, leadContextoAtual, telefoneCompartilhado]);

  useEffect(() => {
    const vinculadas = getLeadsVinculadasConversa(conversa);
    const idsValidos = new Set(
      vinculadas
        .filter((lead) =>
          leadPertenceAoTelefoneCaptaZap(lead, telefoneConversaAtual),
        )
        .map((lead) => String(getLeadIdGenerico(lead) || ""))
        .filter(Boolean),
    );

    const keyAnterior = contextoPacienteStorageKeyAnteriorRef.current;
    const keyMudou = keyAnterior !== contextoPacienteStorageKey;

    if (keyMudou) {
      contextoPacienteStorageKeyAnteriorRef.current =
        contextoPacienteStorageKey;
      leadContextoAtivoRef.current = {
        key: contextoPacienteStorageKey,
        leadId: null,
      };
      setLeadContextoIdSelecionado(null);
      setErroLeadContexto("");
    }

    const contextoBackend = getLeadContextoIdConversa(conversa);
    const contextoBackendTexto = String(contextoBackend || "");

    if (contextoBackendTexto && idsValidos.has(contextoBackendTexto)) {
      setErroLeadContexto("");
      return;
    }

    // Se há só uma lead válida para o telefone, ela pode ser usada como contexto
    // visual local sem persistir em localStorage. Se há várias, o backend precisa
    // definir lead_contexto_id explicitamente.
    if (!contextoBackendTexto && vinculadas.length === 1) {
      const unicaId = getLeadIdGenerico(vinculadas[0]);
      if (
        unicaId &&
        leadPertenceAoTelefoneCaptaZap(vinculadas[0], telefoneConversaAtual)
      ) {
        setLeadContextoIdSelecionado(unicaId);
        setErroLeadContexto("");
        return;
      }
    }

    if (vinculadas.length > 1 && !contextoBackendTexto) {
      setLeadContextoIdSelecionado(null);
      setErroLeadContexto(
        "Este WhatsApp possui mais de um paciente vinculado. Defina a lead em contexto no chamado antes de enviar.",
      );
      return;
    }

    if (contextoBackendTexto && !idsValidos.has(contextoBackendTexto)) {
      setLeadContextoIdSelecionado(null);
      setErroLeadContexto(
        "A lead em contexto não pertence ao telefone desta conversa. Atualize o contexto do chamado.",
      );
      return;
    }

    setErroLeadContexto("");
  }, [
    conversa?.id,
    conversa?.conversa_id,
    conversa?.telefone,
    conversa?.numero,
    conversa?.lead_contexto_id,
    conversa?.leadContextoId,
    contextoPacienteStorageKey,
    leadsVinculadas,
    telefoneConversaAtual,
  ]);

  const selecionarLeadContexto = async (leadId) => {
    const leadIdSeguro = Number(leadId || 0);

    if (!leadIdSeguro) return;

    const leadSelecionada = leadsVinculadas.find(
      (lead) => Number(getLeadIdGenerico(lead) || 0) === leadIdSeguro,
    );

    if (
      leadSelecionada &&
      !leadPertenceAoTelefoneCaptaZap(leadSelecionada, telefoneConversaAtual)
    ) {
      window.alert(
        "Este paciente não pertence ao WhatsApp desta conversa. O contexto não foi alterado.",
      );
      return;
    }

    manterContextoPacienteAtivo(leadIdSeguro);

    const chamadoId =
      conversa?.chamado_id ||
      conversa?.id_chamado ||
      conversa?.chamada_id ||
      conversa?.chamada?.id ||
      null;

    if (!empresaId || !chamadoId) return;

    try {
      setSalvandoLeadContexto(true);

      await requestJson(
        `/whatsapp/captazap/chamados/${chamadoId}/contexto-lead`,
        {
          method: "PATCH",
          body: JSON.stringify({
            empresa_id: empresaId,
            lead_contexto_id: leadIdSeguro,
          }),
        },
      );
    } catch (error) {
      console.error("CaptaZap | erro ao salvar contexto da lead:", error);
      setErroLeadContexto(
        error?.message ||
          "Não foi possível salvar o paciente em contexto. O envio usará a seleção local.",
      );
    } finally {
      setSalvandoLeadContexto(false);
    }
  };

  const mensagens = useMemo(() => {
    const lista = conversa?.mensagens || [];

    if (!empresaId) return [];

    const normalizadas = lista
      .filter((mensagem) => {
        const empresaMensagem = mensagem.empresa_id || mensagem.empresaId;

        if (!empresaMensagem) return true;

        return String(empresaMensagem) === String(empresaId);
      })
      .filter((mensagem) =>
        mensagemPertenceTelefoneConversaCaptaZap(
          mensagem,
          telefoneConversaAtual,
        ),
      )
      .map((mensagem) =>
        normalizarMensagemMidiaCaptaZap(mensagem, {
          apiBase: API_BASE,
          empresaId,
          conversa,
        }),
      );

    // v56: a API/SSE pode mesclar mensagens históricas com eventos recém-chegados.
    // A conversa precisa ser exibida como um extrato: sempre em ordem cronológica.
    // Sem isso, um fechamento antigo (ex.: 22/08) pode aparecer visualmente depois
    // de uma recuperação/reabertura mais recente (ex.: 24/08).
    const ordenadas = normalizadas
      .map((mensagem, indiceOriginal) => ({
        mensagem,
        indiceOriginal,
        data: getDataMensagemCaptaZap(mensagem),
      }))
      .sort((a, b) => {
        const ta = a.data?.getTime?.();
        const tb = b.data?.getTime?.();
        const aTemData = Number.isFinite(ta);
        const bTemData = Number.isFinite(tb);

        if (aTemData && bTemData && ta !== tb) return ta - tb;
        if (aTemData !== bTemData) return aTemData ? -1 : 1;

        // Em eventos do mesmo segundo, o id preserva a ordem de gravação.
        const idA = Number(a.mensagem?.id || 0);
        const idB = Number(b.mensagem?.id || 0);
        if (idA && idB && idA !== idB) return idA - idB;

        return a.indiceOriginal - b.indiceOriginal;
      })
      .map((item) => item.mensagem);

    return ordenadas.length > MAX_MENSAGENS_RENDER_CHAT
      ? ordenadas.slice(-MAX_MENSAGENS_RENDER_CHAT)
      : ordenadas;
  }, [
    conversa?.mensagens,
    empresaId,
    telefoneConversaAtual,
    conversaVisualKey,
  ]);

  const estadoDraMaluEmRecuperacao = useMemo(
    () =>
      getEstadoDraMaluEmRecuperacaoCaptaZap(conversa) ||
      getEstadoDraMaluEmRecuperacaoCaptaZap(conversaRegua),
    [conversa, conversaRegua],
  );

  // A antiga tela operacional de Lead Fria (tentativas, ligações e régua
  // genérica) não pertence mais ao fluxo da Dra. Malu. A Dra. Malu usa sua
  // própria régua versionada e é acompanhada pelo banner de recuperação +
  // painel de supervisão. Mantemos o painel antigo apenas para follow-up
  // humano/comercial que não seja Lead Fria.
  const ocultarPainelFollowUpLegado = useMemo(() => {
    if (estadoDraMaluEmRecuperacao?.ativo) return true;

    const tipoRegua = detectarTipoReguaFollowUpChat(
      conversaRegua || conversa || {},
      conversaRegua?._followup_fluxo_completo ||
        conversaRegua?._followups_fluxo ||
        conversaRegua?._follow_up_fluxo ||
        [],
      followUpRegras || [],
    );

    return tipoRegua === "lead_fria";
  }, [
    conversa,
    conversaRegua,
    estadoDraMaluEmRecuperacao?.ativo,
    followUpRegras,
  ]);

  const alertaRecuperacaoDraMalu = useMemo(
    () => getAlertaRecuperacaoPendenteDraMaluCaptaZap(conversa, mensagens),
    [conversa, mensagens],
  );

  const carregandoHistoricoMensagens = Boolean(
    carregandoMensagens ||
    loadingMensagens ||
    mensagensCarregando ||
    conversa?.carregandoMensagens ||
    conversa?.loadingMensagens ||
    conversa?.mensagensCarregando ||
    conversa?.mensagens_carregando ||
    conversa?._carregandoMensagens ||
    conversa?._loadingMensagens,
  );

  const tiposMensagensRapidas = useMemo(() => {
    const ordemPreferida = [
      "Boas Vindas",
      "Quebra de Objeção",
      "Agradecimento",
      "Lembrete",
      "Finalização",
      "Informativo",
    ];

    const encontrados = new Map();

    for (const mensagem of mensagensRapidas || []) {
      const tipo = String(mensagem?.tipo || "").trim();
      if (!tipo) continue;

      const chave = normalizarTipoMensagemRapida(tipo);
      if (!encontrados.has(chave)) encontrados.set(chave, tipo);
    }

    const tipos = [...encontrados.values()];

    return tipos.sort((a, b) => {
      const ia = ordemPreferida.findIndex(
        (tipo) =>
          normalizarTipoMensagemRapida(tipo) ===
          normalizarTipoMensagemRapida(a),
      );
      const ib = ordemPreferida.findIndex(
        (tipo) =>
          normalizarTipoMensagemRapida(tipo) ===
          normalizarTipoMensagemRapida(b),
      );

      if (ia >= 0 && ib >= 0) return ia - ib;
      if (ia >= 0) return -1;
      if (ib >= 0) return 1;

      return String(a).localeCompare(String(b), "pt-BR");
    });
  }, [mensagensRapidas]);

  const mensagensRapidasFiltradas = useMemo(() => {
    if (!tipoMensagemRapidaSelecionado) return [];

    const tipoSelecionadoNormalizado = normalizarTipoMensagemRapida(
      tipoMensagemRapidaSelecionado,
    );

    return (mensagensRapidas || []).filter(
      (mensagem) =>
        normalizarTipoMensagemRapida(mensagem?.tipo) ===
        tipoSelecionadoNormalizado,
    );
  }, [mensagensRapidas, tipoMensagemRapidaSelecionado]);

  const mensagensRapidasFavoritas = useMemo(
    () =>
      mensagensRapidasFiltradas.filter((mensagem) =>
        Boolean(mensagem?.favorita),
      ),
    [mensagensRapidasFiltradas],
  );

  const mensagensRapidasComuns = useMemo(
    () => mensagensRapidasFiltradas.filter((mensagem) => !mensagem?.favorita),
    [mensagensRapidasFiltradas],
  );

  const tipoMensagemRapidaSugerido = useMemo(
    () => getTipoMensagemRapidaSugerido(conversa, mensagensRapidas),
    [conversa, mensagensRapidas],
  );

  // A conversa pode usar duas réguas diferentes com as mesmas ordens 1..N:
  // "Follow-up" (régua comercial antiga) e "lead_fria" (chamado ainda sem lead).
  // Nunca podemos montar a timeline somente pela ordem, porque a etapa 2 de
  // uma régua pode ter canal e texto completamente diferentes da etapa 2 da outra.
  const tipoReguaFollowUpAtiva = useMemo(() => {
    if (
      Array.isArray(historicoLeadFriaRemoto) &&
      historicoLeadFriaRemoto.length
    ) {
      return "lead_fria";
    }

    return detectarTipoReguaFollowUpChat(conversa);
  }, [conversa, historicoLeadFriaRemoto]);

  const followUpRegrasPainel = useMemo(() => {
    const externas = Array.isArray(followUpRegras) ? followUpRegras : [];

    const locais = (mensagensRapidas || []).filter((item) => {
      const ativo =
        item?.followup_ativo === true ||
        item?.followup_ativo === 1 ||
        String(item?.followup_ativo || "").trim() === "1";

      const ordem = Number(item?.followup_ordem || item?.ordem || 0);

      return ativo && Number.isFinite(ordem) && ordem > 0;
    });

    // Junta fontes. Em algumas telas a prop externa traz apenas Follow-up,
    // enquanto a lista local contém também lead_fria. O merge evita perder a
    // régua certa quando uma fonte estiver incompleta.
    const porId = new Map();
    for (const regra of [...externas, ...locais]) {
      if (!regra) continue;
      const chave = String(
        regra?.id ||
          `${regra?.tipo || ""}-${regra?.followup_ordem || regra?.ordem || ""}-${regra?.titulo || ""}`,
      );
      if (!porId.has(chave)) porId.set(chave, regra);
    }

    const todas = [...porId.values()];
    const filtradasPorTipo = tipoReguaFollowUpAtiva
      ? todas.filter(
          (regra) =>
            normalizarTipoReguaFollowUpChat(
              regra?.tipo_regra || regra?.tipoRegra || regra?.tipo || "",
            ) === tipoReguaFollowUpAtiva,
        )
      : [];

    // Só cai para a lista completa quando ainda não há informação suficiente
    // para identificar a régua do chamado. Assim nunca mistura regras quando
    // a conversa já está marcada como Lead Fria.
    const base = filtradasPorTipo.length ? filtradasPorTipo : todas;

    return [...base].sort((a, b) => {
      const ordemA = Number(a?.followup_ordem || a?.ordem || 0);
      const ordemB = Number(b?.followup_ordem || b?.ordem || 0);

      if (ordemA !== ordemB) return ordemA - ordemB;

      return Number(a?.id || 0) - Number(b?.id || 0);
    });
  }, [followUpRegras, mensagensRapidas, tipoReguaFollowUpAtiva]);

  useEffect(() => {
    if (!empresaId) {
      setMensagensRapidas([]);
      setTipoMensagemRapidaSelecionado("");
      setErroMensagensRapidas("");
      return;
    }

    let cancelado = false;

    async function carregarMensagensRapidas() {
      setLoadingMensagensRapidas(true);
      setErroMensagensRapidas("");

      try {
        const lista = await buscarMensagensRapidasEmpresa(empresaId);

        if (cancelado) return;

        setMensagensRapidas(
          (Array.isArray(lista) ? lista : [])
            .filter((item) => item && item.texto)
            .sort((a, b) => {
              const favoritaA = Number(Boolean(a.favorita));
              const favoritaB = Number(Boolean(b.favorita));

              if (favoritaA !== favoritaB) return favoritaB - favoritaA;

              return Number(b.id || 0) - Number(a.id || 0);
            }),
        );
      } catch (error) {
        if (cancelado) return;

        console.error("CaptaZap | erro ao carregar mensagens rápidas:", error);
        setMensagensRapidas([]);
        setErroMensagensRapidas(
          error?.message || "Não foi possível carregar as mensagens rápidas.",
        );
      } finally {
        if (!cancelado) setLoadingMensagensRapidas(false);
      }
    }

    carregarMensagensRapidas();

    return () => {
      cancelado = true;
    };
  }, [empresaId]);

  useEffect(() => {
    let cancelado = false;

    async function carregarOrigemAds() {
      setOrigemAdsRemota(null);

      if (!conversa || !empresaId) return;

      const origemDireta = getOrigemAnuncioConversa(conversa);
      if (origemDireta) return;

      try {
        const origem = await buscarOrigemAdsConversaChat(conversa, empresaId);
        if (!cancelado) setOrigemAdsRemota(origem);
      } catch (error) {
        if (!cancelado && isDev) {
          console.warn("CaptaZap | origem de anúncio não encontrada:", error);
        }
      }
    }

    carregarOrigemAds();

    return () => {
      cancelado = true;
    };
  }, [
    conversa?.id,
    conversa?.conversa_id,
    conversa?.telefone,
    conversa?.numero,
    conversa?.lead_id,
    conversa?.leadId,
    empresaId,
    isDev,
  ]);

  const handleCarregarMensagensAnteriores = useCallback(async () => {
    if (
      typeof onLoadOlderMessages !== "function" ||
      !conversa?._mensagens_has_more ||
      conversa?._carregando_mensagens_anteriores
    ) {
      return;
    }

    const container = mensagensContainerRef.current;
    const alturaAntes = container?.scrollHeight || 0;
    const scrollAntes = container?.scrollTop || 0;

    carregandoHistoricoAnteriorRef.current = true;

    try {
      await onLoadOlderMessages();

      window.requestAnimationFrame(() => {
        const atual = mensagensContainerRef.current;
        if (atual) {
          const diferenca = atual.scrollHeight - alturaAntes;
          atual.scrollTop = scrollAntes + Math.max(0, diferenca);
        }
        carregandoHistoricoAnteriorRef.current = false;
      });
    } catch {
      carregandoHistoricoAnteriorRef.current = false;
    }
  }, [
    conversa?._mensagens_has_more,
    conversa?._carregando_mensagens_anteriores,
    onLoadOlderMessages,
  ]);

  useEffect(() => {
    if (carregandoHistoricoAnteriorRef.current) return undefined;

    const timer = window.setTimeout(() => {
      if (carregandoHistoricoAnteriorRef.current) return;
      chatEndRef.current?.scrollIntoView({
        behavior: "auto",
        block: "end",
      });
    }, 120);

    return () => window.clearTimeout(timer);
  }, [
    conversa?.id,
    conversa?.conversa_id,
    conversa?.telefone,
    conversa?.numero,
    mensagens.length,
  ]);

  useEffect(() => {
    setMsg("");
    setEmojiAberto(false);
    setFigurinhasAberto(false);
    setErroFigurinhas("");
    setRespostasAberto(false);
    setTipoMensagemRapidaSelecionado("");
    setErroMidia("");
    limparAudioPreview(setAudioPreview);
    setAudioGravacaoInicio(null);
    setAudioGravacaoMs(0);
    setPreviewMensagem(null);
  }, [conversaVisualKey]);

  useEffect(() => {
    return () => {
      limparTimerLiberacaoStreamAudio(audioStreamReleaseTimerRef);
      pararStreamAudio(audioStreamRef);
      limparAudioPreview(setAudioPreview);
    };
  }, []);

  useEffect(() => {
    if (!gravandoAudio || !audioGravacaoInicio) return undefined;

    const timer = window.setInterval(() => {
      setAudioGravacaoMs(Date.now() - audioGravacaoInicio);
    }, 250);

    return () => window.clearInterval(timer);
  }, [gravandoAudio, audioGravacaoInicio]);

  const enviarTextoCaptaZap = async (
    textoEntrada,
    { limparCampo = true, followupId = null } = {},
  ) => {
    const texto = String(textoEntrada || "").trim();
    const etapaId = Number(followupId || 0) || null;

    if (
      !texto ||
      enviando ||
      enviandoMidia ||
      disabled ||
      inputDisabled ||
      envioBloqueado ||
      !conversa ||
      !empresaId
    ) {
      return false;
    }

    if (texto.length > LIMITE_MENSAGEM) {
      window.alert(
        `Mensagem muito grande. Limite de ${LIMITE_MENSAGEM} caracteres.`,
      );
      return false;
    }

    if (!usuarioAutenticadoId || !usuarioAutenticadoNome) {
      window.alert(
        "Não foi possível identificar o usuário logado. Atualize a página antes de enviar.",
      );
      return false;
    }

    if (!conversaPertenceEmpresa) return false;

    try {
      setEnviando(true);

      const leadIdEnvio = getLeadIdOperacionalAtual();

      if (telefoneCompartilhado && !leadIdEnvio) {
        window.alert(
          "Este telefone está vinculado a mais de um paciente. Selecione o paciente em contexto antes de enviar.",
        );
        return false;
      }

      if (leadIdEnvio) {
        manterContextoPacienteAtivo(leadIdEnvio);
      }

      if (etapaId) {
        // A mensagem da régua não passa pelo onSend genérico. Assim o
        // followup_id chega garantidamente ao backend e a etapa só é concluída
        // depois do envio real confirmado pela Z-API.
        const operadorId = usuarioAutenticadoId;
        const operadorNome = usuarioAutenticadoNome;

        if (!operadorId || !operadorNome) {
          window.alert(
            "Não foi possível identificar o usuário logado. Atualize a página antes de enviar.",
          );
          return false;
        }

        const resposta = await requestJson("/whatsapp/enviar", {
          method: "POST",
          body: JSON.stringify({
            empresa_id: empresaId,
            zapi_instance_id:
              conversa?.zapi_instance_id ||
              conversa?.zapiInstanceId ||
              conversa?.conexao_instance_id ||
              conversa?.conexaoInstanceId ||
              conversa?.instance_id ||
              conversa?.instanceId ||
              null,
            telefone:
              conversa?.numero || conversa?.telefone || telefoneConversaAtual,
            texto,
            direcao: "enviada",
            autor: "operador",
            status: "enviado",
            lead_id: leadIdEnvio || null,
            lead_contexto_id: leadIdEnvio || null,
            conversa_id: conversa?.conversa_id || conversa?.id || null,
            protocolo_id: protocoloIdLeadFriaAtual,
            followup_id: etapaId,
            usuario_id: operadorId,
            usuario_nome: operadorNome,
            responsavel_id: operadorId,
            responsavel_nome: operadorNome,
            resposta_msgid: mensagemRespondendo?.messageId || null,
            resposta_texto: mensagemRespondendo?.texto || null,
            resposta_tipo: mensagemRespondendo?.tipo || null,
            resposta_autor: mensagemRespondendo?.autor || null,
          }),
        });

        window.dispatchEvent(
          new CustomEvent("captazap:followup_executado", {
            detail: {
              empresa_id: empresaId,
              telefone:
                conversa?.numero || conversa?.telefone || telefoneConversaAtual,
              followup_id: etapaId,
              mensagem: resposta || null,
            },
          }),
        );

        await recarregarHistoricoLeadFria();
      } else {
        await onSend?.(texto, conversa, {
          empresaId,
          conversaId: conversa.id,
          canal: conversa.canal || "whatsapp",
          telefone: conversa.numero || conversa.telefone,
          leadId: leadIdEnvio,
          lead_id: leadIdEnvio,
          lead_contexto_id: leadIdEnvio,
          leadContextoId: leadIdEnvio,
          resposta_msgid: mensagemRespondendo?.messageId || null,
          resposta_texto: mensagemRespondendo?.texto || null,
          resposta_tipo: mensagemRespondendo?.tipo || null,
          resposta_autor: mensagemRespondendo?.autor || null,
        });
      }

      if (limparCampo) setMsg("");
      setMensagemRespondendo(null);
      if (leadIdEnvio) manterContextoPacienteAtivo(leadIdEnvio);
      setEmojiAberto(false);
      setFigurinhasAberto(false);
      setRespostasAberto(false);
      setTipoMensagemRapidaSelecionado("");

      window.setTimeout(() => {
        inputMensagemRef.current?.focus?.();
      }, 80);

      return true;
    } finally {
      setEnviando(false);
    }
  };

  const abrirMensagemFollowUpEtapa = () => {
    const info = getFollowUpProcessInfo(
      conversaRegua,
      mensagens,
      followUpRegrasPainel,
    );

    if (!info.ativo) return;

    if (!info.acaoDisponivel) {
      setErroLigacaoFollowUp(
        info.mensagemBloqueioAcao ||
          "Esta etapa ainda não está disponível para execução.",
      );
      return;
    }

    if (info.tipoAcao === "ligacao") {
      abrirModalRegistroLigacaoFollowUp();
      return;
    }

    const followupId = Number(info.followupId || 0) || null;

    if (!followupId) {
      setErroLigacaoFollowUp(
        "Não encontrei o identificador da etapa pendente. Atualize a conversa e tente novamente.",
      );
      return;
    }

    const textoBase = limparMarcadoresTecnicosFollowUpChat(
      info.textoCompleto || "",
    );
    const texto = limparMarcadoresTecnicosFollowUpChat(
      substituirPlaceholdersMensagemRapida(
        textoBase,
        conversaParaPlaceholders,
        {
          dentistas,
          procedimentos,
        },
      ),
    );

    if (texto) {
      setPreviewMensagem({
        origem: "followup",
        titulo: limparMarcadoresTecnicosFollowUpChat(
          info.etapaTitulo || "Follow-up",
        ),
        tipo: limparMarcadoresTecnicosFollowUpChat(
          info.tipoMensagem || "Follow-up",
        ),
        texto,
        followup_id: followupId,
        ciclo_id: info.cicloId || null,
        editavel: true,
      });
      setRespostasAberto(false);
      setEmojiAberto(false);
      setFigurinhasAberto(false);
      setErroMidia("");
      return;
    }

    setErroLigacaoFollowUp(
      "A mensagem cadastrada para esta etapa está vazia. Corrija o texto da régua Lead Fria antes de enviar.",
    );
  };

  const abrirModalRegistroLigacaoFollowUp = () => {
    const info = getFollowUpProcessInfo(
      conversaRegua,
      mensagens,
      followUpRegrasPainel,
    );

    if (!info.ativo || info.tipoAcao !== "ligacao") return;

    // Não deixa abrir o modal em etapa futura/aguardando prazo.
    // O backend só aceita registrar follow-up com status pendente.
    if (!info.acaoDisponivel) {
      setErroLigacaoFollowUp(
        info.mensagemBloqueioAcao ||
          "Esta ligação ainda não está pendente. Ela ficará disponível quando o prazo vencer.",
      );
      return;
    }

    setErroLigacaoFollowUp("");
    setFormLigacaoFollowUp({
      realizadoEm: getDatetimeLocalNowCaptaZap(),
      resultado: "ligacao_realizada",
      observacao: "",
    });
    setModalLigacaoFollowUpAberto(true);
    setEmojiAberto(false);
    setRespostasAberto(false);
  };

  const gerarProximaEtapaFollowUp = async () => {
    if (!empresaId || gerandoProximaEtapaFollowUp) return false;

    try {
      setGerandoProximaEtapaFollowUp(true);
      setErroLigacaoFollowUp("");

      const telefone = conversa?.telefone || conversa?.numero || "";
      const protocoloId =
        conversa?.protocolo_id ||
        conversa?.chamado_id ||
        conversa?.id_chamado ||
        conversa?.chamada_id ||
        null;

      const usuarioId =
        currentUserId ||
        usuarioOperadorId ||
        conversa?.responsavel_id ||
        conversa?.captador_id ||
        null;

      const data = await requestJsonComFallback(
        [
          `/api/followup-whatsapp/empresa/${empresaId}/reparar-proximas`,
          `/followup-whatsapp/empresa/${empresaId}/reparar-proximas`,
          `/api/followup-whatsapp/empresa/${empresaId}/gerar`,
          `/followup-whatsapp/empresa/${empresaId}/gerar`,
        ],
        {
          empresa_id: empresaId,
          usuario_id: usuarioId,
          usuario_nome: currentUserName || usuarioOperadorNome || "",
          telefone,
          protocolo_id: protocoloId,
        },
      );

      window.dispatchEvent(
        new CustomEvent("captazap:followup_atualizar", {
          detail: {
            empresa_id: empresaId,
            telefone,
            protocolo_id: protocoloId,
            resultado: data,
          },
        }),
      );

      const criados =
        Number(data?.criados || 0) ||
        Number(data?.total_criados || 0) ||
        Number(data?.gerados || 0) ||
        0;

      if (criados > 0) {
        setErroLigacaoFollowUp(
          "Próxima etapa criada. Atualize a fila se ela ainda não aparecer automaticamente.",
        );
      } else {
        setErroLigacaoFollowUp(
          "A próxima etapa ainda não venceu ou já não há regra disponível. Assim que vencer, ela aparece no Follow-up para registrar.",
        );
      }

      return true;
    } catch (error) {
      console.error(
        "CaptaZap | erro ao gerar próxima etapa de follow-up:",
        error,
      );
      setErroLigacaoFollowUp(
        error?.message ||
          "Não foi possível gerar a próxima etapa agora. Verifique se a regra de Follow-up 2 existe.",
      );
      return false;
    } finally {
      setGerandoProximaEtapaFollowUp(false);
    }
  };

  const registrarLigacaoFollowUp = async ({
    realizadoEm,
    resultado = "ligacao_realizada",
    observacao = "",
  } = {}) => {
    const info = getFollowUpProcessInfo(
      conversaRegua,
      mensagens,
      followUpRegrasPainel,
    );
    const followUpId = getFollowUpIdConversa(conversa);

    if (!info.ativo) return false;

    const ehLigacaoFollowUp = info.tipoAcao === "ligacao";

    if (!info.acaoDisponivel) {
      setErroLigacaoFollowUp(
        info.mensagemBloqueioAcao ||
          "Esta etapa ainda não está disponível para registro.",
      );
      return false;
    }

    if (!followUpId) {
      setErroLigacaoFollowUp(
        "Não existe uma etapa de ligação pendente no banco para registrar. A etapa anterior já foi realizada; gere ou aguarde a próxima ordem aparecer em Follow-up.",
      );
      return false;
    }

    if (registrandoLigacaoFollowUp) return false;

    const realizadoEmIso = datetimeLocalToIsoCaptaZap(realizadoEm);

    if (!realizadoEmIso) {
      setErroLigacaoFollowUp("Informe a data e hora da ligação.");
      return false;
    }

    try {
      setRegistrandoLigacaoFollowUp(true);

      const observacaoFinal = String(observacao || "").trim();
      const resultadoFinal = String(resultado || "ligacao_realizada").trim();

      await registrarExecucaoFollowUpChat({
        followUpId,
        empresaId,
        conversa,
        realizadoEm: realizadoEmIso,
        resultado: resultadoFinal,
        observacao:
          observacaoFinal ||
          `Ligação registrada pelo CaptaZap em ${formatarDataFollowUpChat(realizadoEmIso)}.`,
      });

      window.dispatchEvent(
        new CustomEvent("captazap:followup_executado", {
          detail: {
            followup_id: followUpId,
            empresa_id: empresaId,
            telefone: conversa?.telefone || conversa?.numero || "",
            realizado_em: realizadoEmIso,
            resultado: resultadoFinal,
            observacao: observacaoFinal,
          },
        }),
      );

      setModalLigacaoFollowUpAberto(false);
      return true;
    } catch (error) {
      console.error(
        "CaptaZap | erro ao registrar ligação do follow-up:",
        error,
      );
      setErroLigacaoFollowUp(
        error?.message ||
          "Não foi possível registrar a ligação. Confirme se esta etapa está pendente no follow-up.",
      );
      return false;
    } finally {
      setRegistrandoLigacaoFollowUp(false);
    }
  };


  const abrirEncaminhamentoMensagem = useCallback(
    (mensagem) => {
      const messageId = getMessageIdWhatsappCaptaZap(mensagem);

      if (!messageId) {
        window.alert(
          "Esta mensagem é antiga e não possui o ID do WhatsApp necessário para encaminhar.",
        );
        return;
      }

      setMensagemEncaminhar(mensagem);
      setEmojiAberto(false);
      setRespostasAberto(false);
      setErroMidia("");
    },
    [],
  );

  const confirmarEncaminhamentoMensagem = useCallback(
    async (destinatarios = []) => {
      if (
        !mensagemEncaminhar ||
        !empresaId ||
        !usuarioAutenticadoId ||
        !usuarioAutenticadoNome ||
        encaminhandoMensagem
      ) {
        return;
      }

      const lista = Array.isArray(destinatarios) ? destinatarios : [];

      if (!lista.length) {
        window.alert("Selecione ao menos um destinatário.");
        return;
      }

      try {
        setEncaminhandoMensagem(true);

        const resposta = await requestJson("/whatsapp/encaminhar-mensagem", {
          method: "POST",
          body: JSON.stringify({
            empresa_id: empresaId,
            zapi_instance_id:
              conversa?.zapi_instance_id ||
              conversa?.zapiInstanceId ||
              conversa?.conexao_instance_id ||
              conversa?.conexaoInstanceId ||
              conversa?.instance_id ||
              conversa?.instanceId ||
              mensagemEncaminhar?.zapi_instance_id ||
              null,
            mensagem_id:
              Number(mensagemEncaminhar?.id || 0) || null,
            msgid: getMessageIdWhatsappCaptaZap(mensagemEncaminhar),
            destinatarios: lista,
            usuario_id: usuarioAutenticadoId,
            usuario_nome: usuarioAutenticadoNome,
          }),
        });

        const enviados = Number(resposta?.total_enviado || 0);
        const erros = Number(resposta?.total_erros || 0);

        if (enviados <= 0) {
          const detalhe =
            resposta?.erros?.[0]?.erro ||
            "Não foi possível encaminhar a mensagem.";
          throw new Error(detalhe);
        }

        if (erros > 0) {
          window.alert(
            `Mensagem encaminhada para ${enviados} contato(s), mas ${erros} envio(s) falharam.`,
          );
        }

        setMensagemEncaminhar(null);

        window.dispatchEvent(
          new CustomEvent("captazap:mensagem_encaminhada", {
            detail: {
              empresa_id: empresaId,
              total_enviado: enviados,
              total_erros: erros,
            },
          }),
        );
      } catch (error) {
        console.error("CaptaZap | erro ao encaminhar mensagem:", error);
        window.alert(
          error?.message || "Não foi possível encaminhar esta mensagem.",
        );
      } finally {
        setEncaminhandoMensagem(false);
      }
    },
    [
      mensagemEncaminhar,
      empresaId,
      usuarioAutenticadoId,
      usuarioAutenticadoNome,
      encaminhandoMensagem,
    ],
  );

  const abrirFixacaoMensagemWhatsapp = useCallback((mensagem) => {
    const messageId = getMessageIdWhatsappCaptaZap(mensagem);
    if (!messageId) {
      window.alert(
        "Esta mensagem não possui o ID do WhatsApp necessário para ser fixada.",
      );
      return;
    }

    setMensagemFixar(mensagem);
    setEmojiAberto(false);
    setRespostasAberto(false);
    setErroMidia("");
  }, []);

  const executarFixacaoMensagemWhatsapp = useCallback(
    async ({ action = "pin", duration = "7_days" } = {}) => {
      if (!mensagemFixar || !empresaId || fixandoMensagemWhatsapp) return false;

      const messageId = getMessageIdWhatsappCaptaZap(mensagemFixar);
      const telefone = telefoneConversaAtual;
      const zapiInstanceId = String(
        conversa?.zapi_instance_id ||
          conversa?.zapiInstanceId ||
          conversa?.conexao_instance_id ||
          conversa?.conexaoInstanceId ||
          conversa?.instance_id ||
          conversa?.instanceId ||
          mensagemFixar?.zapi_instance_id ||
          mensagemFixar?.zapiInstanceId ||
          "",
      ).trim();

      if (!messageId || !telefone || !zapiInstanceId) {
        window.alert(
          "Não foi possível identificar a mensagem, o telefone ou a conexão WhatsApp.",
        );
        return false;
      }

      try {
        setFixandoMensagemWhatsapp(true);
        await requestJson("/whatsapp/captazap/mensagens/fixar", {
          method: "POST",
          body: JSON.stringify({
            empresa_id: empresaId,
            telefone,
            zapi_instance_id: zapiInstanceId,
            messageId,
            messageAction: action,
            pinMessageDuration: duration,
          }),
        });

        setMensagemFixar(null);
        return true;
      } catch (error) {
        console.error("CaptaZap | falha ao fixar/desafixar mensagem:", error);
        window.alert(
          error?.message ||
            `Não foi possível ${action === "pin" ? "fixar" : "desafixar"} a mensagem no WhatsApp.`,
        );
        return false;
      } finally {
        setFixandoMensagemWhatsapp(false);
      }
    },
    [
      conversa,
      empresaId,
      fixandoMensagemWhatsapp,
      mensagemFixar,
      telefoneConversaAtual,
    ],
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    await enviarTextoCaptaZap(msg, { limparCampo: true });
  };

  const inserirEmoji = (emoji) => {
    setMsg((atual) => `${atual}${emoji}`);
  };

  const carregarFigurinhasEmpresa = useCallback(async () => {
    if (!empresaId) {
      setFigurinhasEmpresa([]);
      return [];
    }

    try {
      setCarregandoFigurinhas(true);
      setErroFigurinhas("");
      const resposta = await requestJson(
        `/whatsapp/captazap/figurinhas?empresa_id=${encodeURIComponent(empresaId)}`,
      );
      const lista = Array.isArray(resposta?.figurinhas) ? resposta.figurinhas : [];
      setFigurinhasEmpresa(lista);
      return lista;
    } catch (error) {
      setFigurinhasEmpresa([]);
      setErroFigurinhas(
        error?.message || "Não foi possível carregar as figurinhas da empresa.",
      );
      return [];
    } finally {
      setCarregandoFigurinhas(false);
    }
  }, [empresaId]);

  const abrirFigurinhasEmpresa = async () => {
    if (figurinhasAberto) {
      setFigurinhasAberto(false);
      return;
    }

    setFigurinhasAberto(true);
    setEmojiAberto(false);
    setRespostasAberto(false);
    setTipoMensagemRapidaSelecionado("");
    await carregarFigurinhasEmpresa();
  };

  const enviarFigurinhaEmpresa = async (figurinha) => {
    if (
      !figurinha?.arquivo ||
      enviandoFigurinha ||
      enviando ||
      enviandoMidia ||
      envioDesabilitado ||
      !conversa ||
      !empresaId
    ) {
      return false;
    }

    if (!usuarioAutenticadoId || !usuarioAutenticadoNome) {
      window.alert(
        "Não foi possível identificar o usuário logado. Atualize a página antes de enviar.",
      );
      return false;
    }

    const telefone = conversa?.numero || conversa?.telefone || telefoneConversaAtual;
    const leadId = getLeadIdOperacionalAtual();
    const zapiInstanceId = String(
      conversa?.zapi_instance_id ||
        conversa?.zapiInstanceId ||
        conversa?.conexao_instance_id ||
        conversa?.conexaoInstanceId ||
        conversa?.instance_id ||
        conversa?.instanceId ||
        "",
    ).trim();

    if (telefoneCompartilhado && !leadId) {
      window.alert(
        "Este telefone está vinculado a mais de um paciente. Selecione o paciente em contexto antes de enviar a figurinha.",
      );
      return false;
    }

    if (!telefone) {
      window.alert("Não foi possível identificar o telefone da conversa.");
      return false;
    }

    if (!zapiInstanceId) {
      window.alert(
        "Não foi possível identificar a conexão WhatsApp deste atendimento. Atualize a conversa e tente novamente.",
      );
      return false;
    }

    try {
      setEnviandoFigurinha(figurinha.arquivo);
      setErroFigurinhas("");
      if (leadId) manterContextoPacienteAtivo(leadId);

      await requestJson("/whatsapp/captazap/figurinhas/enviar", {
        method: "POST",
        body: JSON.stringify({
          empresa_id: empresaId,
          zapi_instance_id: zapiInstanceId,
          telefone,
          arquivo: figurinha.arquivo,
          lead_id: leadId || null,
          lead_contexto_id: leadId || null,
          usuario_id: usuarioAutenticadoId,
          usuario_nome: usuarioAutenticadoNome,
          operador_id: usuarioAutenticadoId,
          operador_nome: usuarioAutenticadoNome,
          autor: "operador",
        }),
      });

      setFigurinhasAberto(false);
      return true;
    } catch (error) {
      const message = error?.message || "Não foi possível enviar a figurinha.";
      setErroFigurinhas(message);
      window.alert(message);
      return false;
    } finally {
      setEnviandoFigurinha("");
    }
  };

  const abrirPreviewMensagemRapida = (resposta) => {
    const textoComDados = substituirPlaceholdersMensagemRapida(
      resposta?.texto || "",
      conversaParaPlaceholders,
      { dentistas, procedimentos },
    );

    const temMidia = Boolean(
      resposta?.midia_url || resposta?.mediaUrl || resposta?.arquivo_url,
    );

    if (!textoComDados.trim() && !temMidia) return;

    // Garante URL completa para mídia relativa
    const midiaUrlRaw =
      resposta?.midia_url ||
      resposta?.mediaUrl ||
      resposta?.arquivo_url ||
      null;
    const midiaUrlFinal =
      midiaUrlRaw && !midiaUrlRaw.startsWith("http") && API_BASE
        ? `${API_BASE}${midiaUrlRaw.startsWith("/") ? "" : "/"}${midiaUrlRaw}`
        : midiaUrlRaw;

    setPreviewMensagem({
      origem: "rapida",
      titulo: resposta?.titulo || "Mensagem rápida",
      tipo:
        resposta?.tipo || tipoMensagemRapidaSelecionado || "Mensagem rápida",
      texto: textoComDados,
      midia_url: midiaUrlFinal,
      tipo_midia: resposta?.tipo_midia || resposta?.tipoMidia || null,
      mime_type: resposta?.mime_type || resposta?.mimeType || null,
      nome_arquivo: resposta?.nome_arquivo || resposta?.nomeArquivo || null,
      mensagem_rapida_id: resposta?.id || null,
    });

    // Fecha a lista de seleção após escolher a mensagem.
    // Assim a pré-visualização fica visível sozinha, sem sobreposição.
    setRespostasAberto(false);

    setEmojiAberto(false);
    setErroMidia("");
  };

  const fecharPreviewMensagem = () => {
    setPreviewMensagem(null);
  };

  const voltarPreviewMensagem = (textoEditado = null) => {
    const origem = previewMensagem?.origem;

    if (origem === "digitada" && textoEditado !== null) {
      setMsg(String(textoEditado));
    }

    setPreviewMensagem(null);

    // Se a pré-visualização veio das Mensagens Rápidas,
    // o botão Voltar reabre a lista para escolher outra mensagem.
    if (origem === "rapida") {
      setRespostasAberto(true);
      setEmojiAberto(false);
    }
  };

  const inserirPreviewNoCampo = () => {
    const texto = String(previewMensagem?.texto || "");

    // Regra de segurança:
    // a mensagem escolhida sempre substitui o conteúdo atual do campo.
    // Isso evita carregar rascunho, erro ou texto de outra conversa.
    setMsg(texto);

    setPreviewMensagem(null);
    setEmojiAberto(false);
    setRespostasAberto(false);
    setTipoMensagemRapidaSelecionado("");
    setErroMidia("");
  };

  const abrirPreviewMensagemDigitada = () => {
    const texto = msg.trim();

    if (!texto) {
      window.alert("Digite uma mensagem para visualizar.");
      return;
    }

    setPreviewMensagem({
      origem: "digitada",
      titulo: "Pré-visualização da mensagem digitada",
      tipo: "Texto manual",
      texto,
    });

    setEmojiAberto(false);
    setRespostasAberto(false);
  };

  const enviarPreviewMensagem = async (textoEditado = null) => {
    const texto = limparMarcadoresTecnicosFollowUpChat(
      textoEditado ?? previewMensagem?.texto ?? "",
    );
    const midiaUrl = previewMensagem?.midia_url || null;
    const tipoMidia = previewMensagem?.tipo_midia || null;
    const followupId =
      Number(
        previewMensagem?.followup_id || previewMensagem?.followupId || 0,
      ) || null;

    if (!texto && !midiaUrl) return;

    if (previewMensagem?.origem === "followup" && !followupId) {
      const message =
        "Não foi possível identificar a etapa da Lead Fria. Feche a prévia, atualize a conversa e tente novamente.";
      setErroMidia(message);
      window.alert(message);
      return;
    }

    if (midiaUrl) {
      try {
        setEnviandoMidia(true);
        setErroMidia("");

        const telefone = conversa?.numero || conversa?.telefone || "";
        const leadId = getLeadIdOperacionalAtual();

        const token = localStorage.getItem("token");
        const fetchResp = await fetch(midiaUrl, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        if (!fetchResp.ok)
          throw new Error(
            "Não foi possível carregar a mídia da mensagem rápida.",
          );

        const blob = await fetchResp.blob();

        const mimeTypeSalvo = previewMensagem?.mime_type || null;
        const mimeTypeHeader =
          fetchResp.headers.get("content-type")?.split(";")[0]?.trim() || "";
        const mimeTypeFallback =
          tipoMidia === "video" ? "video/mp4" : "image/jpeg";
        const mimeType =
          mimeTypeSalvo ||
          (mimeTypeHeader &&
          mimeTypeHeader !== "application/octet-stream" &&
          !mimeTypeHeader.includes("text/html")
            ? mimeTypeHeader
            : "") ||
          (blob.type &&
          blob.type !== "application/octet-stream" &&
          !blob.type.includes("text/html")
            ? blob.type
            : "") ||
          mimeTypeFallback;

        const extMap = {
          "image/jpeg": "jpg",
          "image/jpg": "jpg",
          "image/png": "png",
          "image/webp": "webp",
          "image/gif": "gif",
          "video/mp4": "mp4",
          "video/webm": "webm",
          "video/quicktime": "mov",
        };
        const ext = extMap[mimeType] || mimeType.split("/")[1] || "jpg";
        const nomeBase =
          (previewMensagem?.nome_arquivo || "").replace(/\.[^.]+$/, "") ||
          "midia-rapida";
        const nomeArquivo = `${nomeBase}.${ext}`;

        const blobComMime = new Blob([blob], { type: mimeType });

        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(String(reader.result || ""));
          reader.onerror = () =>
            reject(new Error("Erro ao converter mídia para base64."));
          reader.readAsDataURL(blobComMime);
        });

        const file = new File([blobComMime], nomeArquivo, { type: mimeType });

        await enviarMidiaCaptaZap({
          empresaId,
          conversa,
          telefone,
          leadId,
          leadContextoId: leadId,
          file,
          base64,
          tipoMidia: tipoMidia || "imagem",
          legenda: texto,
          usuarioId: usuarioAutenticadoId,
          usuarioNome: usuarioAutenticadoNome,
          followupId,
        });

        if (followupId) await recarregarHistoricoLeadFria();

        setPreviewMensagem(null);
        setMsg("");
        return;
      } catch (error) {
        console.error(
          "CaptaZap | erro ao enviar mídia da mensagem rápida:",
          error,
        );
        const message =
          error?.message ||
          "Não foi possível enviar a mídia da mensagem rápida.";
        setErroMidia(message);
        window.alert(message);
        return;
      } finally {
        setEnviandoMidia(false);
      }
    }

    const enviado = await enviarTextoCaptaZap(texto, {
      limparCampo: true,
      followupId,
    });

    if (enviado) {
      setPreviewMensagem(null);
    }
  };

  const handleSelecionarArquivo = async (event) => {
    const file = event.target.files?.[0];

    event.target.value = "";

    if (!file) return;

    await enviarArquivoMidia(file);
  };

  const enviarArquivoMidia = async (
    file,
    {
      audioGravado = false,
      base64Precarregado = null,
      followupId = null,
      clientRequestId = null,
    } = {},
  ) => {
    if (
      !file ||
      enviandoMidia ||
      disabled ||
      inputDisabled ||
      envioBloqueado ||
      !conversa ||
      !empresaId
    ) {
      return;
    }

    if (!conversaPertenceEmpresa) return;

    if (!usuarioAutenticadoId || !usuarioAutenticadoNome) {
      window.alert(
        "Não foi possível identificar o usuário logado. Atualize a página antes de enviar.",
      );
      return;
    }

    if (file.size > MAX_ARQUIVO_BYTES) {
      window.alert("Arquivo muito grande. Envie arquivos de até 25 MB.");
      return;
    }

    const telefone = conversa.numero || conversa.telefone || "";
    const leadId = getLeadIdOperacionalAtual();

    if (leadId) {
      manterContextoPacienteAtivo(leadId);
    }

    if (telefoneCompartilhado && !leadId) {
      window.alert(
        "Este telefone está vinculado a mais de um paciente. Selecione o paciente em contexto antes de enviar mídia.",
      );
      return;
    }

    if (!telefone) {
      window.alert("Não foi possível identificar o telefone da conversa.");
      return;
    }

    const tipoMidia = detectarTipoMidia(file);

    try {
      setEnviandoMidia(true);
      setErroMidia("");
      setEmojiAberto(false);
      setRespostasAberto(false);

      const base64 = base64Precarregado
        ? await base64Precarregado
        : await arquivoParaDataUrl(file);
      const legenda = audioGravado ? "" : msg.trim();

      await enviarMidiaCaptaZap({
        empresaId,
        conversa,
        telefone,
        leadId,
        leadContextoId: leadId,
        file,
        base64,
        tipoMidia,
        legenda,
        usuarioId: usuarioAutenticadoId,
        usuarioNome: usuarioAutenticadoNome,
        followupId,
        clientRequestId,
      });

      if (followupId) await recarregarHistoricoLeadFria();

      if (legenda) setMsg("");
      if (audioGravado) limparAudioPreview(setAudioPreview);
    } catch (error) {
      console.error("CaptaZap | erro ao enviar mídia:", error);
      const message =
        error?.message ||
        "Não foi possível enviar este arquivo. Verifique o backend de mídia.";

      setErroMidia(message);
      window.alert(message);
    } finally {
      setEnviandoMidia(false);
    }
  };

  const handleAudio = async () => {
    if (
      enviandoMidia ||
      disabled ||
      inputDisabled ||
      envioBloqueado ||
      !conversa ||
      !empresaId
    ) {
      return;
    }

    if (audioPreview) {
      window.alert(
        "Você já tem um áudio gravado. Envie ou cancele antes de gravar outro.",
      );
      return;
    }

    if (gravandoAudio) {
      // Não chama requestData() imediatamente antes de stop().
      // Em alguns Chrome/Android isso pode gerar um último fragmento WebM
      // incompleto. O stop() já dispara o dataavailable final.
      const recorderAtual = mediaRecorderRef.current;
      if (recorderAtual && recorderAtual.state !== "inactive") {
        recorderAtual.stop();
      }
      return;
    }

    if (!navigator?.mediaDevices?.getUserMedia) {
      window.alert("Este navegador não permite gravação de áudio.");
      return;
    }

    try {
      setErroMidia("");
      limparAudioPreview(setAudioPreview);
      audioChunksRef.current = [];

      const stream = await obterStreamAudioCaptaZap(
        audioStreamRef,
        audioStreamReleaseTimerRef,
      );

      const recorder = criarMediaRecorderAudioCaptaZap(stream);
      mediaRecorderRef.current = recorder;

      const inicio = Date.now();

      recorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      recorder.onerror = (event) => {
        console.error("CaptaZap | erro MediaRecorder:", event?.error || event);
        setErroMidia(
          event?.error?.message ||
            "Não foi possível gravar o áudio neste navegador.",
        );
      };

      recorder.onstop = () => {
        setGravandoAudio(false);
        setAudioGravacaoInicio(null);
        agendarLiberacaoStreamAudio(audioStreamRef, audioStreamReleaseTimerRef);

        const chunks = audioChunksRef.current.filter(
          (chunk) => chunk && chunk.size > 0,
        );

        audioChunksRef.current = [];

        if (!chunks.length) {
          setAudioGravacaoMs(0);
          setErroMidia(
            "Nenhum áudio foi capturado. Tente novamente e mantenha a gravação por alguns segundos.",
          );
          return;
        }

        const mimeDetectado =
          recorder.mimeType || chunks.find((chunk) => chunk?.type)?.type || "";

        const mimeFinal = normalizarMimeAudioCaptaZap(mimeDetectado);
        const extensao = getExtensaoAudioCaptaZap(mimeFinal);

        const blob = new Blob(chunks, { type: mimeFinal });

        if (!blob.size) {
          setAudioGravacaoMs(0);
          setErroMidia("O áudio gravado ficou vazio. Tente novamente.");
          return;
        }

        const file = new File(
          [blob],
          `audio-captazap-${Date.now()}.${extensao}`,
          {
            type: mimeFinal,
          },
        );

        const url = URL.createObjectURL(blob);

        // Pré-carrega o base64 enquanto o operador revisa o áudio.
        // Assim o clique em Enviar não fica preso fazendo FileReader na hora.
        const base64Promise = arquivoParaDataUrl(file).catch((error) => {
          console.warn("CaptaZap | falha ao pré-carregar áudio:", error);
          return arquivoParaDataUrl(file);
        });

        if (isDev) {
          console.log("🎙️ CaptaZap áudio gravado:", {
            userAgent: navigator.userAgent,
            isIOS: isIOSCaptaZap(),
            recorderMimeType: recorder.mimeType,
            chunkTypes: chunks.map((chunk) => chunk.type),
            mimeFinal,
            extensao,
            size: blob.size,
          });
        }

        setAudioPreview({
          file,
          url,
          size: blob.size,
          mime: mimeFinal,
          base64Promise,
          durationMs: Math.max(0, Date.now() - inicio),
          createdAt: Date.now(),
          requestId: gerarRequestIdAudioCaptaZap(),
        });
      };

      setAudioGravacaoInicio(inicio);
      setAudioGravacaoMs(0);

      // Mantém chunks periódicos por compatibilidade móvel.
      // iOS usa janela menor; Android/desktop mantêm 1s. O backend otimiza o
      // formato recebido sem remover esta camada de segurança do MediaRecorder.
      recorder.start(isIOSCaptaZap() ? 500 : 1000);

      setGravandoAudio(true);
      setEmojiAberto(false);
      setFigurinhasAberto(false);
      setRespostasAberto(false);
    } catch (error) {
      console.error("CaptaZap | erro ao gravar áudio:", error);
      pararStreamAudio(audioStreamRef);
      setGravandoAudio(false);
      setAudioGravacaoInicio(null);
      setAudioGravacaoMs(0);

      const mensagem = ehErroDispositivoAudioCaptaZap(error)
        ? "O microfone foi desconectado, trocado ou ficou indisponível no Windows. O CaptaZap tentou reconectar automaticamente. Confira o microfone selecionado no navegador e tente novamente."
        : error?.name === "NotAllowedError"
          ? "O acesso ao microfone está bloqueado. Libere a permissão de microfone para o CaptaZap no navegador e tente novamente."
          : error?.message ||
            "Não foi possível acessar o microfone. Verifique a permissão do navegador.";

      setErroMidia(mensagem);
      window.alert(mensagem);
    }
  };

  const handleCancelarAudioPreview = () => {
    limparAudioPreview(setAudioPreview);
    setAudioGravacaoMs(0);
    setErroMidia("");
  };

  const handleEnviarAudioPreview = async ({ fecharPreview = false } = {}) => {
    if (
      !audioPreview?.file ||
      enviandoMidia ||
      audioEnvioLockRef.current
    ) {
      return;
    }

    // Trava síncrona: evita clique duplo antes do React atualizar enviandoMidia.
    // O mesmo requestId segue ao backend como segunda camada de idempotência.
    audioEnvioLockRef.current = true;

    try {
      const followupId =
        Number(
          previewMensagem?.origem === "followup"
            ? previewMensagem?.followup_id || previewMensagem?.followupId || 0
            : 0,
        ) || null;

      await enviarArquivoMidia(audioPreview.file, {
        audioGravado: true,
        base64Precarregado: audioPreview.base64Promise || null,
        followupId,
        clientRequestId:
          audioPreview.requestId || gerarRequestIdAudioCaptaZap(),
      });

      if (fecharPreview) {
        setPreviewMensagem(null);
      }
    } finally {
      audioEnvioLockRef.current = false;
    }
  };

  if (!conversa) {
    return <EmptyConversation />;
  }

  if (!conversaPertenceEmpresa) {
    return <EmpresaMismatch conversa={conversa} empresaId={empresaId} />;
  }

  const nomeWhatsapp = String(
    conversa?.nome_whatsapp ||
      conversa?.nomeWhatsapp ||
      conversa?.contato_nome_whatsapp ||
      conversa?.contatoNomeWhatsapp ||
      "",
  )
    .replace(/\s+/g, " ")
    .trim();

  const nomeOficial = String(
    leadContextoAtual?.nome_lead ||
      leadContextoAtual?.nomeLead ||
      leadContextoAtual?.nome ||
      conversa?.nome_oficial ||
      conversa?.nomeOficial ||
      "",
  ).trim();

  const nome =
    nomeOficial ||
    conversa.nome ||
    nomeWhatsapp ||
    conversa.numero ||
    "Contato";

  const normalizarNomeVisualHeader = (value) =>
    String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");

  const nomePrincipalEhWhatsapp =
    Boolean(nomeWhatsapp) &&
    normalizarNomeVisualHeader(nome) === normalizarNomeVisualHeader(nomeWhatsapp);

  const mostrarNomeWhatsappSecundario =
    Boolean(nomeWhatsapp) &&
    normalizarNomeVisualHeader(nome) !== normalizarNomeVisualHeader(nomeWhatsapp);

  const status = formatStatus(conversa.status || "Atendimento");
  const canal = conversa.canal || "whatsapp";
  const empresaNome = conversa.empresa_nome || conversa.empresaNome;
  const canalStyle = getCanalStyle(canal);
  const anuncio = getOrigemAnuncioConversa(conversa) || origemAdsRemota;
  const telefoneHeader = conversa.numero || conversa.telefone || "";
  const nomeEhTelefone =
    normalizarTelefoneCaptaZap(nome) &&
    normalizarTelefoneCaptaZap(nome) ===
      normalizarTelefoneCaptaZap(telefoneHeader);
  const statusNormalizado = normalizarTipoMensagemRapida(status);
  const canalNormalizado = normalizarTipoMensagemRapida(canal);
  const mostrarStatusHeader =
    Boolean(statusNormalizado) && statusNormalizado !== canalNormalizado;
  const mostrarTelefoneHeader = Boolean(telefoneHeader);

  const envioDesabilitado = Boolean(
    disabled || inputDisabled || envioBloqueado,
  );
  const bloqueado =
    !msg.trim() ||
    enviando ||
    enviandoMidia ||
    envioDesabilitado ||
    msg.length > LIMITE_MENSAGEM;
  const midiaBloqueada =
    enviandoMidia || enviando || Boolean(enviandoFigurinha) || envioDesabilitado;

  return (
    <div className="flex h-full max-h-full min-h-0 min-w-0 flex-col overflow-hidden bg-[#efeae2]">
      <header className="relative shrink-0 border-b border-slate-300 bg-white px-2.5 py-1 shadow-sm">
        <div
          className={`absolute inset-x-0 top-0 h-[3px] ${canalStyle.accent}`}
        />

        <div className="flex min-w-0 items-center justify-between gap-2">
          <div className="flex min-w-0 flex-1 items-center gap-1.5">
            <div className="relative shrink-0">
              {avatarContato ? (
                <button
                  type="button"
                  onClick={() => setAvatarAmpliadoAberto(true)}
                  className="block rounded-full focus:outline-none focus-visible:ring-4 focus-visible:ring-blue-200"
                  title="Visualizar foto do perfil"
                  aria-label={`Visualizar foto do perfil de ${nome}`}
                >
                  <img
                    src={avatarContato}
                    alt={nome}
                    onError={() => {
                      setAvatarContato("");
                      setAvatarErro(
                        "A foto expirou. Clique para carregar novamente.",
                      );
                    }}
                    className={`h-8 w-8 rounded-full object-cover ring-2 transition hover:scale-105 ${canalStyle.avatarRing}`}
                  />
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() =>
                    carregarAvatarContato({
                      force: true,
                      abrirAoCarregar: true,
                    })
                  }
                  disabled={avatarCarregando}
                  className={`flex h-8 w-8 items-center justify-center rounded-full ring-2 transition hover:scale-105 disabled:cursor-wait ${canalStyle.avatarBg}`}
                  title={
                    avatarCarregando
                      ? "Carregando foto do perfil"
                      : avatarErro || "Carregar foto do perfil"
                  }
                  aria-label="Carregar foto do perfil"
                >
                  {avatarCarregando ? (
                    <FaSyncAlt size={16} className="animate-spin" />
                  ) : (
                    <FaUserCircle size={21} />
                  )}
                </button>
              )}

              <span
                className={`absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white shadow-sm ${canalStyle.iconBg}`}
              >
                <CanalIcon canal={canal} />
              </span>
            </div>

            <div className="min-w-0 flex-1">
              <div className="flex min-w-0 flex-wrap items-center gap-2">
                <h2
                  className="min-w-0 max-w-[330px] truncate text-[13px] font-black leading-tight text-slate-950"
                  title={nome}
                >
                  {nome}
                </h2>

                <span
                  className={`rounded-full border px-1.5 py-px text-[9px] font-black capitalize ${canalStyle.badge}`}
                >
                  {canal}
                </span>

                {empresaNome && (
                  <span className="hidden max-w-[180px] items-center gap-1 rounded-full border border-blue-200 bg-blue-50 px-1.5 py-px text-[9px] font-bold text-blue-700 xl:inline-flex">
                    <FaBuilding size={10} />
                    <span className="truncate">{empresaNome}</span>
                  </span>
                )}
              </div>

              <div className="mt-px flex min-w-0 items-center gap-1 text-[9.5px] font-semibold leading-tight text-slate-500">
                {mostrarNomeWhatsappSecundario ? (
                  <>
                    <FaWhatsapp
                      size={11}
                      className="shrink-0 text-emerald-600"
                    />
                    <span
                      className="max-w-[260px] truncate font-bold text-emerald-700"
                      title={`Nome do WhatsApp: ${nomeWhatsapp}`}
                    >
                      WhatsApp: {nomeWhatsapp}
                    </span>
                  </>
                ) : null}

                {mostrarStatusHeader ? (
                  <>
                    {mostrarNomeWhatsappSecundario ? (
                      <span className="text-slate-300">•</span>
                    ) : null}
                    <FaRegClock size={11} className="shrink-0" />
                    <span className="truncate">{status}</span>
                  </>
                ) : null}

                {mostrarTelefoneHeader ? (
                  <>
                    {mostrarStatusHeader || mostrarNomeWhatsappSecundario ? (
                      <span className="text-slate-300">•</span>
                    ) : null}
                    <FaPhoneAlt size={10} className="shrink-0" />
                    <span
                      className="inline-block max-w-full whitespace-nowrap leading-5 text-slate-600"
                      title={formatTelefoneHeader(telefoneHeader)}
                    >
                      {formatTelefoneHeader(telefoneHeader)}
                    </span>
                  </>
                ) : null}
              </div>
            </div>
          </div>

          <div className="flex shrink-0 items-center gap-2">
            {(canalNormalizado === "whatsapp" || canalNormalizado === "wa") &&
              telefoneConversaAtual &&
              typeof onIniciarLigacao === "function" && !somenteVisualizacao && (
                <button
                  type="button"
                  onClick={() => onIniciarLigacao(conversa)}
                  disabled={envioDesabilitado}
                  className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-slate-300 bg-white text-emerald-700 transition hover:border-emerald-400 hover:bg-emerald-50 hover:text-emerald-800 disabled:cursor-not-allowed disabled:opacity-50"
                  title="Ligar para este contato pelo WhatsApp"
                  aria-label="Fazer ligação pelo WhatsApp"
                >
                  <FaPhoneAlt size={13} />
                </button>
              )}
            {anuncio ? <AnuncioHeaderCard anuncio={anuncio} /> : null}

            {(canalNormalizado === "whatsapp" || canalNormalizado === "wa") &&
            telefoneConversaAtual &&
            typeof onToggleFixarConversa === "function" ? (
              <button
                type="button"
                onClick={() => onToggleFixarConversa(conversa)}
                disabled={fixandoConversa}
                className={`flex h-7 w-7 items-center justify-center rounded-lg border transition disabled:cursor-wait disabled:opacity-60 ${
                  conversaFixada
                    ? "border-amber-300 bg-amber-50 text-amber-700 shadow-sm hover:bg-amber-100"
                    : "border-slate-300 bg-white text-slate-500 hover:border-amber-300 hover:bg-amber-50 hover:text-amber-700"
                }`}
                title={
                  conversaFixada
                    ? "Desafixar conversa do CaptaZap e do WhatsApp"
                    : "Fixar conversa no CaptaZap e no WhatsApp"
                }
                aria-label={
                  conversaFixada ? "Desafixar conversa" : "Fixar conversa"
                }
              >
                <FaThumbtack
                  size={12}
                  className={fixandoConversa ? "animate-pulse" : ""}
                />
              </button>
            ) : null}

            <button
              type="button"
              className="flex h-7 w-7 items-center justify-center rounded-lg border border-slate-300 bg-white text-slate-500 transition hover:border-blue-300 hover:bg-blue-50 hover:text-blue-800"
              title="Mais opções"
            >
              <FaEllipsisV size={12} />
            </button>
          </div>
        </div>
      </header>

      {avatarAmpliadoAberto && avatarContato ? (
        <div
          className="fixed inset-0 z-[10000] flex items-center justify-center bg-slate-950/80 p-4 backdrop-blur-sm"
          role="dialog"
          aria-modal="true"
          aria-label={`Foto do perfil de ${nome}`}
          onClick={() => setAvatarAmpliadoAberto(false)}
        >
          <div
            className="relative w-full max-w-lg rounded-[28px] border border-white/20 bg-white p-4 shadow-2xl"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setAvatarAmpliadoAberto(false)}
              className="absolute right-3 top-3 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-slate-950/75 text-white shadow-lg transition hover:bg-slate-950"
              title="Fechar"
              aria-label="Fechar foto do perfil"
            >
              <FaTimes size={16} />
            </button>

            <img
              src={avatarContato}
              alt={`Foto do perfil de ${nome}`}
              className="max-h-[72vh] w-full rounded-[20px] bg-slate-100 object-contain"
            />

            <div className="flex items-center justify-between gap-3 px-1 pb-1 pt-3">
              <div className="min-w-0">
                <div className="truncate text-sm font-black text-slate-900">
                  {nome}
                </div>
                <div className="text-xs font-semibold text-slate-500">
                  Foto do perfil do WhatsApp
                </div>
              </div>

              <button
                type="button"
                onClick={() =>
                  carregarAvatarContato({
                    force: true,
                    abrirAoCarregar: true,
                  })
                }
                disabled={avatarCarregando}
                className="inline-flex h-10 shrink-0 items-center gap-2 rounded-2xl border border-slate-300 bg-white px-3 text-xs font-black text-slate-700 shadow-sm transition hover:border-blue-300 hover:bg-blue-50 hover:text-blue-800 disabled:cursor-wait disabled:opacity-60"
              >
                <FaSyncAlt
                  size={12}
                  className={avatarCarregando ? "animate-spin" : ""}
                />
                Atualizar foto
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {estadoDraMaluEmRecuperacao?.ativo ? (
        <AlertaDraMaluEmRecuperacaoCaptaZap
          estado={estadoDraMaluEmRecuperacao}
        />
      ) : alertaRecuperacaoDraMalu?.ativo ? (
        <AlertaResponsabilidadeDraMaluCaptaZap
          alerta={alertaRecuperacaoDraMalu}
        />
      ) : null}

      <section
        ref={mensagensContainerRef}
        key={`mensagens-${conversaVisualKey}`}
        className="relative min-h-0 flex-1 overflow-y-auto overscroll-contain bg-[#efeae2] px-5 py-4 pb-5"
        style={{
          backgroundImage:
            "radial-gradient(circle at 18px 18px, rgba(15, 23, 42, 0.045) 1px, transparent 1.5px), radial-gradient(circle at 70px 42px, rgba(15, 23, 42, 0.035) 1px, transparent 1.5px)",
          backgroundSize: "96px 96px",
        }}
      >
        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.18),rgba(255,255,255,0.03))]" />

        {carregandoHistoricoMensagens ? (
          <LoadingMessages canal={canal} />
        ) : mensagens.length === 0 ? (
          <EmptyMessages canal={canal} />
        ) : (
          <div className="relative mx-auto flex max-w-4xl flex-col gap-3">
            {conversa?._mensagens_has_more ? (
              <div className="flex justify-center pb-1">
                <button
                  type="button"
                  onClick={handleCarregarMensagensAnteriores}
                  disabled={Boolean(
                    conversa?._carregando_mensagens_anteriores,
                  )}
                  className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white/95 px-3 py-1.5 text-[10px] font-black text-slate-600 shadow-sm transition hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700 disabled:cursor-wait disabled:opacity-60"
                >
                  <FaRegClock size={11} />
                  {conversa?._carregando_mensagens_anteriores
                    ? "Carregando mensagens..."
                    : "Carregar mensagens anteriores"}
                </button>
              </div>
            ) : null}

            <ConversationContext conversa={conversa} canalStyle={canalStyle} />

            <LeadContextSelector
              conversa={conversa}
              leads={leadsVinculadas}
              leadContextoId={leadIdOperacional}
              leadContextoAtual={leadContextoAtual}
              salvando={salvandoLeadContexto}
              erro={erroLeadContexto}
              onSelect={selecionarLeadContexto}
            />

            {mensagens.map((mensagem, index) => {
              const mensagemAnterior = index > 0 ? mensagens[index - 1] : null;
              const mostrarSeparadorData =
                deveMostrarSeparadorDataMensagemCaptaZap(
                  mensagemAnterior,
                  mensagem,
                );

              return (
                <div
                  key={getMessageKey(
                    mensagem,
                    index,
                    empresaId,
                    conversaVisualKey,
                  )}
                  className="contents"
                >
                  {mostrarSeparadorData ? (
                    <DataMensagemSeparadorCaptaZap mensagem={mensagem} />
                  ) : null}

                  <MensagemComMidiaCaptaZap
                    mensagem={mensagem}
                    contato={conversa}
                    empresaId={empresaId}
                    usuarios={usuarios}
                    viewerUserId={currentUserId}
                    ownerUserId={responsavelOperacionalId}
                    ownerUserName={responsavelOperacionalNome}
                    modoVisualizacao={
                      modoVisualizacao ||
                      (somenteVisualizacao || isSupervisao
                        ? "supervisao"
                        : "atendimento")
                    }
                    onReply={(dados) => {
                      setMensagemRespondendo(dados);
                      setEmojiAberto(false);
                      setRespostasAberto(false);
                      window.setTimeout(
                        () => inputMensagemRef.current?.focus?.(),
                        40,
                      );
                    }}
                    onForward={
                      somenteVisualizacao || isSupervisao || envioDesabilitado
                        ? undefined
                        : abrirEncaminhamentoMensagem
                    }
                    onPin={
                      somenteVisualizacao || isSupervisao || envioDesabilitado
                        ? undefined
                        : abrirFixacaoMensagemWhatsapp
                    }
                  />
                </div>
              );
            })}

            {!ocultarPainelFollowUpLegado ? (
              <>
                <FollowUpStatusOperacionalPanel
                  conversa={conversaRegua}
                  mensagens={mensagens}
                />

                <FollowUpProcessPanel
                  conversa={conversaRegua}
                  mensagens={mensagens}
                  followUpRegras={followUpRegrasPainel}
                  registrandoLigacao={registrandoLigacaoFollowUp}
                  gerandoProximaEtapa={gerandoProximaEtapaFollowUp}
                  onUsarMensagemEtapa={abrirMensagemFollowUpEtapa}
                  onRegistrarLigacao={abrirModalRegistroLigacaoFollowUp}
                  onGerarProximaEtapa={gerarProximaEtapaFollowUp}
                />
              </>
            ) : null}

            <div ref={chatEndRef} />
          </div>
        )}
      </section>

      {mensagemEncaminhar ? (
        <EncaminharMensagemModalCaptaZap
          mensagem={mensagemEncaminhar}
          empresaId={empresaId}
          enviando={encaminhandoMensagem}
          onClose={() => {
            if (!encaminhandoMensagem) setMensagemEncaminhar(null);
          }}
          onConfirm={confirmarEncaminhamentoMensagem}
        />
      ) : null}

      {mensagemFixar ? (
        <FixarMensagemWhatsappModalCaptaZap
          mensagem={mensagemFixar}
          enviando={fixandoMensagemWhatsapp}
          onClose={() => {
            if (!fixandoMensagemWhatsapp) setMensagemFixar(null);
          }}
          onAction={executarFixacaoMensagemWhatsapp}
        />
      ) : null}

      {previewMensagem ? (
        <PreviewMensagemModal
          preview={previewMensagem}
          enviando={enviando}
          envioDesabilitado={envioDesabilitado}
          onClose={fecharPreviewMensagem}
          onVoltar={voltarPreviewMensagem}
          onInserirNoCampo={inserirPreviewNoCampo}
          onEnviar={enviarPreviewMensagem}
          onGravarAudio={handleAudio}
          gravandoAudio={gravandoAudio}
          audioGravacaoMs={audioGravacaoMs}
          audioPreview={audioPreview}
          enviandoMidia={enviandoMidia}
          onPararGravacao={() => mediaRecorderRef.current?.stop()}
          onCancelarAudio={handleCancelarAudioPreview}
          onEnviarAudio={() =>
            handleEnviarAudioPreview({ fecharPreview: true })
          }
        />
      ) : null}

      {modalLigacaoFollowUpAberto ? (
        <RegistroLigacaoFollowUpModal
          form={formLigacaoFollowUp}
          setForm={setFormLigacaoFollowUp}
          registrando={registrandoLigacaoFollowUp}
          erro={erroLigacaoFollowUp}
          conversa={conversa}
          onClose={() => {
            setErroLigacaoFollowUp("");
            setModalLigacaoFollowUpAberto(false);
          }}
          onSubmit={() => registrarLigacaoFollowUp(formLigacaoFollowUp)}
        />
      ) : null}

      <footer className="sticky bottom-0 z-40 max-h-[46dvh] shrink-0 overflow-y-auto border-t border-slate-300 bg-white px-3 py-2 shadow-[0_-10px_30px_rgba(15,23,42,0.08)]">
        {erroMidia ? (
          <div className="mx-auto mb-2 max-w-4xl rounded-2xl border border-red-200 bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-700">
            {erroMidia}
          </div>
        ) : null}

        {envioDesabilitado ? (
          <div className="mx-auto mb-2 max-w-4xl rounded-2xl border border-amber-200 bg-amber-50 px-3 py-1.5 text-xs font-semibold text-amber-800">
            Envio bloqueado neste chamado. Abra ou assuma um chamado ativo para
            responder.
          </div>
        ) : null}

        {!previewMensagem && gravandoAudio ? (
          <div className="mx-auto mb-3 max-w-4xl rounded-[24px] border border-red-200 bg-red-50 px-4 py-3 shadow-sm">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex min-w-0 items-center gap-3">
                <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-red-500 text-white shadow-sm">
                  <FaMicrophone size={16} />
                  <span className="absolute -right-1 -top-1 h-3 w-3 animate-ping rounded-full bg-red-400" />
                </span>
                <div className="min-w-0">
                  <div className="text-sm font-black text-red-800">
                    Gravando áudio...
                  </div>
                  <div className="mt-0.5 text-xs font-semibold text-red-600">
                    {formatDuracaoAudio(audioGravacaoMs)} · clique no botão
                    vermelho para parar e revisar antes de enviar.
                  </div>
                </div>
              </div>

              <button
                type="button"
                onClick={() => mediaRecorderRef.current?.stop()}
                className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-2xl bg-red-600 px-4 text-xs font-black text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-red-700"
              >
                <FaStop size={13} />
                Parar gravação
              </button>
            </div>
          </div>
        ) : null}

        {!previewMensagem && audioPreview ? (
          <div className="mx-auto mb-3 max-w-4xl rounded-[24px] border border-emerald-200 bg-emerald-50/90 px-4 py-3 shadow-sm">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
              <div className="min-w-0 flex-1">
                <div className="mb-2 flex items-center gap-2 text-xs font-black uppercase tracking-wide text-emerald-700">
                  <FaMicrophone size={13} />
                  Áudio gravado para revisão
                </div>
                <audio
                  src={audioPreview.url}
                  controls
                  className="w-full max-w-xl"
                />
                <div className="mt-1 text-[11px] font-semibold text-emerald-700/80">
                  Ouça antes de enviar. Se não gostou, cancele e grave
                  novamente.
                </div>
              </div>

              <div className="flex shrink-0 flex-wrap items-center gap-2">
                <button
                  type="button"
                  onClick={handleCancelarAudioPreview}
                  disabled={enviandoMidia}
                  className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-xs font-black text-slate-600 shadow-sm transition hover:-translate-y-0.5 hover:border-red-200 hover:bg-red-50 hover:text-red-600 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  <FaTimes size={13} />
                  Cancelar
                </button>

                <button
                  type="button"
                  onClick={handleEnviarAudioPreview}
                  disabled={enviandoMidia || envioDesabilitado}
                  className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl bg-[#25D366] px-4 text-xs font-black text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-[#1FB85A] disabled:cursor-not-allowed disabled:bg-slate-300"
                >
                  <FaPaperPlane size={13} />
                  {enviandoMidia ? "Enviando áudio..." : "Enviar áudio"}
                </button>
              </div>
            </div>
          </div>
        ) : null}

        {emojiAberto && (
          <div
            className="fixed inset-0 z-[95] flex items-center justify-center bg-slate-950/20 px-3 py-4 backdrop-blur-[1px]"
            onClick={() => setEmojiAberto(false)}
          >
            <div
              className="flex max-h-[calc(100vh-32px)] w-[min(520px,calc(100vw-24px))] flex-col overflow-hidden rounded-[24px] border border-slate-300 bg-white shadow-[0_24px_70px_rgba(15,23,42,0.26)]"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="sticky top-0 z-10 flex items-start justify-between gap-3 border-b border-slate-100 bg-white px-3 py-3">
                <div className="min-w-0">
                  <div className="text-xs font-black text-slate-700">
                    Emojis do CaptaZap
                  </div>
                  <div className="mt-0.5 text-[10px] font-semibold text-slate-400">
                    Clique em vários emojis. O painel só fecha no X.
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => setEmojiAberto(false)}
                  className="flex h-7 w-7 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-400 shadow-sm transition hover:border-red-200 hover:bg-red-50 hover:text-red-600"
                  title="Fechar emojis"
                >
                  <FaTimes size={12} />
                </button>
              </div>

              <div className="min-h-0 flex-1 overflow-y-auto p-3">
                {EMOJIS_RAPIDOS_GRUPOS.map((grupo) => (
                  <div key={grupo.titulo} className="mb-3 last:mb-0">
                    <div className="mb-1.5 flex items-center justify-between gap-2 px-1 text-[10px] font-black uppercase tracking-wide text-slate-400">
                      <span>{grupo.titulo}</span>
                      <span>{grupo.emojis.length}</span>
                    </div>

                    <div className="grid grid-cols-7 gap-2 sm:grid-cols-8">
                      {grupo.emojis.map((emoji, index) => (
                        <button
                          key={`${grupo.titulo}-${emoji}-${index}`}
                          type="button"
                          onClick={() => inserirEmoji(emoji)}
                          className="flex h-10 items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 text-lg transition hover:-translate-y-0.5 hover:border-blue-300 hover:bg-blue-50 hover:shadow-sm"
                          title={`Inserir ${emoji}`}
                        >
                          {emoji}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {figurinhasAberto && (
          <div
            className="fixed inset-0 z-[95] flex items-center justify-center bg-slate-950/20 px-3 py-4 backdrop-blur-[1px]"
            onClick={() => setFigurinhasAberto(false)}
          >
            <div
              className="flex max-h-[calc(100vh-32px)] w-[min(560px,calc(100vw-24px))] flex-col overflow-hidden rounded-[24px] border border-slate-300 bg-white shadow-[0_24px_70px_rgba(15,23,42,0.26)]"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="flex items-start justify-between gap-3 border-b border-slate-100 bg-white px-4 py-3">
                <div>
                  <div className="text-xs font-black text-slate-700">
                    🧩 Figurinhas da empresa
                  </div>
                  <div className="mt-0.5 text-[10px] font-semibold text-slate-400">
                    Para adicionar uma nova, clique em “Salvar na empresa” numa figurinha recebida.
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setFigurinhasAberto(false)}
                  className="flex h-7 w-7 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-400 shadow-sm transition hover:border-red-200 hover:bg-red-50 hover:text-red-600"
                  title="Fechar figurinhas"
                >
                  <FaTimes size={12} />
                </button>
              </div>

              <div className="min-h-0 flex-1 overflow-y-auto p-4">
                {carregandoFigurinhas ? (
                  <div className="py-10 text-center text-xs font-bold text-slate-400">
                    Carregando figurinhas...
                  </div>
                ) : erroFigurinhas ? (
                  <div className="rounded-2xl border border-red-200 bg-red-50 p-3 text-xs font-semibold text-red-700">
                    {erroFigurinhas}
                  </div>
                ) : figurinhasEmpresa.length === 0 ? (
                  <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4 text-center text-xs font-semibold leading-5 text-blue-700">
                    Ainda não há figurinhas salvas. Quando um paciente mandar uma figurinha, use o botão <strong>Salvar na empresa</strong>.
                  </div>
                ) : (
                  <div className="grid grid-cols-3 gap-3 sm:grid-cols-4">
                    {figurinhasEmpresa.map((figurinha) => {
                      const url = resolverMidiaUrlCaptaZap(figurinha?.url || "", API_BASE);
                      const enviandoEsta = enviandoFigurinha === figurinha?.arquivo;
                      return (
                        <button
                          key={figurinha?.arquivo || figurinha?.url}
                          type="button"
                          onClick={() => enviarFigurinhaEmpresa(figurinha)}
                          disabled={Boolean(enviandoFigurinha) || envioDesabilitado}
                          className="group flex min-h-[118px] flex-col items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 p-2 transition hover:-translate-y-0.5 hover:border-blue-300 hover:bg-blue-50 hover:shadow-sm disabled:cursor-not-allowed disabled:opacity-60"
                          title={figurinha?.nome || "Enviar figurinha"}
                        >
                          <img
                            src={url}
                            alt={figurinha?.nome || "Figurinha"}
                            loading="lazy"
                            className="h-20 w-20 object-contain"
                          />
                          <span className="mt-1 max-w-full truncate text-[10px] font-bold text-slate-500">
                            {enviandoEsta ? "Enviando..." : "Enviar"}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {respostasAberto && (
          <div
            className="fixed inset-0 z-[95] flex items-center justify-center bg-slate-950/20 px-3 py-4 backdrop-blur-[1px]"
            onClick={() => {
              setRespostasAberto(false);
              setTipoMensagemRapidaSelecionado("");
            }}
          >
            <div
              className="flex max-h-[calc(100vh-32px)] w-[min(520px,calc(100vw-24px))] flex-col overflow-hidden rounded-[24px] border border-slate-300 bg-white shadow-[0_24px_70px_rgba(15,23,42,0.26)]"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="sticky top-0 z-10 flex shrink-0 items-start justify-between gap-3 border-b border-slate-100 bg-white px-3 py-3">
                <div className="min-w-0">
                  <div className="text-xs font-bold text-slate-700">
                    Mensagens rápidas
                  </div>
                  <div className="text-[11px] text-slate-400">
                    {tipoMensagemRapidaSugerido
                      ? `Etapa sugerida: ${tipoMensagemRapidaSugerido}`
                      : "Selecione uma resposta para inserir no campo."}
                  </div>
                </div>

                <div className="flex shrink-0 items-center gap-2">
                  <FaCommentDots className="text-blue-500" size={16} />

                  <button
                    type="button"
                    onClick={() => {
                      setRespostasAberto(false);
                      setTipoMensagemRapidaSelecionado("");
                    }}
                    className="flex h-7 w-7 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-400 shadow-sm transition hover:border-red-200 hover:bg-red-50 hover:text-red-600"
                    title="Fechar mensagens rápidas"
                  >
                    <FaTimes size={12} />
                  </button>
                </div>
              </div>

              <div className="min-h-0 flex-1 overflow-y-auto p-3">
                {loadingMensagensRapidas ? (
                  <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3 text-xs font-semibold text-slate-500">
                    Carregando mensagens cadastradas...
                  </div>
                ) : erroMensagensRapidas ? (
                  <div className="rounded-2xl border border-red-200 bg-red-50 p-3 text-xs font-semibold text-red-700">
                    {erroMensagensRapidas}
                  </div>
                ) : mensagensRapidas.length === 0 ? (
                  <div className="rounded-2xl border border-amber-200 bg-amber-50 p-3 text-xs font-semibold leading-5 text-amber-800">
                    Nenhuma mensagem rápida cadastrada para esta empresa.
                    Cadastre em Mensagens rápidas para aparecer aqui.
                  </div>
                ) : (
                  <div className="space-y-3">
                    <label className="block">
                      <span className="mb-1.5 block text-[11px] font-black uppercase tracking-wide text-slate-500">
                        Tipo de mensagem
                      </span>
                      <select
                        value={tipoMensagemRapidaSelecionado}
                        onChange={(event) =>
                          setTipoMensagemRapidaSelecionado(event.target.value)
                        }
                        className="h-10 w-full rounded-2xl border border-slate-300 bg-white px-3 text-xs font-bold text-slate-700 outline-none transition focus:border-blue-400 focus:ring-4 focus:ring-blue-500/10"
                      >
                        <option value="">Selecione o tipo...</option>
                        {tiposMensagensRapidas.map((tipo) => (
                          <option key={tipo} value={tipo}>
                            {tipo}
                          </option>
                        ))}
                      </select>
                    </label>

                    {tipoMensagemRapidaSugerido ? (
                      <div className="rounded-2xl border border-violet-200 bg-violet-50 p-3 text-xs font-semibold leading-5 text-violet-700">
                        Cadência detectada na conversa: use mensagens do tipo{" "}
                        <strong>{tipoMensagemRapidaSugerido}</strong>.
                      </div>
                    ) : null}

                    {!tipoMensagemRapidaSelecionado ? (
                      <div className="rounded-2xl border border-blue-100 bg-blue-50 p-3 text-xs font-semibold leading-5 text-blue-700">
                        Escolha um tipo, por exemplo "Quebra de Objeção", para
                        listar somente as mensagens cadastradas nessa categoria.
                      </div>
                    ) : mensagensRapidasFiltradas.length === 0 ? (
                      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-3 text-xs font-semibold leading-5 text-amber-800">
                        Nenhuma mensagem cadastrada para este tipo.
                      </div>
                    ) : (
                      <div className="max-h-[320px] space-y-3 overflow-y-auto pr-1">
                        {mensagensRapidasFavoritas.length > 0 ? (
                          <section>
                            <div className="mb-1.5 flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wide text-amber-700">
                              <span>★</span>
                              Favoritas
                            </div>

                            <div className="space-y-2">
                              {mensagensRapidasFavoritas.map((resposta) => (
                                <MensagemRapidaOpcao
                                  key={
                                    resposta.id ||
                                    `${resposta.titulo}-${resposta.texto}`
                                  }
                                  resposta={resposta}
                                  favorita
                                  onClick={() =>
                                    abrirPreviewMensagemRapida(resposta)
                                  }
                                />
                              ))}
                            </div>
                          </section>
                        ) : null}

                        {mensagensRapidasComuns.length > 0 ? (
                          <section>
                            <div className="mb-1.5 text-[11px] font-black uppercase tracking-wide text-slate-500">
                              Outras mensagens
                            </div>

                            <div className="space-y-2">
                              {mensagensRapidasComuns.map((resposta) => (
                                <MensagemRapidaOpcao
                                  key={
                                    resposta.id ||
                                    `${resposta.titulo}-${resposta.texto}`
                                  }
                                  resposta={resposta}
                                  onClick={() =>
                                    abrirPreviewMensagemRapida(resposta)
                                  }
                                />
                              ))}
                            </div>
                          </section>
                        ) : null}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit} className="mx-auto max-w-4xl">
          {mensagemRespondendo ? (
            <div className="mb-2 flex items-start gap-2 rounded-2xl border border-blue-200 bg-blue-50 px-3 py-2 shadow-sm">
              <FaReply className="mt-1 shrink-0 text-blue-600" size={13} />
              <div className="min-w-0 flex-1">
                <div className="truncate text-[11px] font-black text-blue-800">
                  Respondendo a {mensagemRespondendo.autor || "esta mensagem"}
                </div>
                <div className="line-clamp-2 whitespace-pre-wrap break-words text-xs leading-4 text-slate-600">
                  {mensagemRespondendo.texto || "Mensagem"}
                </div>
              </div>
              <button
                type="button"
                onClick={() => setMensagemRespondendo(null)}
                className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-slate-400 transition hover:bg-white hover:text-red-600"
                title="Cancelar resposta"
              >
                <FaTimes size={12} />
              </button>
            </div>
          ) : null}

          <div className="flex items-end gap-2 rounded-[24px] border border-slate-300 bg-white p-2 shadow-sm transition focus-within:border-blue-400 focus-within:ring-4 focus-within:ring-blue-500/10">
            <ComposerAction
              title="Mensagens rápidas"
              active={respostasAberto}
              onClick={() => {
                const vaiAbrir = !respostasAberto;

                if (vaiAbrir && tipoMensagemRapidaSugerido) {
                  setTipoMensagemRapidaSelecionado(tipoMensagemRapidaSugerido);
                }

                setRespostasAberto(vaiAbrir);
                setEmojiAberto(false);
                setFigurinhasAberto(false);
              }}
            >
              <FaCommentDots size={16} />
            </ComposerAction>

            <ComposerAction
              title="Emojis"
              active={emojiAberto}
              onClick={() => {
                setEmojiAberto((atual) => !atual);
                setFigurinhasAberto(false);
                setRespostasAberto(false);
              }}
            >
              <FaRegSmile size={17} />
            </ComposerAction>

            <ComposerAction
              title="Figurinhas da empresa"
              active={figurinhasAberto}
              onClick={abrirFigurinhasEmpresa}
            >
              <span className="text-[17px] leading-none">🧩</span>
            </ComposerAction>

            <input
              ref={inputArquivoRef}
              type="file"
              className="hidden"
              accept="*/*"
              onChange={handleSelecionarArquivo}
            />

            <button
              type="button"
              disabled={midiaBloqueada || Boolean(audioPreview)}
              onClick={() => inputArquivoRef.current?.click()}
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-slate-300 bg-slate-50 text-slate-600 transition hover:border-blue-300 hover:bg-blue-50 hover:text-blue-800 disabled:cursor-not-allowed disabled:opacity-50"
              title="Anexar qualquer arquivo"
            >
              {enviandoMidia ? (
                <FaFileAlt size={15} />
              ) : (
                <FaPaperclip size={16} />
              )}
            </button>

            <textarea
              ref={inputMensagemRef}
              value={msg}
              maxLength={LIMITE_MENSAGEM}
              disabled={envioDesabilitado || enviandoMidia}
              onChange={(event) => setMsg(event.target.value)}
              onFocus={() => {
                setEmojiAberto(false);
                setFigurinhasAberto(false);
                setRespostasAberto(false);
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" && !event.shiftKey) {
                  event.preventDefault();
                  handleSubmit(event);
                }
              }}
              rows={1}
              className="max-h-32 min-h-10 flex-1 resize-none bg-transparent px-1 py-2 text-sm leading-6 text-slate-800 outline-none placeholder:text-slate-400"
              placeholder={
                envioDesabilitado
                  ? "Envio bloqueado neste chamado"
                  : enviandoMidia
                    ? "Enviando arquivo..."
                    : "Digite uma mensagem..."
              }
            />

            <button
              type="button"
              onClick={abrirPreviewMensagemDigitada}
              disabled={
                !msg.trim() || enviando || enviandoMidia || envioDesabilitado
              }
              className="hidden h-10 shrink-0 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-slate-50 px-3 text-xs font-black text-slate-500 shadow-sm transition hover:border-blue-300 hover:bg-blue-50 hover:text-blue-800 disabled:cursor-not-allowed disabled:opacity-50 md:inline-flex"
              title="Visualizar a mensagem completa antes de enviar"
            >
              <FaEye size={14} />
              Visualizar
            </button>

            <button
              type="button"
              onClick={handleAudio}
              disabled={
                Boolean(audioPreview) || (midiaBloqueada && !gravandoAudio)
              }
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border text-white shadow-sm transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-60 ${
                gravandoAudio
                  ? "border-red-500 bg-red-500 hover:bg-red-600 shadow-red-700/20"
                  : canalStyle.audioButton
              }`}
              title={
                audioPreview
                  ? "Envie ou cancele o áudio gravado antes de gravar outro"
                  : gravandoAudio
                    ? "Parar e revisar áudio"
                    : "Gravar áudio"
              }
            >
              {gravandoAudio ? (
                <FaStop size={14} />
              ) : (
                <FaMicrophone size={16} />
              )}
            </button>

            <button
              type="submit"
              disabled={bloqueado}
              className={`flex h-10 shrink-0 items-center justify-center gap-2 rounded-2xl px-4 text-sm font-bold text-white shadow-sm transition disabled:cursor-not-allowed disabled:bg-slate-300 disabled:shadow-none ${canalStyle.sendButton}`}
            >
              <span className="hidden sm:inline">
                {enviando ? "Enviando..." : "Enviar"}
              </span>
              <FaPaperPlane size={14} />
            </button>
          </div>

          <div className="mt-1 flex items-center justify-between px-2 text-[10px] font-medium text-slate-400">
            <span>
              Enter para enviar • Shift + Enter para quebrar linha • Visualizar
              para revisar textos longos
            </span>

            <span
              className={
                msg.length >= LIMITE_MENSAGEM
                  ? "font-bold text-red-500"
                  : undefined
              }
            >
              {msg.length}/{LIMITE_MENSAGEM}
            </span>
          </div>
        </form>
      </footer>
    </div>
  );
}

function getDataMensagemCaptaZap(mensagem = {}) {
  const raw =
    mensagem.datahora ||
    mensagem.created_at ||
    mensagem.timestamp ||
    mensagem.data ||
    mensagem.enviado_em ||
    "";

  const data = raw ? new Date(raw) : null;
  return data && !Number.isNaN(data.getTime()) ? data : null;
}

function getChaveDiaMensagemCaptaZap(mensagem = {}) {
  const data = getDataMensagemCaptaZap(mensagem);
  if (!data) return "";

  return [
    data.getFullYear(),
    String(data.getMonth() + 1).padStart(2, "0"),
    String(data.getDate()).padStart(2, "0"),
  ].join("-");
}

function deveMostrarSeparadorDataMensagemCaptaZap(anterior, atual) {
  if (!atual) return false;
  if (!anterior) return true;

  const diaAnterior = getChaveDiaMensagemCaptaZap(anterior);
  const diaAtual = getChaveDiaMensagemCaptaZap(atual);

  return Boolean(diaAtual && diaAtual !== diaAnterior);
}

function formatarDataSeparadorMensagemCaptaZap(mensagem = {}) {
  const data = getDataMensagemCaptaZap(mensagem);
  if (!data) return "Data não informada";

  const hoje = new Date();
  const ontem = new Date();
  ontem.setDate(hoje.getDate() - 1);

  const chave = getChaveDiaMensagemCaptaZap(mensagem);
  const chaveHoje = getChaveDiaMensagemCaptaZap({ datahora: hoje });
  const chaveOntem = getChaveDiaMensagemCaptaZap({ datahora: ontem });

  if (chave === chaveHoje) return "Hoje";
  if (chave === chaveOntem) return "Ontem";

  return data.toLocaleDateString("pt-BR", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

function DataMensagemSeparadorCaptaZap({ mensagem }) {
  return (
    <div className="relative z-0 my-2 flex justify-center">
      <span className="rounded-full border border-slate-300 bg-white/95 px-3 py-1 text-[11px] font-semibold text-slate-600 shadow-sm backdrop-blur">
        {formatarDataSeparadorMensagemCaptaZap(mensagem)}
      </span>
    </div>
  );
}


function getMessageIdWhatsappCaptaZap(mensagem = {}) {
  return String(
    mensagem?.msgid ||
      mensagem?.messageId ||
      mensagem?.message_id ||
      mensagem?.wa_media_id ||
      "",
  ).trim();
}

function formatarTamanhoArquivoCaptaZap(bytes = null) {
  const valor = Number(bytes || 0);
  if (!Number.isFinite(valor) || valor <= 0) return "";

  if (valor < 1024) return `${valor} B`;
  if (valor < 1024 * 1024) return `${(valor / 1024).toFixed(1)} KB`;
  if (valor < 1024 * 1024 * 1024) {
    return `${(valor / (1024 * 1024)).toFixed(1)} MB`;
  }

  return `${(valor / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}

function getNomeArquivoMensagemCaptaZap(mensagem = {}, mediaUrl = "") {
  const explicito = String(
    mensagem?.nome_arquivo ||
      mensagem?.nomeArquivo ||
      mensagem?.filename ||
      mensagem?.fileName ||
      mensagem?.document_name ||
      mensagem?.documentName ||
      "",
  ).trim();

  if (explicito) return explicito;

  const texto = String(
    mensagem?.texto ||
      mensagem?.mensagem ||
      mensagem?.message ||
      "",
  ).trim();

  if (
    texto &&
    texto.length <= 180 &&
    /\.[a-z0-9]{1,12}$/i.test(texto.split("?")[0])
  ) {
    return texto;
  }

  try {
    const pathname = new URL(
      mediaUrl,
      window.location.origin,
    ).pathname;
    const ultimo = decodeURIComponent(
      String(pathname || "").split("/").filter(Boolean).pop() || "",
    );

    if (ultimo && /\.[a-z0-9]{1,12}$/i.test(ultimo)) {
      return ultimo;
    }
  } catch {
    // ignora URL inválida
  }

  const mime = String(
    mensagem?.mime_type ||
      mensagem?.mimeType ||
      "",
  ).toLowerCase();

  const mimeExtMap = {
    "application/pdf": "pdf",
    "application/zip": "zip",
    "application/x-zip-compressed": "zip",
    "application/json": "json",
    "text/plain": "txt",
    "text/csv": "csv",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "docx",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      "xlsx",
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      "pptx",
  };

  const ext = mimeExtMap[mime] || "";
  return ext ? `arquivo.${ext}` : "Arquivo";
}

function BotaoEncaminharMensagemCaptaZap({
  mensagem,
  onForward,
}) {
  const messageId = getMessageIdWhatsappCaptaZap(mensagem);

  if (!messageId || typeof onForward !== "function") return null;

  return (
    <button
      type="button"
      onClick={() => onForward(mensagem)}
      className={[
        "inline-flex h-6 items-center gap-1 rounded-full border border-slate-300",
        "bg-white/90 px-2 text-[9.5px] font-black text-slate-500 shadow-sm transition",
        "hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700",
        "opacity-60 md:opacity-0 md:group-hover:opacity-100",
      ].join(" ")}
      title="Encaminhar mensagem"
      aria-label="Encaminhar mensagem"
    >
      <FaReply size={9} className="rotate-180" />
      Encaminhar
    </button>
  );
}


function BotaoFixarMensagemCaptaZap({ mensagem, onPin }) {
  const messageId = getMessageIdWhatsappCaptaZap(mensagem);
  if (!messageId || typeof onPin !== "function") return null;

  return (
    <button
      type="button"
      onClick={() => onPin(mensagem)}
      className={[
        "inline-flex h-6 items-center gap-1 rounded-full border border-amber-300",
        "bg-amber-50/95 px-2 text-[9.5px] font-black text-amber-700 shadow-sm transition",
        "hover:border-amber-400 hover:bg-amber-100 hover:text-amber-800",
        "opacity-70 md:opacity-0 md:group-hover:opacity-100",
      ].join(" ")}
      title="Fixar esta mensagem no WhatsApp"
      aria-label="Fixar mensagem no WhatsApp"
    >
      <FaThumbtack size={9} />
      Fixar
    </button>
  );
}

function AcoesMensagemCaptaZap({
  mensagem,
  enviada = false,
  onForward,
  onPin,
}) {
  const messageId = getMessageIdWhatsappCaptaZap(mensagem);
  const temPin = Boolean(messageId && typeof onPin === "function");
  const temForward = Boolean(messageId && typeof onForward === "function");

  if (!temPin && !temForward) return null;

  return (
    <div
      className={`mt-0.5 flex items-center gap-1 ${enviada ? "self-end" : "self-start"}`}
    >
      <BotaoFixarMensagemCaptaZap mensagem={mensagem} onPin={onPin} />
      <BotaoEncaminharMensagemCaptaZap
        mensagem={mensagem}
        onForward={onForward}
      />
    </div>
  );
}

function FixarMensagemWhatsappModalCaptaZap({
  mensagem,
  enviando = false,
  onClose,
  onAction,
}) {
  const resumo = String(
    mensagem?.texto || mensagem?.mensagem || mensagem?.message || "Mensagem selecionada",
  )
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 150);

  const opcoes = [
    { value: "24_hours", label: "24 horas" },
    { value: "7_days", label: "7 dias" },
    { value: "30_days", label: "30 dias" },
  ];

  return (
    <div className="absolute inset-0 z-[90] flex items-center justify-center bg-slate-950/35 p-4 backdrop-blur-[1px]">
      <div className="w-full max-w-[420px] overflow-hidden rounded-[24px] border border-amber-200 bg-white shadow-[0_24px_80px_rgba(15,23,42,0.25)]">
        <div className="flex items-start justify-between gap-3 border-b border-slate-200 px-4 py-3">
          <div className="min-w-0">
            <div className="flex items-center gap-2 text-sm font-black text-slate-900">
              <span className="grid h-8 w-8 place-items-center rounded-xl bg-amber-100 text-amber-700">
                <FaThumbtack size={13} />
              </span>
              Fixar mensagem no WhatsApp
            </div>
            <p className="mt-1 text-[11px] font-semibold leading-4 text-slate-500">
              O destaque aparecerá dentro da conversa do WhatsApp pelo período escolhido.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            disabled={enviando}
            className="grid h-8 w-8 shrink-0 place-items-center rounded-xl border border-slate-200 bg-white text-slate-500 transition hover:bg-slate-50 disabled:opacity-50"
            aria-label="Fechar"
          >
            <FaTimes size={12} />
          </button>
        </div>

        <div className="p-4">
          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-3 py-2 text-[11px] font-semibold leading-5 text-slate-600">
            {resumo || "Mensagem selecionada"}
          </div>

          <div className="mt-3 grid grid-cols-3 gap-2">
            {opcoes.map((opcao) => (
              <button
                key={opcao.value}
                type="button"
                disabled={enviando}
                onClick={() =>
                  onAction?.({ action: "pin", duration: opcao.value })
                }
                className="h-10 rounded-xl border border-amber-300 bg-amber-50 px-2 text-[11px] font-black text-amber-800 transition hover:border-amber-400 hover:bg-amber-100 disabled:cursor-wait disabled:opacity-50"
              >
                {opcao.label}
              </button>
            ))}
          </div>

          <button
            type="button"
            disabled={enviando}
            onClick={() => onAction?.({ action: "unpin", duration: "7_days" })}
            className="mt-3 flex h-10 w-full items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white text-[11px] font-black text-slate-600 transition hover:border-slate-400 hover:bg-slate-50 hover:text-slate-800 disabled:cursor-wait disabled:opacity-50"
          >
            <FaThumbtack size={10} />
            Desafixar esta mensagem
          </button>

          {enviando ? (
            <div className="mt-3 text-center text-[10px] font-bold text-slate-500">
              Atualizando no WhatsApp...
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

function EncaminharMensagemModalCaptaZap({
  mensagem,
  empresaId,
  enviando = false,
  onClose,
  onConfirm,
}) {
  const [destinatarios, setDestinatarios] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");
  const [busca, setBusca] = useState("");
  const [selecionados, setSelecionados] = useState([]);
  const [telefoneManual, setTelefoneManual] = useState("");

  useEffect(() => {
    let cancelado = false;

    async function carregar() {
      if (!empresaId) {
        setCarregando(false);
        return;
      }

      try {
        setCarregando(true);
        setErro("");

        const data = await requestJson(
          `/whatsapp/captazap/encaminhamento-destinatarios?empresa_id=${encodeURIComponent(
            empresaId,
          )}&limit=1600`,
        );

        if (cancelado) return;

        const lista =
          data?.destinatarios ||
          data?.contatos ||
          data?.dados ||
          [];

        setDestinatarios(Array.isArray(lista) ? lista : []);
      } catch (error) {
        if (cancelado) return;

        console.error(
          "CaptaZap | erro ao carregar destinatários de encaminhamento:",
          error,
        );

        setErro(
          error?.message ||
            "Não foi possível carregar os contatos. Você ainda pode digitar o telefone manualmente.",
        );
        setDestinatarios([]);
      } finally {
        if (!cancelado) setCarregando(false);
      }
    }

    carregar();

    return () => {
      cancelado = true;
    };
  }, [empresaId]);

  const selecionadosSet = useMemo(
    () =>
      new Set(
        selecionados
          .map((item) => normalizarTelefoneCaptaZap(item?.telefone || ""))
          .filter(Boolean),
      ),
    [selecionados],
  );

  const filtrados = useMemo(() => {
    const termo = String(busca || "")
      .trim()
      .toLocaleLowerCase("pt-BR");

    const digitos = normalizarTelefoneCaptaZap(busca);

    return (destinatarios || [])
      .filter((item) => {
        if (!termo && !digitos) return true;

        const nome = String(item?.nome || "")
          .toLocaleLowerCase("pt-BR");
        const telefone = normalizarTelefoneCaptaZap(
          item?.telefone ||
            item?.telefone_normalizado ||
            item?.numero ||
            "",
        );

        return (
          (termo && nome.includes(termo)) ||
          (digitos && telefone.includes(digitos))
        );
      })
      .slice(0, 250);
  }, [destinatarios, busca]);

  const alternarDestinatario = (item) => {
    const telefone = normalizarTelefoneCaptaZap(
      item?.telefone ||
        item?.telefone_normalizado ||
        item?.numero ||
        "",
    );

    if (!telefone) return;

    setSelecionados((atual) => {
      const existe = atual.some(
        (selecionado) =>
          normalizarTelefoneCaptaZap(selecionado?.telefone || "") === telefone,
      );

      if (existe) {
        return atual.filter(
          (selecionado) =>
            normalizarTelefoneCaptaZap(selecionado?.telefone || "") !==
            telefone,
        );
      }

      if (atual.length >= 20) {
        window.alert(
          "Selecione no máximo 20 contatos por encaminhamento.",
        );
        return atual;
      }

      return [
        ...atual,
        {
          telefone,
          nome:
            item?.nome ||
            item?.nome_lead ||
            item?.nome_whatsapp ||
            telefone,
        },
      ];
    });
  };

  const adicionarTelefoneManual = () => {
    const telefone = normalizarTelefoneCaptaZap(telefoneManual);

    if (telefone.length < 10) {
      window.alert("Digite um telefone válido com DDD.");
      return;
    }

    const jaExiste = selecionadosSet.has(telefone);

    if (jaExiste) {
      setTelefoneManual("");
      return;
    }

    if (selecionados.length >= 20) {
      window.alert(
        "Selecione no máximo 20 contatos por encaminhamento.",
      );
      return;
    }

    setSelecionados((atual) => [
      ...atual,
      {
        telefone,
        nome: telefone,
      },
    ]);

    setTelefoneManual("");
  };

  const tipoMidia = getTipoMidiaMensagemCaptaZap(mensagem);
  const mediaUrl = getMidiaUrlMensagemCaptaZap(mensagem);
  const textoPreview = String(
    mensagem?.texto ||
      mensagem?.mensagem ||
      mensagem?.message ||
      "",
  ).trim();

  return (
    <div
      className="fixed inset-0 z-[10020] flex items-center justify-center bg-slate-950/55 p-3 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-label="Encaminhar mensagem"
    >
      <div
        className="flex max-h-[88vh] w-full max-w-xl flex-col overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_30px_100px_rgba(15,23,42,0.35)]"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 border-b border-slate-200 bg-slate-50 px-4 py-3">
          <div className="min-w-0">
            <div className="text-base font-black text-slate-900">
              Encaminhar mensagem
            </div>
            <div className="mt-0.5 text-xs font-semibold text-slate-500">
              Escolha até 20 contatos da empresa. A janela permanece aberta até você fechar ou encaminhar.
            </div>
          </div>

          <button
            type="button"
            onClick={() => onClose?.()}
            disabled={enviando}
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-500 transition hover:border-red-200 hover:bg-red-50 hover:text-red-600 disabled:cursor-not-allowed disabled:opacity-50"
            title="Fechar"
          >
            <FaTimes size={12} />
          </button>
        </div>

        <div className="border-b border-slate-200 bg-white px-4 py-3">
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3">
            <div className="mb-1 flex items-center gap-2 text-[10px] font-black uppercase tracking-wide text-slate-400">
              {tipoMidia ? <FaFileAlt size={11} /> : <FaCommentDots size={11} />}
              Mensagem selecionada
            </div>

            <div className="line-clamp-3 whitespace-pre-wrap break-words text-sm font-semibold leading-5 text-slate-700">
              {tipoMidia === "documento"
                ? getNomeArquivoMensagemCaptaZap(mensagem, mediaUrl)
                : textoPreview ||
                  (tipoMidia === "imagem"
                    ? "Imagem"
                    : tipoMidia === "video"
                      ? "Vídeo"
                      : tipoMidia === "audio"
                        ? "Mensagem de áudio"
                        : "Mensagem")}
            </div>
          </div>
        </div>

        <div className="space-y-3 border-b border-slate-200 px-4 py-3">
          <input
            value={busca}
            onChange={(event) => setBusca(event.target.value)}
            placeholder="Buscar por nome ou telefone..."
            className="h-10 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm font-semibold text-slate-700 outline-none transition focus:border-blue-400 focus:ring-4 focus:ring-blue-500/10"
          />

          <div className="flex gap-2">
            <input
              value={telefoneManual}
              onChange={(event) => setTelefoneManual(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  adicionarTelefoneManual();
                }
              }}
              inputMode="tel"
              placeholder="Ou digite DDD + telefone"
              className="h-9 min-w-0 flex-1 rounded-xl border border-slate-300 bg-white px-3 text-xs font-semibold text-slate-700 outline-none transition focus:border-blue-400 focus:ring-4 focus:ring-blue-500/10"
            />

            <button
              type="button"
              onClick={adicionarTelefoneManual}
              className="h-9 shrink-0 rounded-xl border border-blue-200 bg-blue-50 px-3 text-xs font-black text-blue-700 transition hover:bg-blue-100"
            >
              Adicionar
            </button>
          </div>

          {selecionados.length > 0 ? (
            <div className="flex flex-wrap gap-1.5">
              {selecionados.map((item) => (
                <button
                  key={normalizarTelefoneCaptaZap(item.telefone)}
                  type="button"
                  onClick={() => alternarDestinatario(item)}
                  className="inline-flex max-w-full items-center gap-1 rounded-full border border-blue-200 bg-blue-50 px-2 py-1 text-[10px] font-black text-blue-700"
                  title="Remover destinatário"
                >
                  <span className="max-w-[180px] truncate">
                    {item.nome || item.telefone}
                  </span>
                  <FaTimes size={8} />
                </button>
              ))}
            </div>
          ) : null}
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto p-3">
          {carregando ? (
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 text-center text-xs font-semibold text-slate-500">
              Carregando contatos...
            </div>
          ) : erro && filtrados.length === 0 ? (
            <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 text-xs font-semibold leading-5 text-amber-800">
              {erro}
            </div>
          ) : filtrados.length === 0 ? (
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 text-center text-xs font-semibold text-slate-500">
              Nenhum contato encontrado.
            </div>
          ) : (
            <div className="space-y-1.5">
              {filtrados.map((item) => {
                const telefone = normalizarTelefoneCaptaZap(
                  item?.telefone ||
                    item?.telefone_normalizado ||
                    item?.numero ||
                    "",
                );

                const marcado = selecionadosSet.has(telefone);

                return (
                  <button
                    key={`${telefone}-${item?.lead_id || "sem-lead"}`}
                    type="button"
                    onClick={() => alternarDestinatario(item)}
                    className={`flex w-full items-center gap-3 rounded-2xl border px-3 py-2.5 text-left transition ${
                      marcado
                        ? "border-blue-300 bg-blue-50"
                        : "border-slate-200 bg-white hover:border-blue-200 hover:bg-slate-50"
                    }`}
                  >
                    <span
                      className={`grid h-8 w-8 shrink-0 place-items-center rounded-full text-xs font-black ${
                        marcado
                          ? "bg-blue-600 text-white"
                          : "bg-slate-100 text-slate-600"
                      }`}
                    >
                      {marcado ? "✓" : <FaUserCircle size={16} />}
                    </span>

                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-xs font-black text-slate-800">
                        {item?.nome || telefone}
                      </span>
                      <span className="mt-0.5 block text-[10px] font-semibold text-slate-400">
                        {telefone}
                      </span>
                    </span>
                  </button>
                );
              })}
            </div>
          )}
        </div>

        <div className="flex items-center justify-between gap-3 border-t border-slate-200 bg-slate-50 px-4 py-3">
          <div className="flex items-center gap-2 text-xs font-black text-slate-500">
            <FaUsers size={13} />
            {selecionados.length} selecionado(s)
          </div>

          <button
            type="button"
            onClick={() => onConfirm?.(selecionados)}
            disabled={enviando || selecionados.length === 0}
            className="inline-flex h-10 items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 text-xs font-black text-white shadow-sm transition hover:bg-[#1FB85A] disabled:cursor-not-allowed disabled:bg-slate-300"
          >
            <FaPaperPlane size={12} />
            {enviando
              ? "Encaminhando..."
              : selecionados.length === 1
                ? "Encaminhar"
                : `Encaminhar para ${selecionados.length}`}
          </button>
        </div>
      </div>
    </div>
  );
}

function MensagemComMidiaCaptaZap({
  mensagem,
  contato,
  empresaId,
  usuarios = [],
  viewerUserId = null,
  ownerUserId = null,
  ownerUserName = "",
  modoVisualizacao = "",
  onReply,
  onForward,
  onPin,
}) {
  const msg = normalizarMensagemMidiaCaptaZap(mensagem, {
    apiBase: API_BASE,
    empresaId,
    conversa: contato,
  });

  if (isMensagemRecuperadoDraMaluCaptaZap(msg)) {
    return <MensagemInternaRecuperadoDraMaluCaptaZap mensagem={msg} />;
  }

  const eventoOperacional = getEventoOperacionalSistemaCaptaZap(msg);
  if (eventoOperacional) {
    return (
      <EventoOperacionalTimelineCaptaZap
        evento={eventoOperacional}
        mensagem={msg}
      />
    );
  }

  const mediaUrl = getMidiaUrlMensagemCaptaZap(msg);
  const tipoMidia = getTipoMidiaMensagemCaptaZap(msg);
  const hasMidia = Boolean(mediaUrl && tipoMidia);
  const linksTexto = extrairLinksTextoMensagemCaptaZap(
    msg.texto || msg.mensagem || msg.message || "",
  );

  const autorUsuarioId =
    msg.usuario_id ||
    msg.usuarioId ||
    msg.operador_id ||
    msg.operadorId ||
    msg.atendente_id ||
    msg.atendenteId ||
    null;

  const autorUsuarioNome = String(
    msg.usuario_nome ||
      msg.usuarioNome ||
      msg.operador_nome ||
      msg.operadorNome ||
      msg.atendente_nome ||
      msg.atendenteNome ||
      "",
  ).trim();

  // A identidade visual pertence ao autor da mensagem, não ao responsável
  // atual do chamado nem ao usuário que abriu a conversa para visualização.
  const listaUsuarios = Array.isArray(usuarios) ? usuarios : [];
  const localizarUsuario = ({ usuarioId = null, usuarioNome = "" } = {}) => {
    const idBuscado = usuarioId;
    const nomeBuscado = String(usuarioNome || "").trim();

    return listaUsuarios.find((usuario) => {
      const idUsuario = usuario?.id || usuario?.usuario_id || usuario?.user_id;
      if (idBuscado && idUsuario) {
        return String(idUsuario) === String(idBuscado);
      }

      if (!nomeBuscado) return false;
      const nome = String(
        usuario?.nome || usuario?.name || usuario?.nome_usuario || "",
      )
        .trim()
        .toLocaleLowerCase("pt-BR");

      return nome === nomeBuscado.toLocaleLowerCase("pt-BR");
    });
  };

  const operadorAutor = localizarUsuario({
    usuarioId: autorUsuarioId,
    usuarioNome: autorUsuarioNome,
  });

  // No legado sem autoria persistida, o nome já aparece como referência do
  // responsável pelo atendimento. Usa o mesmo responsável apenas para
  // recuperar o avatar, sem atribuí-lo como autor da mensagem.
  const operadorResponsavelReferencia =
    !autorUsuarioId && !autorUsuarioNome
      ? localizarUsuario({
          usuarioId: ownerUserId,
          usuarioNome: ownerUserName,
        })
      : null;

  const operadorMensagem =
    operadorAutor || operadorResponsavelReferencia || null;

  const messageBubbleProps = {
    mensagem: msg,
    contato,
    empresaId,
    onReply,
    operador: operadorMensagem,
    modoVisualizacao,
    viewerUserId,
    ownerUserId,
    ownerUserName,
  };

  const enviada = isMensagemEnviadaOperadorCaptaZap(msg);

  if (!hasMidia && linksTexto.length === 0) {
    return (
      <div
        className={`group flex w-full flex-col ${
          enviada ? "items-end" : "items-start"
        }`}
      >
        <div className="w-full">
          <MessageBubble {...messageBubbleProps} />
        </div>

        <AcoesMensagemCaptaZap
          mensagem={msg}
          enviada={enviada}
          onPin={onPin}
          onForward={tipoMidia === "sticker" ? undefined : onForward}
        />
      </div>
    );
  }

  return (
    <div
      className={`group flex w-full flex-col ${enviada ? "items-end" : "items-start"}`}
    >
      <div className="w-full">
        <MessageBubble {...messageBubbleProps} />
      </div>

      {hasMidia && tipoMidia !== "sticker" ? (
        <div
          className={`mt-1 max-w-[320px] overflow-hidden rounded-2xl border bg-white shadow-sm ${
            enviada
              ? "border-emerald-200 self-end"
              : "border-slate-200 self-start"
          }`}
        >
          {tipoMidia === "imagem" ? (
            <a
              href={mediaUrl}
              target="_blank"
              rel="noreferrer"
              className="block"
              title="Abrir imagem"
            >
              <img
                src={mediaUrl}
                alt={msg.texto || msg.mensagem || "Imagem recebida"}
                loading="lazy"
                className="max-h-[360px] w-full object-contain"
                onError={(event) => {
                  event.currentTarget.style.display = "none";
                }}
              />
            </a>
          ) : tipoMidia === "video" ? (
            <video
              src={mediaUrl}
              controls
              preload="metadata"
              className="w-full"
            />
          ) : tipoMidia === "audio" ? (
            <div className="p-3">
              <audio
                src={mediaUrl}
                controls
                preload="metadata"
                className="w-full"
              />
            </div>
          ) : (
            <div className="flex items-center gap-3 p-3">
              <FaFileAlt className="shrink-0 text-blue-700" />

              <div className="min-w-0 flex-1">
                <div
                  className="truncate text-sm font-black text-slate-800"
                  title={getNomeArquivoMensagemCaptaZap(msg, mediaUrl)}
                >
                  {getNomeArquivoMensagemCaptaZap(msg, mediaUrl)}
                </div>

                <div className="mt-0.5 text-[10px] font-semibold text-slate-400">
                  {msg.mime_type || msg.mimeType || "Arquivo"}
                  {formatarTamanhoArquivoCaptaZap(
                    msg.tamanho_bytes || msg.tamanhoBytes,
                  )
                    ? ` • ${formatarTamanhoArquivoCaptaZap(
                        msg.tamanho_bytes || msg.tamanhoBytes,
                      )}`
                    : ""}
                </div>
              </div>

              <div className="flex shrink-0 items-center gap-1">
                <a
                  href={mediaUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-lg border border-blue-200 bg-blue-50 px-2 py-1 text-[10px] font-black text-blue-700 transition hover:bg-blue-100"
                  title="Abrir arquivo"
                >
                  Abrir
                </a>

                <a
                  href={mediaUrl}
                  download={getNomeArquivoMensagemCaptaZap(msg, mediaUrl)}
                  className="rounded-lg border border-slate-200 bg-white px-2 py-1 text-[10px] font-black text-slate-600 transition hover:bg-slate-50"
                  title="Baixar arquivo"
                >
                  Baixar
                </a>
              </div>
            </div>
          )}
        </div>
      ) : null}

      {linksTexto.length > 0 ? (
        <div
          className={`mt-1 flex max-w-[320px] flex-col gap-1 rounded-2xl border border-blue-100 bg-blue-50/80 p-2 text-xs font-semibold text-blue-700 ${
            enviada ? "self-end" : "self-start"
          }`}
        >
          {linksTexto.map((link) => (
            <a
              key={link}
              href={link}
              target="_blank"
              rel="noreferrer"
              className="truncate underline decoration-blue-300 underline-offset-2 hover:text-blue-900"
              title={link}
            >
              {link}
            </a>
          ))}
        </div>
      ) : null}

      <AcoesMensagemCaptaZap
        mensagem={msg}
        enviada={enviada}
        onPin={onPin}
        onForward={tipoMidia === "sticker" ? undefined : onForward}
      />
    </div>
  );
}

function getEstadoDraMaluEmRecuperacaoCaptaZap(conversa = {}) {
  if (!conversa || typeof conversa !== "object") return null;

  const flag = Boolean(
    conversa._dra_malu_em_recuperacao === true ||
      conversa._dra_malu_em_recuperacao === 1 ||
      String(conversa._dra_malu_em_recuperacao || "").toLowerCase() === "true" ||
      conversa.dra_malu_em_recuperacao === true ||
      conversa.dra_malu_em_recuperacao === 1 ||
      String(conversa.dra_malu_em_recuperacao || "").toLowerCase() === "true" ||
      conversa._dra_malu_virtual_followup === true ||
      conversa._dra_malu_virtual_followup === 1,
  );

  const status = normalizarTipoMensagemRapida(
    conversa.dra_malu_status || conversa.status_dra_malu || "",
  )
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  const statusAtivo = [
    "aguardando inicio",
    "aguardando envio",
    "enviando",
    "erro envio",
    "em andamento",
    "aguardando etapa",
    "evento enviado",
    "aguardando resposta",
    "coletando dados",
  ].includes(status);

  if (!flag && !statusAtivo) return null;

  return {
    ativo: true,
    atendimentoId: conversa.dra_malu_atendimento_id || null,
    etapa: Math.max(
      0,
      Number(
        conversa.dra_malu_etapa ||
          conversa._follow_up_etapa ||
          conversa._follow_up_ordem ||
          0,
      ),
    ),
    totalEtapas: Math.max(
      0,
      Number(
        conversa.dra_malu_total_etapas ||
          conversa._follow_up_total ||
          conversa._followup_total_regua ||
          0,
      ),
    ),
    titulo:
      conversa.dra_malu_etapa_titulo ||
      conversa._follow_up_titulo ||
      "Recuperação automática",
    entrouEm:
      conversa.dra_malu_entrou_em ||
      conversa._follow_up_criado_em ||
      conversa.criado_em ||
      null,
    captadorOrigem: getPrimeiroValorTexto([
      conversa.dra_malu_captador_origem_nome,
      conversa.captador_origem_nome,
      conversa.responsavel_nome,
      conversa.captador_nome,
      conversa.usuario_responsavel_nome,
    ]),
  };
}

function AlertaDraMaluEmRecuperacaoCaptaZap({ estado = {} }) {
  const etapa = Number(estado.etapa || 0);
  const total = Number(estado.totalEtapas || 0);
  const etapaTexto = etapa
    ? `Etapa ${etapa}${total ? ` de ${total}` : ""}`
    : "Preparando primeira etapa";

  const entrouEm = estado.entrouEm
    ? new Date(estado.entrouEm)
    : null;
  const horario =
    entrouEm && !Number.isNaN(entrouEm.getTime())
      ? entrouEm.toLocaleString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "";

  return (
    <div className="relative z-30 shrink-0 border-b-2 border-violet-500 bg-gradient-to-r from-violet-100 via-white to-indigo-100 px-4 py-3 shadow-[0_8px_24px_rgba(109,40,217,0.14)]">
      <div className="mx-auto flex max-w-5xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-violet-100 shadow-sm ring-2 ring-white">
            <img
              src={DRA_MALU_AVATAR_URL}
              alt="Dra. Malu IA"
              className="h-full w-full object-cover object-center"
            />
          </span>
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-xs font-black uppercase tracking-[0.12em] text-violet-950">
                Dra. Malu · Em recuperação
              </span>
              <span className="rounded-full border border-violet-300 bg-white px-2 py-0.5 text-[9px] font-black uppercase tracking-wide text-violet-800">
                IA trabalhando
              </span>
            </div>
            <div className="mt-1 text-sm font-black text-violet-950">
              {etapaTexto} · {estado.titulo || "Recuperação automática"}
            </div>
            <div className="mt-0.5 text-[11px] font-semibold text-violet-800">
              A Dra. Malu está conduzindo este contato. Quando o paciente responder,
              a automação para e o chamado é encaminhado para a Fila.
            </div>
          </div>
        </div>

        <div className="shrink-0 rounded-xl border border-violet-200 bg-white/90 px-3 py-2 text-right shadow-sm">
          <div className="text-[9px] font-black uppercase tracking-wide text-violet-600">
            Responsável agora
          </div>
          <div className="mt-0.5 text-xs font-black text-violet-950">
            Dra. Malu IA
          </div>
          {estado.captadorOrigem ? (
            <div className="mt-0.5 max-w-[240px] truncate text-[10px] font-semibold text-slate-500">
              Origem: {estado.captadorOrigem}
            </div>
          ) : null}
          {horario ? (
            <div className="mt-0.5 text-[9px] font-semibold text-slate-400">
              Na régua desde {horario}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

function getAlertaRecuperacaoPendenteDraMaluCaptaZap(
  conversa = {},
  mensagens = [],
) {
  const lista = Array.isArray(mensagens) ? mensagens.filter(Boolean) : [];
  const marcadores = lista
    .filter((mensagem) => isMensagemRecuperadoDraMaluCaptaZap(mensagem))
    .map((mensagem) => ({
      mensagem,
      timestamp: parseDataFollowUpChat(
        mensagem.datahora ||
          mensagem.created_at ||
          mensagem.updated_at ||
          mensagem.timestamp,
      ),
    }))
    .sort((a, b) => b.timestamp - a.timestamp);

  const marcador = marcadores[0] || null;
  const conversaMarcada = isMensagemRecuperadoDraMaluCaptaZap(conversa);

  if (!marcador && !conversaMarcada) return null;

  const recuperadoEm =
    marcador?.timestamp ||
    parseDataFollowUpChat(
      conversa.recuperado_em ||
        conversa.recuperadoEm ||
        conversa.dra_malu_recuperado_em ||
        conversa.atualizado_em ||
        conversa.updated_at,
    );

  const operadorRespondeuDepois = Boolean(
    recuperadoEm &&
    lista.some((mensagem) => {
      if (isMensagemRecuperadoDraMaluCaptaZap(mensagem)) return false;
      if (!isMensagemOperadorFollowUpChat(mensagem)) return false;
      const timestamp = parseDataFollowUpChat(
        mensagem.datahora ||
          mensagem.created_at ||
          mensagem.updated_at ||
          mensagem.timestamp,
      );
      return timestamp > recuperadoEm;
    }),
  );

  if (operadorRespondeuDepois) return null;

  const captador = getPrimeiroValorTexto([
    conversa.dra_malu_captador_origem_nome,
    conversa.captador_origem_nome,
    conversa.responsavel_nome,
    conversa.responsavelNome,
    conversa.captador_nome,
    conversa.captadorNome,
    conversa.usuario_responsavel_nome,
    conversa.lead_captador_nome,
    conversa.crm_captador_nome,
    conversa.lead?.captador_nome,
    conversa.lead?.responsavel_nome,
  ]);

  const semResponsavelAtual = !Number(
    conversa.responsavel_id || conversa.captador_id || 0,
  );
  const emFila = Boolean(
    semResponsavelAtual ||
      String(conversa.aba_captazap || "").toLowerCase() === "fila" ||
      conversa.em_fila === true,
  );

  return {
    ativo: true,
    emFila,
    captador: captador || "captador de origem",
    recuperadoEm,
    chamadoId:
      conversa.chamado_id ||
      conversa.id_chamado ||
      conversa.chamada_id ||
      conversa.id ||
      null,
  };
}

function AlertaResponsabilidadeDraMaluCaptaZap({ alerta = {} }) {
  const horario = alerta.recuperadoEm
    ? new Date(alerta.recuperadoEm).toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

  return (
    <div className="relative z-30 shrink-0 border-b-2 border-amber-400 bg-gradient-to-r from-amber-100 via-yellow-50 to-amber-100 px-4 py-3 shadow-[0_8px_24px_rgba(180,83,9,0.16)]">
      <div className="mx-auto flex max-w-5xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-amber-400 text-lg shadow-sm ring-2 ring-white">
            ✅
          </span>
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-xs font-black uppercase tracking-[0.12em] text-amber-950">
                Contato recuperado pela Dra. Malu
              </span>
              <span className="rounded-full border border-amber-400 bg-white px-2 py-0.5 text-[9px] font-black uppercase tracking-wide text-amber-900">
                {alerta.emFila ? "Na Fila" : "Ação necessária"}
              </span>
            </div>
            <div className="mt-1 text-sm font-black text-amber-950">
              {alerta.emFila
                ? "Paciente respondeu · aguardando alguém assumir na Fila"
                : "Paciente respondeu · atendimento humano necessário"}
            </div>
            <div className="mt-0.5 text-[11px] font-semibold text-amber-800">
              A Dra. Malu encerrou a automação deste contato.
              {horario ? ` Recuperado às ${horario}.` : ""}
            </div>
          </div>
        </div>

        <div className="shrink-0 rounded-xl border border-amber-300 bg-white/80 px-3 py-2 text-right shadow-sm">
          <div className="text-[9px] font-black uppercase tracking-wide text-amber-700">
            Captador de origem
          </div>
          <div
            className="mt-0.5 max-w-[240px] truncate text-xs font-black text-amber-950"
            title={alerta.captador}
          >
            👤 {alerta.captador}
          </div>
        </div>
      </div>
    </div>
  );
}

function EventoOperacionalTimelineCaptaZap({
  evento = {},
  mensagem = {},
}) {
  const hora =
    evento.hora || formatarHoraMensagemInternaDraMaluCaptaZap(mensagem);
  const dataCurta = formatarDataCurtaEventoOperacionalCaptaZap(mensagem);
  const momento = [dataCurta, hora].filter(Boolean).join(" · ");

  const visual = {
    recuperado: {
      icone: "✓",
      iconeClass: "bg-violet-100 text-violet-700 ring-violet-200",
      tituloClass: "text-violet-900",
    },
    reaberto: {
      icone: "↻",
      iconeClass: "bg-emerald-100 text-emerald-700 ring-emerald-200",
      tituloClass: "text-emerald-900",
    },
    transferido: {
      icone: "→",
      iconeClass: "bg-blue-100 text-blue-700 ring-blue-200",
      tituloClass: "text-blue-900",
    },
    fechado: {
      icone: "✓",
      iconeClass: "bg-slate-200 text-slate-700 ring-slate-300",
      tituloClass: "text-slate-900",
    },
  }[evento.tipo] || {
    icone: "•",
    iconeClass: "bg-slate-100 text-slate-600 ring-slate-200",
    tituloClass: "text-slate-900",
  };

  return (
    <div className="my-1.5 flex w-full justify-center px-2">
      <div className="w-full max-w-[680px] rounded-2xl border border-slate-200 bg-white/95 px-3.5 py-3 shadow-sm">
        <div className="flex items-start gap-3">
          <span
            className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-black ring-1 ${visual.iconeClass}`}
            aria-hidden="true"
          >
            {visual.icone}
          </span>

          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
              <div className={`text-[12px] font-black ${visual.tituloClass}`}>
                {evento.titulo || "Atualização do atendimento"}
              </div>
              {momento ? (
                <div className="shrink-0 text-[10px] font-semibold text-slate-400">
                  {momento}
                </div>
              ) : null}
            </div>

            {evento.resumo ? (
              <div className="mt-0.5 text-[12px] font-semibold leading-5 text-slate-600">
                {evento.resumo}
              </div>
            ) : null}

            {evento.detalhe ? (
              <div className="mt-1.5 rounded-xl bg-slate-50 px-2.5 py-1.5 text-[11px] font-semibold leading-4 text-slate-500 ring-1 ring-slate-100">
                {evento.detalhe}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

function MensagemInternaRecuperadoDraMaluCaptaZap({ mensagem = {} }) {
  return (
    <div className="my-1.5 flex w-full flex-col items-center gap-1.5 px-2">
      <EventoOperacionalTimelineCaptaZap
        mensagem={mensagem}
        evento={{
          tipo: "recuperado",
          titulo: "Paciente recuperado",
          resumo:
            "O paciente respondeu. A Dra. Malu encerrou a recuperação automática.",
          detalhe: "O atendimento agora precisa continuar com uma pessoa da equipe.",
        }}
      />

      <EventoOperacionalTimelineCaptaZap
        mensagem={mensagem}
        evento={{
          tipo: "reaberto",
          titulo: "Atendimento reaberto",
          resumo: "O atendimento voltou para a Fila.",
          detalhe: "Está aguardando alguém assumir e continuar a conversa.",
        }}
      />
    </div>
  );
}

function getEventoOperacionalSistemaCaptaZap(mensagem = {}) {
  if (!mensagem || typeof mensagem !== "object") return null;

  const direcao = String(
    mensagem.direcao || mensagem.direction || mensagem.sentido || "",
  )
    .trim()
    .toLowerCase();
  const autor = String(
    mensagem.autor || mensagem.de || mensagem.from || "",
  )
    .trim()
    .toLowerCase();
  const status = String(mensagem.status || "")
    .trim()
    .toLowerCase();

  const ehInterna = Boolean(
    ["interna", "interno", "sistema"].includes(direcao) ||
      ["sistema", "system"].includes(autor) ||
      ["interno", "sistema"].includes(status),
  );

  if (!ehInterna) return null;

  const texto = String(
    mensagem.texto ||
      mensagem.mensagem ||
      mensagem.message ||
      mensagem.body ||
      "",
  )
    .replace(/\s+/g, " ")
    .trim();

  if (!texto) return null;

  const fechamento = texto.match(
    /^Chamado fechado por\s+(.+?)\s+em\s+(\d{2}\/\d{2}\/\d{4}),\s*(\d{2}:\d{2})\.?(?:\s*Motivo:\s*(.+?))?\.?$/i,
  );

  if (fechamento) {
    const responsavel = String(fechamento[1] || "").trim();
    const motivo = String(fechamento[4] || "").replace(/\.$/, "").trim();

    return {
      tipo: "fechado",
      titulo: "Atendimento encerrado",
      resumo: responsavel
        ? `${responsavel} encerrou este atendimento.`
        : "Este atendimento foi encerrado.",
      detalhe: motivo ? `Motivo: ${motivo}` : "Atendimento finalizado pela equipe.",
      hora: String(fechamento[3] || "").trim(),
    };
  }

  const transferencia = texto.match(
    /^Atendimento transferido por\s+(.+?)\s+para\s+(.+?)\.?$/i,
  );

  if (transferencia) {
    const origem = String(transferencia[1] || "").trim();
    const destino = String(transferencia[2] || "")
      .replace(/\.$/, "")
      .trim();

    return {
      tipo: "transferido",
      titulo: "Atendimento transferido",
      resumo: destino
        ? `${destino} passou a ser responsável pelo atendimento.`
        : "O atendimento mudou de responsável.",
      detalhe: origem ? `Transferido por ${origem}.` : "Responsável atualizado.",
    };
  }

  const normalizado = normalizarTextoBuscaDraMaluCaptaZap(texto);

  if (
    normalizado.includes("chamado reaberto") ||
    normalizado.includes("atendimento reaberto")
  ) {
    return {
      tipo: "reaberto",
      titulo: "Atendimento reaberto",
      resumo: "O atendimento voltou a ficar ativo.",
      detalhe: normalizado.includes("fila")
        ? "Foi enviado para a Fila e está aguardando alguém assumir."
        : "A equipe pode continuar o atendimento.",
    };
  }

  return null;
}

function formatarDataCurtaEventoOperacionalCaptaZap(mensagem = {}) {
  const raw =
    mensagem.datahora ||
    mensagem.created_at ||
    mensagem.updated_at ||
    mensagem.enviado_em ||
    mensagem.recebido_em ||
    mensagem.timestamp ||
    "";

  const timestamp = parseDataFollowUpChat(raw);
  if (!timestamp) return "";

  const data = new Date(timestamp);
  if (Number.isNaN(data.getTime())) return "";

  return data.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
  });
}

function getTextoMensagemInternaRecuperadoDraMaluCaptaZap() {
  return "🟡 Contato recuperado pela Dra. Malu. Paciente respondeu; automação encerrada e chamado enviado para a Fila.";
}

function formatarHoraMensagemInternaDraMaluCaptaZap(mensagem = {}) {
  const raw =
    mensagem.datahora ||
    mensagem.created_at ||
    mensagem.updated_at ||
    mensagem.enviado_em ||
    mensagem.recebido_em ||
    mensagem.timestamp ||
    "";

  const timestamp = parseDataFollowUpChat(raw);
  if (!timestamp) return "";

  const data = new Date(timestamp);
  if (Number.isNaN(data.getTime())) return "";

  return data.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

function isMensagemRecuperadoDraMaluCaptaZap(mensagem = {}) {
  if (!mensagem || typeof mensagem !== "object") return false;

  const flags = Boolean(
    mensagem.recuperado_dra_malu ||
    mensagem.recuperadoDraMalu ||
    mensagem._recuperado_dra_malu ||
    mensagem._captazap_destaque_amarelo ||
    mensagem.badge_recuperacao_dra_malu ||
    mensagem.origem_recuperacao === "dra_malu_ia" ||
    mensagem.origemRecuperacao === "dra_malu_ia" ||
    mensagem.tipo_sistema === "recuperado_dra_malu" ||
    mensagem.tipoSistema === "recuperado_dra_malu" ||
    mensagem._captazap_classe_visual === "recuperado-dra-malu",
  );

  if (flags) return true;

  const texto = [
    mensagem.texto,
    mensagem.mensagem,
    mensagem.message,
    mensagem.body,
    mensagem.preview,
    mensagem.ultima_mensagem,
    mensagem.titulo,
    mensagem.tipo_sistema,
    mensagem.tipoSistema,
    mensagem.evento,
    mensagem.categoria,
    mensagem.origem,
    mensagem.automacao_tipo,
  ]
    .filter(Boolean)
    .join(" ");

  const normalizado = normalizarTextoBuscaDraMaluCaptaZap(texto);

  return Boolean(
    (normalizado.includes("chamado recuperado") &&
      normalizado.includes("dra malu")) ||
    normalizado.includes("recuperado pela dra malu") ||
    normalizado.includes("recuperado dra malu") ||
    (normalizado.includes("dra malu ia") &&
      normalizado.includes("favor dar continuidade")),
  );
}

function normalizarTextoBuscaDraMaluCaptaZap(value = "") {
  return normalizarTipoMensagemRapida(value)
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function RegistroLigacaoFollowUpModal({
  form,
  setForm,
  registrando = false,
  erro = "",
  conversa = {},
  onClose,
  onSubmit,
}) {
  const nome =
    conversa?.nome || conversa?.lead?.nome || conversa?.telefone || "Paciente";
  const telefone = formatTelefoneHeader(
    conversa?.telefone || conversa?.numero || "",
  );

  const atualizarCampo = (campo, valor) => {
    setForm((atual) => ({ ...atual, [campo]: valor }));
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-950/45 px-4 py-6 backdrop-blur-[2px]">
      <div className="w-full max-w-xl overflow-hidden rounded-[32px] border border-slate-200 bg-white shadow-[0_30px_90px_rgba(15,23,42,0.35)]">
        <div className="relative overflow-hidden border-b border-blue-200 bg-gradient-to-br from-blue-700 via-blue-800 to-slate-950 px-5 py-5 text-white">
          <div className="pointer-events-none absolute -right-12 -top-16 h-36 w-36 rounded-full bg-cyan-300/25 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-16 left-8 h-32 w-32 rounded-full bg-amber-300/20 blur-2xl" />

          <div className="relative flex items-start justify-between gap-4">
            <div className="min-w-0">
              <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-[11px] font-black uppercase tracking-wide text-blue-100">
                <FaPhoneAlt size={11} />
                Follow-up por ligação
              </div>

              <h3 className="mt-3 truncate text-lg font-black leading-tight">
                Registrar ligação realizada
              </h3>

              <p className="mt-1 text-xs font-semibold leading-5 text-blue-100">
                Salve data, hora, resultado e observação para auditoria do
                atendimento.
              </p>
            </div>

            <button
              type="button"
              onClick={onClose}
              disabled={registrando}
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl border border-white/20 bg-white/10 text-white shadow-sm transition hover:bg-white/20 disabled:opacity-60"
              title="Fechar"
            >
              <FaTimes size={14} />
            </button>
          </div>
        </div>

        <div className="bg-gradient-to-b from-white to-blue-50/30 px-5 py-5">
          <div className="mb-4 rounded-[24px] border border-slate-200 bg-white px-4 py-3 shadow-sm">
            <div className="text-[11px] font-black uppercase tracking-wide text-slate-400">
              Paciente
            </div>
            <div className="mt-1 truncate text-sm font-black text-slate-950">
              {nome}
            </div>
            {telefone ? (
              <div className="mt-0.5 text-xs font-semibold text-slate-500">
                {telefone}
              </div>
            ) : null}
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <label className="block">
              <span className="mb-1.5 block text-[11px] font-black uppercase tracking-wide text-slate-500">
                Data e hora da ligação
              </span>
              <input
                type="datetime-local"
                value={form.realizadoEm || ""}
                onChange={(event) =>
                  atualizarCampo("realizadoEm", event.target.value)
                }
                disabled={registrando}
                className="h-12 w-full rounded-2xl border border-slate-300 bg-white px-3 text-sm font-bold text-slate-800 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 disabled:bg-slate-100"
              />
            </label>

            <label className="block">
              <span className="mb-1.5 block text-[11px] font-black uppercase tracking-wide text-slate-500">
                Resultado
              </span>
              <select
                value={form.resultado || "ligacao_realizada"}
                onChange={(event) =>
                  atualizarCampo("resultado", event.target.value)
                }
                disabled={registrando}
                className="h-12 w-full rounded-2xl border border-slate-300 bg-white px-3 text-sm font-bold text-slate-800 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 disabled:bg-slate-100"
              >
                <option value="ligacao_realizada">Ligação realizada</option>
                <option value="nao_atendeu">Não atendeu</option>
                <option value="ocupado">Ocupado</option>
                <option value="numero_invalido">Número inválido</option>
                <option value="retornar_depois">Retornar depois</option>
              </select>
            </label>
          </div>

          <label className="mt-3 block">
            <span className="mb-1.5 block text-[11px] font-black uppercase tracking-wide text-slate-500">
              Observação
            </span>
            <textarea
              value={form.observacao || ""}
              onChange={(event) =>
                atualizarCampo("observacao", event.target.value)
              }
              disabled={registrando}
              rows={4}
              placeholder="Ex: paciente não atendeu, pediu retorno às 16h, demonstrou interesse..."
              className="w-full resize-none rounded-[22px] border border-slate-300 bg-white px-3 py-3 text-sm leading-6 text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 disabled:bg-slate-100"
            />
          </label>

          {erro ? (
            <div className="mt-4 rounded-[22px] border border-red-200 bg-red-50 px-4 py-3 text-xs font-bold leading-5 text-red-700">
              {erro}
            </div>
          ) : null}

          <div className="mt-4 rounded-[22px] border-2 border-blue-300 bg-blue-50 px-4 py-3 text-xs font-semibold leading-5 text-blue-800">
            Ao salvar, o follow-up será marcado como executado com o horário
            informado e sairá dos pendentes.
          </div>
        </div>

        <div className="flex flex-col gap-2 border-t border-slate-200 bg-white px-5 py-4 sm:flex-row sm:items-center sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            disabled={registrando}
            className="h-11 rounded-2xl border border-slate-300 bg-white px-4 text-xs font-black text-slate-600 shadow-sm transition hover:bg-slate-50 disabled:opacity-60"
          >
            Cancelar
          </button>

          <button
            type="button"
            onClick={onSubmit}
            disabled={registrando || !form.realizadoEm}
            className="inline-flex h-11 items-center justify-center gap-2 rounded-2xl bg-blue-700 px-5 text-xs font-black text-white shadow-[0_12px_26px_rgba(29,78,216,0.20)] transition hover:-translate-y-0.5 hover:bg-blue-800 disabled:cursor-not-allowed disabled:bg-slate-300"
          >
            <FaCheckCircle size={13} />
            {registrando ? "Salvando..." : "Salvar registro da ligação"}
          </button>
        </div>
      </div>
    </div>
  );
}

function PreviewMensagemModal({
  preview,
  enviando,
  envioDesabilitado,
  onClose,
  onVoltar,
  onInserirNoCampo,
  onEnviar,
  onGravarAudio,
  gravandoAudio = false,
  audioGravacaoMs = 0,
  audioPreview = null,
  enviandoMidia = false,
  onPararGravacao,
  onCancelarAudio,
  onEnviarAudio,
}) {
  const origem = preview?.origem || "digitada";
  const editavel = origem === "followup" || origem === "digitada";
  const textoOriginal = limparMarcadoresTecnicosFollowUpChat(
    preview?.texto || "",
  );
  const [textoEditavel, setTextoEditavel] = useState(textoOriginal);

  useEffect(() => {
    setTextoEditavel(textoOriginal);
  }, [preview?.followup_id, preview?.id, preview?.texto, textoOriginal]);

  // Defesa final: metadados internos jamais podem aparecer no texto do paciente.
  const texto = limparMarcadoresTecnicosFollowUpChat(
    editavel ? textoEditavel : textoOriginal,
  );
  const titulo = limparMarcadoresTecnicosFollowUpChat(
    preview?.titulo || "Mensagem",
  );
  const tipo = limparMarcadoresTecnicosFollowUpChat(
    preview?.tipo || (origem === "rapida" ? "Mensagem rápida" : "Texto manual"),
  );
  const mostrarTipo = Boolean(
    tipo &&
    normalizarTipoMensagemRapida(tipo) !== normalizarTipoMensagemRapida(titulo),
  );
  const linhas = texto.split("\n").length;
  const podeGravarAudio = origem === "rapida" || origem === "followup";

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-950/45 px-4 py-6 backdrop-blur-[2px]">
      <div className="flex max-h-[88vh] w-full max-w-2xl flex-col overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-[0_30px_90px_rgba(15,23,42,0.35)]">
        <div className="flex shrink-0 items-start justify-between gap-4 border-b border-slate-200 px-5 py-4">
          <div className="min-w-0">
            <div className="inline-flex items-center gap-2 rounded-full border-2 border-blue-300 bg-blue-50 px-3 py-1 text-[11px] font-black uppercase tracking-wide text-blue-700">
              <FaEye size={12} />
              Pré-visualização
            </div>
            <h3 className="mt-2 truncate text-base font-black text-slate-950">
              {titulo}
            </h3>
            <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px] font-semibold text-slate-500">
              {mostrarTipo ? (
                <>
                  <span>{tipo}</span>
                  <span className="text-slate-300">•</span>
                </>
              ) : null}
              <span>{texto.length} caracteres</span>
              <span className="text-slate-300">•</span>
              <span>
                {linhas} linha{linhas === 1 ? "" : "s"}
              </span>
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-400 shadow-sm transition hover:border-red-200 hover:bg-red-50 hover:text-red-600"
            title="Fechar pré-visualização"
          >
            <FaTimes size={14} />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto bg-slate-50 px-5 py-4">
          <div className="rounded-[22px] border border-slate-200 bg-white p-4 text-sm leading-6 text-slate-800 shadow-sm">
            {editavel ? (
              <label className="block">
                <span className="mb-2 block text-[11px] font-black uppercase tracking-wide text-slate-500">
                  Mensagem que será enviada ao paciente
                </span>
                <textarea
                  value={textoEditavel}
                  onChange={(event) => setTextoEditavel(event.target.value)}
                  rows={8}
                  maxLength={LIMITE_MENSAGEM}
                  autoFocus={origem === "digitada"}
                  className="min-h-[190px] w-full resize-y rounded-2xl border border-emerald-200 bg-emerald-50/50 px-3 py-3 text-sm leading-6 text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10"
                  placeholder={
                    origem === "digitada"
                      ? "Escreva ou revise sua mensagem..."
                      : "Digite a mensagem da etapa..."
                  }
                />
                <div className="mt-1 text-right text-[10px] font-semibold text-slate-400">
                  {texto.length}/{LIMITE_MENSAGEM}
                </div>
              </label>
            ) : texto ? (
              <div className="whitespace-pre-wrap break-words">{texto}</div>
            ) : (
              <div className="text-slate-400">Mensagem vazia.</div>
            )}
          </div>

          {editavel ? (
            <div className="mt-3 rounded-[20px] border border-blue-200 bg-blue-50 px-3 py-2 text-[11px] font-semibold leading-5 text-blue-800">
              {origem === "digitada"
                ? "Você pode continuar escrevendo e revisar a mensagem neste espaço maior. Será enviado exatamente o texto que permanecer neste campo."
                : "A mensagem acima foi carregada da etapa atual. Você pode personalizá-la; será enviado exatamente o texto que permanecer neste campo."}
            </div>
          ) : null}

          {podeGravarAudio ? (
            <div className="mt-4 rounded-[24px] border border-emerald-200 bg-emerald-50/90 p-4 shadow-sm">
              <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 text-sm font-black text-emerald-800">
                    <FaMicrophone size={14} />
                    Gravar mensagem usando este texto como roteiro
                  </div>
                  <p className="mt-1 text-xs font-semibold leading-5 text-emerald-700/80">
                    Leia a mensagem acima, grave com sua voz, ouça a prévia e
                    envie o áudio direto daqui. Ideal para pacientes com
                    dificuldade de leitura.
                  </p>

                  {gravandoAudio ? (
                    <div className="mt-3 rounded-2xl border border-red-200 bg-white px-3 py-2 text-xs font-black text-red-700">
                      Gravando... {formatDuracaoAudio(audioGravacaoMs)}
                    </div>
                  ) : null}

                  {audioPreview ? (
                    <div className="mt-3">
                      <audio
                        src={audioPreview.url}
                        controls
                        className="w-full"
                      />
                      <div className="mt-1 text-[11px] font-semibold text-emerald-700/80">
                        Revise antes de enviar. Se não gostar, refaça a
                        gravação.
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="flex shrink-0 flex-wrap items-center gap-2">
                  {gravandoAudio ? (
                    <button
                      type="button"
                      onClick={onPararGravacao}
                      className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl bg-red-600 px-4 text-xs font-black text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-red-700"
                    >
                      <FaStop size={13} />
                      Parar
                    </button>
                  ) : audioPreview ? (
                    <>
                      <button
                        type="button"
                        onClick={onCancelarAudio}
                        disabled={enviandoMidia}
                        className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-xs font-black text-slate-600 shadow-sm transition hover:-translate-y-0.5 hover:border-red-200 hover:bg-red-50 hover:text-red-600 disabled:cursor-not-allowed disabled:opacity-60"
                      >
                        <FaTimes size={13} />
                        Refazer
                      </button>

                      <button
                        type="button"
                        onClick={onEnviarAudio}
                        disabled={enviandoMidia || envioDesabilitado}
                        className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl bg-[#25D366] px-4 text-xs font-black text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-[#1FB85A] disabled:cursor-not-allowed disabled:bg-slate-300"
                      >
                        <FaPaperPlane size={13} />
                        {enviandoMidia ? "Enviando áudio..." : "Enviar áudio"}
                      </button>
                    </>
                  ) : (
                    <button
                      type="button"
                      onClick={onGravarAudio}
                      disabled={enviandoMidia || envioDesabilitado}
                      className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 text-xs font-black text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-emerald-700 disabled:cursor-not-allowed disabled:bg-slate-300"
                    >
                      <FaMicrophone size={13} />
                      Gravar mensagem
                    </button>
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>

        <div className="flex shrink-0 flex-col gap-2 border-t border-slate-200 bg-white px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="text-[11px] font-semibold leading-5 text-slate-500">
            {origem === "rapida"
              ? "Confira os dados preenchidos, envie como texto ou grave um áudio usando o texto como roteiro."
              : origem === "followup"
                ? "Confira a mensagem da etapa antes de enviar ao paciente."
                : "Continue escrevendo ou confira o texto completo antes de enviar ao paciente."}
          </div>

          <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
            <button
              type="button"
              onClick={() => (onVoltar || onClose)?.(texto)}
              className="inline-flex h-10 items-center justify-center rounded-2xl border border-slate-300 bg-white px-4 text-xs font-black text-slate-600 shadow-sm transition hover:-translate-y-0.5 hover:bg-slate-50"
            >
              Voltar
            </button>

            {origem === "rapida" ? (
              <button
                type="button"
                onClick={onInserirNoCampo}
                className="inline-flex h-10 items-center justify-center rounded-2xl border-2 border-blue-300 bg-blue-50 px-4 text-xs font-black text-blue-700 shadow-sm transition hover:-translate-y-0.5 hover:bg-blue-100"
              >
                Inserir no campo
              </button>
            ) : null}

            {podeGravarAudio && !audioPreview && !gravandoAudio ? (
              <button
                type="button"
                onClick={onGravarAudio}
                disabled={enviandoMidia || envioDesabilitado}
                className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 text-xs font-black text-emerald-700 shadow-sm transition hover:-translate-y-0.5 hover:bg-emerald-100 disabled:cursor-not-allowed disabled:opacity-60"
              >
                <FaMicrophone size={13} />
                Gravar
              </button>
            ) : null}

            <button
              type="button"
              onClick={() => onEnviar?.(texto)}
              disabled={enviando || envioDesabilitado || !texto.trim()}
              className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl bg-[#25D366] px-4 text-xs font-black text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-[#1FB85A] disabled:cursor-not-allowed disabled:bg-slate-300"
            >
              <FaPaperPlane size={13} />
              {enviando ? "Enviando..." : "Enviar agora"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function getDatetimeLocalNowCaptaZap() {
  const data = new Date();
  const pad = (valor) => String(valor).padStart(2, "0");

  return `${data.getFullYear()}-${pad(data.getMonth() + 1)}-${pad(data.getDate())}T${pad(data.getHours())}:${pad(data.getMinutes())}`;
}

function datetimeLocalToIsoCaptaZap(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";

  const data = new Date(raw);
  if (Number.isNaN(data.getTime())) return "";

  return data.toISOString();
}

function normalizarMensagemMidiaCaptaZap(
  mensagem = {},
  { apiBase = "", empresaId = null } = {},
) {
  const tipoMidia = getTipoMidiaMensagemCaptaZap(mensagem);
  const midiaUrl = resolverMidiaUrlCaptaZap(
    getMidiaUrlMensagemCaptaZap(mensagem),
    apiBase,
  );
  const recuperadoDraMalu = isMensagemRecuperadoDraMaluCaptaZap(mensagem);

  const textoOriginal =
    mensagem.texto ??
    mensagem.mensagem ??
    mensagem.message ??
    mensagem.body ??
    "";

  const texto = recuperadoDraMalu
    ? getTextoMensagemInternaRecuperadoDraMaluCaptaZap()
    : textoOriginal ||
      (tipoMidia === "sticker"
        ? midiaUrl
          ? ""
          : "Figurinha"
        : tipoMidia === "imagem"
          ? "Imagem"
          : tipoMidia === "video"
          ? "Vídeo"
          : tipoMidia === "audio"
            ? "Mensagem de áudio"
            : tipoMidia === "documento"
              ? "Documento"
              : "");

  return {
    ...mensagem,
    empresa_id: mensagem.empresa_id || mensagem.empresaId || empresaId || null,
    telefone:
      mensagem.telefone ||
      mensagem.numero ||
      mensagem.phone ||
      mensagem.whatsapp ||
      null,
    numero:
      mensagem.numero ||
      mensagem.telefone ||
      mensagem.phone ||
      mensagem.whatsapp ||
      null,
    texto,
    mensagem: recuperadoDraMalu ? texto : (mensagem.mensagem ?? texto),
    recuperado_dra_malu: recuperadoDraMalu,
    recuperadoDraMalu: recuperadoDraMalu,
    _recuperado_dra_malu: recuperadoDraMalu,
    _captazap_destaque_amarelo:
      recuperadoDraMalu || Boolean(mensagem._captazap_destaque_amarelo),
    _captazap_classe_visual: recuperadoDraMalu
      ? "recuperado-dra-malu"
      : mensagem._captazap_classe_visual || "",
    tipo_sistema: recuperadoDraMalu
      ? "recuperado_dra_malu"
      : mensagem.tipo_sistema || mensagem.tipoSistema || null,
    tipo_midia: tipoMidia || mensagem.tipo_midia || mensagem.tipoMidia || null,
    tipoMidia: tipoMidia || mensagem.tipoMidia || mensagem.tipo_midia || null,
    midia_url: midiaUrl || mensagem.midia_url || mensagem.midiaUrl || null,
    midiaUrl: midiaUrl || mensagem.midiaUrl || mensagem.midia_url || null,
    mediaUrl: midiaUrl || mensagem.mediaUrl || mensagem.media_url || null,
    arquivo_url: midiaUrl || mensagem.arquivo_url || null,
  };
}

function getTipoMidiaMensagemCaptaZap(mensagem = {}) {
  const raw = String(
    mensagem.tipo_midia ||
      mensagem.tipoMidia ||
      mensagem.media_type ||
      mensagem.mediaType ||
      mensagem.type ||
      mensagem.message_type ||
      "",
  )
    .trim()
    .toLowerCase();

  if (["sticker", "figurinha"].includes(raw)) return "sticker";
  if (["imagem", "image", "photo", "foto"].includes(raw)) return "imagem";
  if (["video", "vídeo"].includes(raw)) return "video";
  if (["audio", "áudio", "ptt", "voice"].includes(raw)) return "audio";
  if (["documento", "document", "file", "arquivo"].includes(raw)) {
    return "documento";
  }

  const mime = String(
    mensagem.mime_type ||
      mensagem.mimeType ||
      mensagem.mimetype ||
      mensagem.content_type ||
      "",
  ).toLowerCase();

  if (mime.startsWith("image/")) return "imagem";
  if (mime.startsWith("video/")) return "video";
  if (mime.startsWith("audio/")) return "audio";
  if (mime) return "documento";

  const url = String(getMidiaUrlMensagemCaptaZap(mensagem) || "").toLowerCase();

  if (/\.(png|jpe?g|gif|webp|bmp|heic)(\?|#|$)/i.test(url)) return "imagem";
  if (/\.(mp4|mov|webm|mkv|avi)(\?|#|$)/i.test(url)) return "video";
  if (/\.(mp3|ogg|wav|m4a|webm)(\?|#|$)/i.test(url)) return "audio";
  if (url) return "documento";

  return "";
}

function getMidiaUrlMensagemCaptaZap(mensagem = {}) {
  return (
    mensagem.midia_url ||
    mensagem.midiaUrl ||
    mensagem.media_url ||
    mensagem.mediaUrl ||
    mensagem.arquivo_url ||
    mensagem.arquivoUrl ||
    mensagem.file_url ||
    mensagem.fileUrl ||
    mensagem.url_arquivo ||
    mensagem.urlArquivo ||
    mensagem.downloadUrl ||
    mensagem.download_url ||
    mensagem.imageUrl ||
    mensagem.image_url ||
    mensagem.videoUrl ||
    mensagem.video_url ||
    mensagem.audioUrl ||
    mensagem.audio_url ||
    mensagem?.image?.imageUrl ||
    mensagem?.image?.url ||
    mensagem?.image?.link ||
    mensagem?.video?.videoUrl ||
    mensagem?.video?.url ||
    mensagem?.audio?.audioUrl ||
    mensagem?.audio?.url ||
    mensagem?.document?.documentUrl ||
    mensagem?.document?.url ||
    mensagem?.document?.link ||
    mensagem?.file?.url ||
    mensagem?.file?.link ||
    ""
  );
}

function resolverMidiaUrlCaptaZap(url = "", apiBase = "") {
  const raw = String(url || "").trim();

  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith("data:")) return raw;
  if (raw.startsWith("blob:")) return raw;

  const base = String(apiBase || "").replace(/\/+$/, "");

  if (!base) return raw;

  return `${base}/${raw.replace(/^\/+/, "")}`;
}

function getAvatarContatoConversaCaptaZap(conversa = {}) {
  const lead = conversa?.lead || {};

  return (
    conversa?.profileUrl ||
    conversa?.profile_url ||
    conversa?.avatar_url ||
    conversa?.avatar ||
    conversa?.foto ||
    conversa?.foto_url ||
    conversa?.foto_perfil ||
    conversa?.fotoPerfil ||
    lead?.profileUrl ||
    lead?.profile_url ||
    lead?.avatar_url ||
    lead?.avatar ||
    lead?.foto ||
    lead?.foto_url ||
    lead?.foto_perfil ||
    lead?.fotoPerfil ||
    ""
  );
}

function isMensagemEnviadaOperadorCaptaZap(mensagem = {}) {
  const direcao = String(
    mensagem.direcao || mensagem.direction || mensagem.sentido || "",
  ).toLowerCase();

  if (
    direcao === "recebida" ||
    direcao === "in" ||
    direcao === "incoming" ||
    direcao === "entrada"
  ) {
    return false;
  }

  if (direcao === "enviada" || direcao === "out" || direcao === "outgoing") {
    return true;
  }

  if (mensagem.fromMe === true || mensagem.from_me === true) return true;

  const autor = String(
    mensagem.autor || mensagem.de || mensagem.from || "",
  ).toLowerCase();

  return [
    "operador",
    "atendente",
    "captador",
    "usuario",
    "usuário",
    "sistema",
  ].includes(autor);
}

function extrairLinksTextoMensagemCaptaZap(texto = "") {
  const textoSeguro = String(texto || "");
  const matches = textoSeguro.match(/https?:\/\/[^\s<>"')]+/gi) || [];

  return [...new Set(matches.map((link) => link.replace(/[.,;!?]+$/g, "")))];
}

function normalizarTipoMensagemRapida(value = "") {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function substituirPlaceholdersMensagemRapida(
  texto = "",
  conversa = {},
  { dentistas = [], procedimentos = [] } = {},
) {
  const lead =
    conversa?.lead || conversa?.lead_dados || conversa?.leadDados || {};
  const agendamento = getAgendamentoMensagemRapida(conversa);

  const paciente = getPrimeiroValorTexto([
    lead.nome_lead,
    lead.nomeLead,
    lead.nome,
    lead.nome_cliente,
    lead.nomeCliente,
    conversa.nome,
    conversa.nome_lead,
    conversa.nomeLead,
    conversa.numero,
    conversa.telefone,
  ]);

  const captadorCompleto = getPrimeiroValorTexto([
    conversa.responsavel_nome,
    conversa.usuario_responsavel_nome,
    conversa.atendente_nome,
    conversa.operador_nome,
    conversa.captador_nome,
    conversa.lead_captador_nome,
    conversa.dono_lead_nome,
    lead.responsavel_nome,
    lead.usuario_responsavel_nome,
    lead.usuario_criador_nome,
    lead.captador_nome,
    lead.usuario_nome,
  ]);

  const profissional = getProfissionalMensagemRapida(conversa, agendamento, {
    dentistas,
  });
  const procedimento = getProcedimentoMensagemRapida(conversa, agendamento, {
    procedimentos,
  });
  const captadorPrimeiroNome = getPrimeiroNome(captadorCompleto);
  const dataAgendamento = formatarDataAgendamentoMensagemRapida(conversa);

  return String(texto || "")
    .replace(/\[paciente\]/gi, paciente || "")
    .replace(/\[captador\]/gi, captadorPrimeiroNome || "")
    .replace(/\[profissional\]/gi, profissional || "")
    .replace(/\[procedimento\]/gi, procedimento || "")
    .replace(/\[data_agendamento\]/gi, dataAgendamento || "Não informado")
    .replace(/\[dataagendamento\]/gi, dataAgendamento || "Não informado")
    .replace(/\[data agendamento\]/gi, dataAgendamento || "Não informado")
    .replace(/\[agendamento\]/gi, dataAgendamento || "Não informado");
}

function getPrimeiroValorTexto(values = []) {
  for (const value of values) {
    const text = String(value ?? "").trim();

    if (!text) continue;
    if (text === "0") continue;
    if (text.toLowerCase() === "null") continue;
    if (text.toLowerCase() === "undefined") continue;

    return text;
  }

  return "";
}

function getPrimeiroNome(nome = "") {
  const normalizado = String(nome || "")
    .trim()
    .replace(/\s+/g, " ");

  if (!normalizado) return "";

  return normalizado.split(" ")[0] || normalizado;
}

function formatarDataAgendamentoMensagemRapida(conversa = {}) {
  const agendamento = getAgendamentoMensagemRapida(conversa);
  const raw = getDataRawAgendamentoMensagemRapida(agendamento, conversa);

  if (!raw) return "Não informado";

  const data = parseDataAgendamentoMensagemRapida(raw);

  if (!data) return String(raw);

  const diaSemana = data.toLocaleDateString("pt-BR", {
    weekday: "long",
  });
  const dataFormatada = data.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const horaFormatada = data.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
  const rawTemHora = /\d{1,2}:\d{2}/.test(String(raw || ""));

  return rawTemHora
    ? `${diaSemana}, ${dataFormatada} às ${horaFormatada}`
    : `${diaSemana}, ${dataFormatada}`;
}

function parseDataAgendamentoMensagemRapida(value) {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number") {
    const timestamp = value < 10000000000 ? value * 1000 : value;
    const data = new Date(timestamp);
    return Number.isNaN(data.getTime()) ? null : data;
  }

  const text = String(value || "").trim();
  if (!text) return null;

  const mysql = text.match(
    /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?/,
  );

  if (mysql) {
    const data = new Date(
      Number(mysql[1]),
      Number(mysql[2]) - 1,
      Number(mysql[3]),
      Number(mysql[4] || 0),
      Number(mysql[5] || 0),
      Number(mysql[6] || 0),
      0,
    );

    return Number.isNaN(data.getTime()) ? null : data;
  }

  const br = text.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/,
  );

  if (br) {
    const anoRaw = Number(br[3]);
    const ano = anoRaw < 100 ? 2000 + anoRaw : anoRaw;
    const data = new Date(
      ano,
      Number(br[2]) - 1,
      Number(br[1]),
      Number(br[4] || 0),
      Number(br[5] || 0),
      Number(br[6] || 0),
      0,
    );

    return Number.isNaN(data.getTime()) ? null : data;
  }

  const parsed = new Date(text);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function getAgendamentoMensagemRapida(conversa = {}) {
  const candidatos = [];

  if (conversa.ultimo_agendamento) candidatos.push(conversa.ultimo_agendamento);
  if (conversa._ultimo_agendamento)
    candidatos.push(conversa._ultimo_agendamento);
  if (conversa.lead?.ultimo_agendamento)
    candidatos.push(conversa.lead.ultimo_agendamento);
  if (conversa.lead?._ultimo_agendamento)
    candidatos.push(conversa.lead._ultimo_agendamento);

  const listas = [
    conversa.agendamentos,
    conversa.agendamentosLead,
    conversa.agendas,
    conversa.lead?.agendamentos,
    conversa.lead?.agendamentosLead,
    conversa.lead?.agendas,
  ];

  for (const lista of listas) {
    if (!Array.isArray(lista)) continue;
    candidatos.push(...lista);
  }

  const validos = candidatos
    .filter(Boolean)
    .filter((item) => {
      const status = normalizarTipoMensagemRapida(
        item.status_agendamento || item.statusAgendamento || item.status || "",
      );

      if (!status) return true;

      return [
        "agendado",
        "reagendado",
        "confirmado",
        "confirmada",
        "marcado",
        "marcada",
        "compareceu",
      ].includes(status);
    })
    .map((item) => ({
      item,
      data: parseDataAgendamentoMensagemRapida(
        getDataRawAgendamentoMensagemRapida(item, conversa),
      ),
    }))
    .filter(({ data }) => data && !Number.isNaN(data.getTime()))
    .sort((a, b) => b.data.getTime() - a.data.getTime());

  return validos[0]?.item || candidatos.find(Boolean) || null;
}

function getDataRawAgendamentoMensagemRapida(agendamento = {}, conversa = {}) {
  const data = getPrimeiroValorTexto([
    agendamento?.data_agendamento,
    agendamento?.dataAgendamento,
    agendamento?.data,
    agendamento?.inicio,
    agendamento?.start,
    agendamento?.start_at,
    agendamento?.datahora,
    agendamento?.data_hora,
    agendamento?.dataHora,
    conversa.data_agendamento,
    conversa.dataAgendamento,
    conversa.proximo_agendamento,
    conversa.proximaConsulta,
    conversa.lead?.data_agendamento,
    conversa.lead?.dataAgendamento,
  ]);

  const hora = getPrimeiroValorTexto([
    agendamento?.hora_agendamento,
    agendamento?.horaAgendamento,
    agendamento?.hora,
    agendamento?.horario,
    agendamento?.time,
    conversa.hora_agendamento,
    conversa.horaAgendamento,
    conversa.hora,
    conversa.horario,
    conversa.lead?.hora_agendamento,
    conversa.lead?.horaAgendamento,
  ]);

  if (data && hora && !/\d{1,2}:\d{2}/.test(String(data))) {
    return `${data} ${hora}`;
  }

  return data;
}

function getProfissionalMensagemRapida(
  conversa = {},
  agendamento = {},
  { dentistas = [] } = {},
) {
  const lead =
    conversa?.lead || conversa?.lead_dados || conversa?.leadDados || {};

  const direto = getPrimeiroValorTexto([
    agendamento?.profissional_nome,
    agendamento?.nome_profissional,
    agendamento?.profissional,
    agendamento?.profissional?.nome,
    agendamento?.profissional?.profissional,
    agendamento?.dentista_nome,
    agendamento?.nome_dentista,
    agendamento?.dentista,
    agendamento?.dentista?.nome,
    agendamento?.dentista?.profissional,
    agendamento?.medico_nome,
    agendamento?.nome_medico,
    agendamento?.doutor_nome,
    agendamento?.nome_doutor,

    conversa.profissional_nome,
    conversa.nome_profissional,
    conversa.profissional,
    conversa.profissional?.nome,
    conversa.profissional?.profissional,
    conversa.dentista_nome,
    conversa.nome_dentista,
    conversa.dentista,
    conversa.dentista?.nome,
    conversa.dentista?.profissional,
    conversa.medico_nome,
    conversa.nome_medico,
    conversa.doutor_nome,
    conversa.nome_doutor,

    lead.profissional_nome,
    lead.nome_profissional,
    lead.profissional,
    lead.profissional?.nome,
    lead.profissional?.profissional,
    lead.dentista_nome,
    lead.nome_dentista,
    lead.dentista,
    lead.dentista?.nome,
    lead.dentista?.profissional,
    lead.medico_nome,
    lead.nome_medico,
    lead.doutor_nome,
    lead.nome_doutor,
    lead.dentista_profissional,
    lead.nomeDentista,
    conversa.dentista_profissional,
    conversa.nomeDentista,
    agendamento?.dentista_profissional,
    agendamento?.nomeDentista,
  ]);

  if (direto) return direto;

  const profissionalId = getPrimeiroValorTexto([
    agendamento?.id_dentista,
    agendamento?.dentista_id,
    agendamento?.id_profissional,
    agendamento?.profissional_id,
    conversa.id_dentista,
    conversa.dentista_id,
    conversa.id_profissional,
    conversa.profissional_id,
    lead.id_dentista,
    lead.dentista_id,
    lead.id_profissional,
    lead.profissional_id,
  ]);

  const listas = [
    dentistas,
    conversa.dentistas,
    conversa.profissionais,
    conversa.lead?.dentistas,
    conversa.lead?.profissionais,
  ];

  return getNomePorIdMensagemRapida(profissionalId, listas, [
    "profissional",
    "nome",
    "nome_profissional",
    "nome_dentista",
  ]);
}

function getProcedimentoMensagemRapida(
  conversa = {},
  agendamento = {},
  { procedimentos = [] } = {},
) {
  const lead =
    conversa?.lead || conversa?.lead_dados || conversa?.leadDados || {};

  const direto = getPrimeiroValorTexto([
    agendamento?.procedimento_nome,
    agendamento?.nome_procedimento,
    agendamento?.procedimento,
    agendamento?.procedimento?.nome,
    agendamento?.servico_nome,
    agendamento?.nome_servico,

    conversa.procedimento_nome,
    conversa.nome_procedimento,
    conversa.procedimento,
    conversa.procedimento?.nome,
    conversa.servico_nome,
    conversa.nome_servico,

    lead.procedimento_nome,
    lead.nome_procedimento,
    lead.procedimento,
    lead.procedimento?.nome,
    lead.servico_nome,
    lead.nome_servico,
    lead.tratamento,
    lead.tratamento_nome,
    conversa.tratamento,
    conversa.tratamento_nome,
    agendamento?.tratamento,
    agendamento?.tratamento_nome,
  ]);

  if (direto) return direto;

  const procedimentoId = getPrimeiroValorTexto([
    agendamento?.id_procedimento,
    agendamento?.procedimento_id,
    agendamento?.id_servico,
    agendamento?.servico_id,
    conversa.id_procedimento,
    conversa.procedimento_id,
    conversa.id_servico,
    conversa.servico_id,
    lead.id_procedimento,
    lead.procedimento_id,
    lead.id_servico,
    lead.servico_id,
  ]);

  const listas = [
    procedimentos,
    conversa.procedimentos,
    conversa.servicos,
    conversa.lead?.procedimentos,
    conversa.lead?.servicos,
  ];

  return getNomePorIdMensagemRapida(procedimentoId, listas, [
    "nome",
    "procedimento",
    "nome_procedimento",
    "servico",
    "nome_servico",
  ]);
}

function getNomePorIdMensagemRapida(id, listas = [], camposNome = ["nome"]) {
  const idTexto = String(id || "").trim();
  if (!idTexto) return "";

  for (const lista of listas || []) {
    if (!Array.isArray(lista)) continue;

    const encontrado = lista.find((item) => {
      const ids = [
        item?.id,
        item?.value,
        item?.id_dentista,
        item?.dentista_id,
        item?.id_profissional,
        item?.profissional_id,
        item?.id_procedimento,
        item?.procedimento_id,
        item?.id_servico,
        item?.servico_id,
      ];

      return ids.some((value) => String(value || "") === idTexto);
    });

    if (encontrado) {
      return getPrimeiroValorTexto(
        camposNome.map((campo) => encontrado[campo]),
      );
    }
  }

  return "";
}

function getTipoMensagemRapidaSugerido(conversa = {}, mensagensRapidas = []) {
  const candidatos = [
    conversa?._follow_up_tipo_mensagem,
    conversa?._follow_up_mensagem_rapida_tipo,
    conversa?._follow_up_etapa_label,
    conversa?._follow_up_titulo,
    conversa?.status_followup,
  ]
    .map((valor) => String(valor || "").trim())
    .filter(Boolean)
    .filter((valor) =>
      normalizarTipoMensagemRapida(valor).includes("follow-up"),
    );

  if (!candidatos.length) return "";

  const desejado = candidatos[0];
  const desejadoNormalizado = normalizarTipoMensagemRapida(desejado);
  const tiposDisponiveis = Array.from(
    new Set(
      (mensagensRapidas || [])
        .map((mensagem) => String(mensagem?.tipo || "").trim())
        .filter(Boolean),
    ),
  );

  const exato = tiposDisponiveis.find(
    (tipo) => normalizarTipoMensagemRapida(tipo) === desejadoNormalizado,
  );

  if (exato) return exato;

  const numero = desejado.match(/follow[-\s]?up\s*(\d+)/i)?.[1];

  if (numero) {
    const porNumero = tiposDisponiveis.find((tipo) => {
      const tipoNormalizado = normalizarTipoMensagemRapida(tipo);
      return (
        tipoNormalizado.includes("follow-up") &&
        new RegExp(`(^|\D)${numero}(\D|$)`).test(tipoNormalizado)
      );
    });

    if (porNumero) return porNumero;
  }

  return "";
}

async function buscarMensagensRapidasEmpresa(empresaId) {
  const rotas = [
    // Rota limpa do router próprio de mensagens rápidas.
    // O componente antigo do projeto usa exatamente este prefixo /api.
    `/api/mensagens-rapidas/empresa/${empresaId}`,
    `/api/mensagem-rapida/empresa/${empresaId}`,
    `/api/mensagensRapidas/empresa/${empresaId}`,
    `/api/mensagemRapida/empresa/${empresaId}`,

    // Fallbacks caso o VITE_API_BASE_URL já termine com /api.
    `/mensagens-rapidas/empresa/${empresaId}`,
    `/mensagem-rapida/empresa/${empresaId}`,
    `/mensagensRapidas/empresa/${empresaId}`,
    `/mensagemRapida/empresa/${empresaId}`,
  ];

  let lastError = null;

  for (const rota of rotas) {
    try {
      return await requestJson(rota);
    } catch (error) {
      lastError = error;

      const message = String(error?.message || "").toLowerCase();
      const podeTentarProxima =
        message.includes("404") ||
        message.includes("not found") ||
        message.includes("cannot get");

      if (!podeTentarProxima) break;
    }
  }

  throw lastError || new Error("Rota de mensagens rápidas não encontrada.");
}

async function enviarMidiaCaptaZap({
  empresaId,
  conversa,
  telefone,
  leadId,
  leadContextoId,
  file,
  base64,
  tipoMidia,
  legenda,
  usuarioId,
  usuarioNome,
  followupId = null,
  clientRequestId = null,
}) {
  const operadorIdEnvio = Number(usuarioId || 0) || null;
  const operadorNomeEnvio = String(usuarioNome || "").trim();
  const zapiInstanceIdEnvio = String(
    conversa?.zapi_instance_id ||
      conversa?.zapiInstanceId ||
      conversa?.conexao_instance_id ||
      conversa?.conexaoInstanceId ||
      conversa?.instance_id ||
      conversa?.instanceId ||
      "",
  ).trim();

  if (!operadorIdEnvio || !operadorNomeEnvio) {
    throw new Error(
      "Não foi possível identificar o usuário logado. Atualize a página antes de enviar.",
    );
  }

  const bodyBase = {
    empresa_id: empresaId,
    zapi_instance_id: zapiInstanceIdEnvio || null,
    lead_id: leadContextoId || leadId || null,
    lead_contexto_id: leadContextoId || leadId || null,
    telefone,
    base64,
    legenda: legenda || "",
    texto: legenda || "",
    mime_type: file.type || "application/octet-stream",
    tamanho_bytes: file.size || null,
    nome_arquivo: file.name || `arquivo-${Date.now()}`,
    filename: file.name || `arquivo-${Date.now()}`,
    conversa_id: conversa?.conversa_id || conversa?.id || null,
    protocolo_id:
      conversa?.protocolo_id ||
      conversa?.chamado_id ||
      conversa?.id_chamado ||
      conversa?.conversa_id ||
      conversa?.id ||
      null,
    usuario_id: operadorIdEnvio,
    usuario_nome: operadorNomeEnvio,
    operador_id: operadorIdEnvio,
    operador_nome: operadorNomeEnvio,
    followup_id: Number(followupId || 0) || null,
    client_audio_platform:
      tipoMidia === "audio" ? getPlataformaAudioCaptaZap() : null,
    client_audio_mime:
      tipoMidia === "audio" ? String(file.type || "") : null,
    client_request_id:
      tipoMidia === "audio" ? String(clientRequestId || "") || null : null,
  };

  if (tipoMidia === "imagem") {
    return requestJson("/whatsapp/enviar-imagem", {
      method: "POST",
      body: JSON.stringify(bodyBase),
    });
  }

  if (tipoMidia === "video") {
    return requestJson("/whatsapp/enviar-video", {
      method: "POST",
      body: JSON.stringify(bodyBase),
    });
  }

  if (tipoMidia === "audio") {
    return requestJsonComFallback(
      ["/whatsapp/enviar-audio", "/whatsapp/enviar"],
      {
        ...bodyBase,
        autor: "operador",
        status: "enviado",
        direcao: "enviada",
        tipo_midia: "audio",
      },
    );
  }

  return requestJsonComFallback(
    ["/whatsapp/enviar-documento", "/whatsapp/enviar"],
    {
      ...bodyBase,
      autor: "operador",
      status: "enviado",
      direcao: "enviada",
      tipo_midia: "documento",
    },
  );
}

async function requestJsonComFallback(rotas = [], body = {}) {
  let lastError = null;

  for (const rota of rotas) {
    try {
      return await requestJson(rota, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
    } catch (error) {
      lastError = error;

      const message = String(error?.message || "").toLowerCase();
      const podeTentarProxima =
        message.includes("404") ||
        message.includes("not found") ||
        message.includes("cannot post");

      if (!podeTentarProxima) break;
    }
  }

  throw lastError || new Error("Nenhuma rota de envio de mídia respondeu.");
}

function gerarRequestIdAudioCaptaZap() {
  try {
    if (globalThis?.crypto?.randomUUID) {
      return globalThis.crypto.randomUUID();
    }
  } catch {}

  return `audio-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

function detectarTipoMidia(file) {
  const mime = String(file?.type || "")
    .toLowerCase()
    .split(";")[0]
    .trim();
  const name = String(file?.name || "").toLowerCase();

  // Só usa endpoints nativos de mídia para formatos comuns do WhatsApp.
  // Todo o restante cai como DOCUMENTO, o que permite selecionar arquivos
  // arbitrários sem tentar empurrar SVG/MKV/ZIP/etc. em endpoints errados.
  const imagensNativas = new Set([
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
    "image/gif",
  ]);

  const videosNativos = new Set([
    "video/mp4",
    "video/webm",
    "video/quicktime",
  ]);

  const audiosNativos = new Set([
    "audio/mpeg",
    "audio/mp3",
    "audio/ogg",
    "audio/webm",
    "audio/wav",
    "audio/mp4",
    "audio/x-m4a",
    "audio/aac",
  ]);

  if (imagensNativas.has(mime)) return "imagem";
  if (videosNativos.has(mime)) return "video";
  if (audiosNativos.has(mime)) return "audio";

  if (/\.(png|jpe?g|gif|webp)$/i.test(name)) return "imagem";
  if (/\.(mp4|mov|webm)$/i.test(name)) return "video";
  if (/\.(mp3|mpeg|ogg|wav|m4a|aac)$/i.test(name)) return "audio";

  return "documento";
}

function arquivoParaDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(new Error("Não foi possível ler o arquivo."));
    reader.readAsDataURL(file);
  });
}

function streamAudioAtivoCaptaZap(stream) {
  return Boolean(
    stream &&
    typeof stream.getAudioTracks === "function" &&
    stream.getAudioTracks().some((track) => track.readyState === "live"),
  );
}

function ehErroDispositivoAudioCaptaZap(error) {
  const nome = String(error?.name || "").toLowerCase();
  const mensagem = String(error?.message || "").toLowerCase();

  return (
    nome === "notreadableerror" ||
    nome === "aborterror" ||
    mensagem.includes("device was removed") ||
    mensagem.includes("device removed") ||
    mensagem.includes("could not start audio source") ||
    mensagem.includes("could not start audio") ||
    mensagem.includes("track start error")
  );
}

async function solicitarStreamAudioCaptaZap() {
  return navigator.mediaDevices.getUserMedia({
    audio: {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
    },
  });
}

function limparTimerLiberacaoStreamAudio(audioStreamReleaseTimerRef) {
  if (audioStreamReleaseTimerRef?.current) {
    window.clearTimeout(audioStreamReleaseTimerRef.current);
    audioStreamReleaseTimerRef.current = null;
  }
}

async function obterStreamAudioCaptaZap(
  audioStreamRef,
  audioStreamReleaseTimerRef,
) {
  limparTimerLiberacaoStreamAudio(audioStreamReleaseTimerRef);

  // Não reutiliza a captura anterior. Em Chrome/Windows o dispositivo padrão pode
  // mudar ou ser removido (headset USB/Bluetooth, webcam etc.) enquanto o stream
  // ainda está referenciado, resultando em "Device was removed" ao gravar.
  // Abrir um stream novo a cada gravação faz o navegador resolver novamente o
  // microfone atualmente disponível.
  pararStreamAudio(audioStreamRef);

  let stream;

  try {
    stream = await solicitarStreamAudioCaptaZap();
  } catch (error) {
    if (!ehErroDispositivoAudioCaptaZap(error)) throw error;

    // Força o Chrome a atualizar a lista de dispositivos e tenta uma única vez
    // com o microfone que estiver disponível naquele momento.
    try {
      if (typeof navigator.mediaDevices?.enumerateDevices === "function") {
        await navigator.mediaDevices.enumerateDevices();
      }
    } catch {
      // A atualização da lista é apenas uma tentativa de recuperação.
    }

    await new Promise((resolve) => window.setTimeout(resolve, 180));
    stream = await solicitarStreamAudioCaptaZap();
  }

  audioStreamRef.current = stream;

  // Se o dispositivo realmente for removido durante o uso, invalida a referência
  // para que a próxima gravação obrigatoriamente abra um stream novo.
  stream.getAudioTracks?.().forEach((track) => {
    track.addEventListener?.(
      "ended",
      () => {
        if (audioStreamRef?.current === stream) {
          audioStreamRef.current = null;
        }
      },
      { once: true },
    );
  });

  return stream;
}

function agendarLiberacaoStreamAudio(
  audioStreamRef,
  audioStreamReleaseTimerRef,
  delayMs = 90000,
) {
  limparTimerLiberacaoStreamAudio(audioStreamReleaseTimerRef);

  audioStreamReleaseTimerRef.current = window.setTimeout(() => {
    pararStreamAudio(audioStreamRef);
    audioStreamReleaseTimerRef.current = null;
  }, delayMs);
}

function pararStreamAudio(audioStreamRef) {
  const stream = audioStreamRef?.current;

  if (!stream) return;

  stream.getTracks().forEach((track) => track.stop());
  audioStreamRef.current = null;
}

function limparAudioPreview(setAudioPreview) {
  setAudioPreview((atual) => {
    if (atual?.url) {
      try {
        URL.revokeObjectURL(atual.url);
      } catch {
        // ignora URL já revogada
      }
    }

    return null;
  });
}

function formatDuracaoAudio(ms = 0) {
  const totalSeconds = Math.max(0, Math.floor(Number(ms || 0) / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

async function requestJson(path, options = {}) {
  const url = path.startsWith("http")
    ? path
    : API_BASE
      ? `${API_BASE}${path}`
      : path;

  const response = await fetch(url, {
    method: "GET",
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...(options.headers || {}),
    },
  });

  const text = await response.text();
  const data = text ? safeJson(text) : null;

  if (!response.ok) {
    const message =
      data?.erro || data?.error || data?.message || `HTTP ${response.status}`;

    throw new Error(message);
  }

  return data;
}

function getAuthHeaders() {
  const raw =
    window.localStorage?.getItem("token") ||
    window.localStorage?.getItem("authToken") ||
    window.localStorage?.getItem("jwt") ||
    "";

  const token = raw ? (raw.startsWith("Bearer ") ? raw : `Bearer ${raw}`) : "";

  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: token } : {}),
  };
}

function safeJson(text) {
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

function MensagemRapidaOpcao({ resposta, favorita = false, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full rounded-2xl border p-3 text-left transition hover:border-blue-300 hover:bg-blue-50 ${
        favorita
          ? "border-amber-200 bg-amber-50/80"
          : "border-slate-200 bg-slate-50"
      }`}
      title={resposta?.titulo || String(resposta?.texto || "").slice(0, 50)}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0 truncate text-xs font-bold text-slate-800">
          {resposta?.titulo || "Mensagem rápida"}
        </div>

        {favorita || resposta?.favorita ? (
          <span className="shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-black text-amber-700 ring-1 ring-amber-200">
            Favorita
          </span>
        ) : null}
      </div>

      <div className="mt-1 text-[10px] font-black uppercase tracking-wide text-blue-600">
        {resposta?.tipo || "Sem tipo"}
      </div>

      <div className="mt-1 line-clamp-3 text-[11px] leading-5 text-slate-500">
        {resposta?.texto}
      </div>
    </button>
  );
}

function ComposerAction({ children, title, active, onClick }) {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border shadow-sm transition hover:-translate-y-0.5 ${
        active
          ? "border-blue-400 bg-blue-50 text-blue-700 ring-4 ring-blue-500/10"
          : "border-slate-300 bg-slate-50 text-slate-600 hover:border-blue-300 hover:bg-blue-50 hover:text-blue-800"
      }`}
    >
      {children}
    </button>
  );
}

function LeadContextSelector({
  conversa,
  leads = [],
  leadContextoId,
  leadContextoAtual,
  salvando = false,
  erro = "",
  onSelect,
}) {
  const lista = Array.isArray(leads) ? leads.filter(Boolean) : [];

  if (lista.length <= 1) return null;

  const selecionadoNome = leadContextoAtual
    ? getNomeLeadVinculada(leadContextoAtual)
    : "";
  const telefone = formatTelefoneHeader(
    conversa?.telefone || conversa?.numero || conversa?.phone || "",
  );

  return (
    <div className="mb-2 flex justify-center">
      <div className="flex w-full max-w-4xl flex-wrap items-center justify-between gap-2 rounded-2xl border border-slate-200 bg-white/90 px-3 py-2 shadow-sm">
        <div className="flex min-w-0 items-center gap-2">
          <span
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-xl ${
              leadContextoId
                ? "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200"
                : "bg-amber-50 text-amber-700 ring-1 ring-amber-200"
            }`}
            title={`${lista.length} pacientes no mesmo WhatsApp${telefone ? ` · ${telefone}` : ""}`}
          >
            <FaUsers size={13} />
          </span>

          <div className="min-w-0">
            <div className="truncate text-xs font-black text-slate-800">
              {leadContextoId
                ? `Paciente: ${selecionadoNome || "selecionado"}`
                : `${lista.length} pacientes neste WhatsApp`}
            </div>
            <div className="truncate text-[10px] font-semibold text-slate-400">
              {leadContextoId
                ? "Contexto definido para o envio"
                : "Escolha antes de enviar"}
            </div>
          </div>
        </div>

        <label className="relative block min-w-[210px] max-w-full flex-1 sm:flex-none">
          <span className="sr-only">Paciente em contexto</span>
          <select
            value={leadContextoId || ""}
            onChange={(event) => onSelect?.(event.target.value)}
            disabled={salvando}
            className={`h-9 w-full rounded-xl border bg-white px-3 pr-8 text-xs font-black outline-none transition disabled:cursor-not-allowed disabled:bg-slate-100 ${
              leadContextoId
                ? "border-emerald-200 text-emerald-800 focus:border-emerald-400 focus:ring-4 focus:ring-emerald-500/10"
                : "border-amber-200 text-amber-800 focus:border-amber-400 focus:ring-4 focus:ring-amber-500/10"
            }`}
            title="Selecionar paciente em contexto"
          >
            <option value="">Selecionar paciente...</option>
            {lista.map((lead) => {
              const leadId = getLeadIdGenerico(lead);
              const nome = getNomeLeadVinculada(lead);
              const status = getPrimeiroValorTexto([
                lead.status_negociacao,
                lead.status_agendamento,
                lead.status,
              ]);

              return (
                <option key={leadId || nome} value={leadId || ""}>
                  {nome || `Lead #${leadId || ""}`}
                  {status ? ` · ${status}` : ""}
                </option>
              );
            })}
          </select>
        </label>

        {erro ? (
          <div className="basis-full rounded-xl border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold text-red-700">
            {erro}
          </div>
        ) : null}
      </div>
    </div>
  );
}

function temItemFollowUpRealChat(item = {}) {
  if (!item || typeof item !== "object") return false;

  const status = normalizarTipoMensagemRapida(
    item._follow_up_status ||
      item.status_followup ||
      item.followup_status ||
      item.status_execucao ||
      item.status ||
      item.situacao ||
      "",
  );

  const temIdReal = Boolean(
    item._followup_chamado_id ||
    item._follow_up_id ||
    item.followup_id ||
    item.followupId ||
    item.id_followup ||
    item.chamado_followup_id,
  );

  const temExecucaoReal = Boolean(
    item.realizado_em ||
    item.executado_em ||
    item.followup_realizado_em ||
    item._follow_up_realizado_em,
  );

  const temStatusReal =
    status.includes("pend") ||
    status.includes("andamento") ||
    status.includes("venc") ||
    status.includes("realiz") ||
    status.includes("execut") ||
    status.includes("cancel");

  return Boolean(
    item._existe_no_banco === true ||
    temIdReal ||
    temExecucaoReal ||
    (temStatusReal && temIdReal),
  );
}

function temFollowUpRealChat(conversa = {}, mensagens = []) {
  if (temItemFollowUpRealChat(conversa)) return true;

  const listasReais = [
    conversa._followups_historico,
    conversa._follow_up_historico,
    conversa.followups_historico,
    conversa.chamado_followups,
    conversa._followup_fluxo_completo,
    conversa._followups_fluxo,
    conversa._follow_up_fluxo,
  ];

  const temListaReal = listasReais.some((lista) => {
    if (!Array.isArray(lista) || lista.length === 0) return false;
    return lista.some((item) => temItemFollowUpRealChat(item));
  });

  if (temListaReal) return true;

  const listaMensagens = Array.isArray(mensagens) ? mensagens : [];

  return listaMensagens.some((mensagem) => temItemFollowUpRealChat(mensagem));
}

function FollowUpStatusOperacionalPanel({ conversa = {}, mensagens = [] }) {
  if (!temFollowUpRealChat(conversa, mensagens)) return null;

  const resumo = getFollowUpResumoOperacionalChat(conversa, mensagens);

  if (!resumo) return null;

  // Follow-up cancelado vira histórico da régua, mas não deve aparecer como
  // ação operacional ativa no chat. O card/lista já mostra "Responder" quando
  // o paciente voltou, e o backend mantém o cancelamento auditável.
  if (resumo.status === "cancelado" || resumo.status === "informativo") {
    return null;
  }

  const realizado =
    resumo.status === "realizado" || resumo.status === "executado";
  const pendente = resumo.status === "pendente" || resumo.status === "vencido";
  const cancelado = resumo.status === "cancelado";

  const visual = realizado
    ? {
        box: "border-emerald-300 bg-gradient-to-br from-emerald-50 via-white to-emerald-50 shadow-emerald-900/10",
        icon: "bg-emerald-600 text-white shadow-emerald-900/20",
        badge: "border-emerald-200 bg-emerald-100 text-emerald-800",
        titulo: `Etapa concluída · ${resumo.titulo || `Follow-up ${resumo.ordem || ""}`}`,
      }
    : cancelado
      ? {
          box: "border-slate-300 bg-gradient-to-br from-slate-50 via-white to-slate-100 shadow-slate-900/8",
          icon: "bg-slate-700 text-white shadow-slate-900/15",
          badge: "border-slate-200 bg-slate-100 text-slate-700",
          titulo: `${resumo.titulo || `Follow-up ${resumo.ordem || ""}`} cancelado`,
        }
      : pendente
        ? {
            box: "border-amber-300 bg-gradient-to-br from-amber-50 via-white to-orange-50 shadow-amber-900/10",
            icon: "bg-amber-500 text-white shadow-amber-900/20",
            badge: "border-amber-200 bg-amber-100 text-amber-800",
            titulo: `${resumo.titulo || `Follow-up ${resumo.ordem || ""}`} pendente`,
          }
        : {
            box: "border-blue-200 bg-gradient-to-br from-blue-50 via-white to-sky-50 shadow-blue-900/10",
            icon: "bg-blue-600 text-white shadow-blue-900/20",
            badge: "border-blue-200 bg-blue-100 text-blue-800",
            titulo: resumo.titulo || "Follow-up comercial",
          };

  return (
    <div className="mb-3 flex justify-center">
      <div
        className={`w-full max-w-4xl overflow-hidden rounded-[26px] border px-4 py-3 shadow-sm ${visual.box}`}
      >
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex min-w-0 items-start gap-3">
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl shadow-sm ${visual.icon}`}
            >
              {realizado ? <FaCheckCircle size={16} /> : <FaBolt size={15} />}
            </span>

            <div className="min-w-0">
              <div className="flex flex-wrap items-center gap-2">
                <h3 className="truncate text-sm font-black text-slate-950">
                  {visual.titulo}
                </h3>
                <span
                  className={`rounded-full border px-2.5 py-1 text-[10px] font-black uppercase tracking-wide ${visual.badge}`}
                >
                  {resumo.statusLabel}
                </span>
              </div>

              <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] font-bold text-slate-600">
                {resumo.data ? (
                  <span>
                    {realizado ? "Concluído em" : "Prazo"}: {resumo.data}
                  </span>
                ) : null}
                {resumo.usuario ? (
                  <>
                    <span className="text-slate-300">•</span>
                    <span>Por: {resumo.usuario}</span>
                  </>
                ) : null}
                {resumo.resultado ? (
                  <>
                    <span className="text-slate-300">•</span>
                    <span>{resumo.resultado}</span>
                  </>
                ) : null}
              </div>

              {resumo.proximaTitulo ? (
                <div className="mt-1 text-[11px] font-semibold text-slate-500">
                  Próxima etapa:{" "}
                  <span className="font-black text-slate-800">
                    {resumo.proximaTitulo}
                  </span>
                  {resumo.proximaData ? ` · ${resumo.proximaData}` : ""}
                </div>
              ) : null}
            </div>
          </div>

          <span className="shrink-0 rounded-2xl border border-white/70 bg-white/75 px-3 py-2 text-[11px] font-black text-slate-700 shadow-sm">
            Fluxo visível no atendimento
          </span>
        </div>
      </div>
    </div>
  );
}

function getFollowUpResumoOperacionalChat(conversa = {}, mensagens = []) {
  if (!temFollowUpRealChat(conversa, mensagens)) return null;

  const candidatos = [];

  const adicionar = (obj = {}, origem = "") => {
    if (!obj || typeof obj !== "object") return;
    if (!temItemFollowUpRealChat(obj)) return;

    const titulo = getPrimeiroValorTexto([
      obj.followup_ultimo_titulo,
      obj.followup_titulo,
      obj.titulo_followup,
      obj._follow_up_ultimo_titulo,
      obj._follow_up_titulo,
      obj._follow_up_etapa_label,
      obj.status_followup,
      obj.titulo,
    ]);
    const status = normalizarTipoMensagemRapida(
      getPrimeiroValorTexto([
        obj.followup_status,
        obj.status_followup,
        obj._follow_up_status,
        obj.status,
        obj.resultado,
      ]),
    );
    const temMarcador = Boolean(
      titulo ||
      obj.followup_ordem ||
      obj._follow_up_etapa ||
      obj._followup_chamado_id ||
      obj._follow_up_id ||
      obj.realizado_em ||
      obj.followup_realizado_em ||
      obj.agendado_para,
    );

    if (!temMarcador) return;

    const realizadoEm = getPrimeiroValorTexto([
      obj.realizado_em,
      obj.followup_realizado_em,
      obj._follow_up_realizado_em,
      obj.executado_em,
      obj.datahora,
    ]);
    const agendadoPara = getPrimeiroValorTexto([
      obj.agendado_para,
      obj._follow_up_liberado_em,
      obj.followup_liberado_em,
      obj.janela_inicio,
    ]);
    const statusFinal =
      status.includes("realiz") ||
      status.includes("execut") ||
      obj.resultado === "mensagem_enviada"
        ? "realizado"
        : status.includes("cancel")
          ? "cancelado"
          : status.includes("pend") ||
              status.includes("venc") ||
              obj._follow_up_pendente
            ? "pendente"
            : realizadoEm && origem === "mensagem"
              ? "realizado"
              : "informativo";

    candidatos.push({
      origem,
      titulo:
        titulo ||
        (obj.followup_ordem || obj._follow_up_etapa
          ? `Follow-up ${obj.followup_ordem || obj._follow_up_etapa}`
          : "Follow-up"),
      ordem:
        obj.followup_ordem ||
        obj._follow_up_etapa ||
        obj._follow_up_ordem ||
        "",
      status: statusFinal,
      statusLabel:
        statusFinal === "realizado"
          ? "Concluída"
          : statusFinal === "cancelado"
            ? "Cancelado"
            : statusFinal === "pendente"
              ? "Pendente"
              : "Registrado",
      data: formatarDataFollowUpChat(
        realizadoEm ||
          agendadoPara ||
          obj.datahora ||
          obj.created_at ||
          obj.updated_at ||
          "",
      ),
      timestamp: parseDataFollowUpChat(
        realizadoEm ||
          agendadoPara ||
          obj.datahora ||
          obj.created_at ||
          obj.updated_at ||
          "",
      ),
      usuario: getPrimeiroValorTexto([
        obj.realizado_por_nome,
        obj.realizadoPorNome,
        obj.usuario_nome,
        obj.autor_nome,
        obj.realizado_por ? `usuário ${obj.realizado_por}` : "",
      ]),
      resultado: limparResultadoFollowUpChat(
        obj.resultado || obj.observacao || "",
      ),
      proximaTitulo: getPrimeiroValorTexto([
        obj._follow_up_proxima_titulo,
        obj.proximo_followup_titulo,
        obj.proxima_etapa_titulo,
      ]),
      proximaData: formatarDataFollowUpChat(
        getPrimeiroValorTexto([
          obj._follow_up_proxima_liberado_em,
          obj.proximo_agendado_para,
          obj.proxima_etapa_em,
        ]),
      ),
    });
  };

  adicionar(conversa, "conversa");

  const listaMensagens = Array.isArray(mensagens) ? mensagens : [];
  for (const mensagem of listaMensagens) {
    adicionar(mensagem, "mensagem");
  }

  if (!candidatos.length) return null;

  const prioridade = {
    pendente: 4,
    realizado: 3,
    informativo: 2,
    cancelado: 1,
  };
  return candidatos.sort((a, b) => {
    const pa = prioridade[a.status] || 0;
    const pb = prioridade[b.status] || 0;
    if (pa !== pb) return pb - pa;
    return (b.timestamp || 0) - (a.timestamp || 0);
  })[0];
}

function limparResultadoFollowUpChat(value = "") {
  const texto = String(value || "").trim();
  if (!texto) return "";
  if (texto === "mensagem_enviada") return "Mensagem enviada";
  return texto.replaceAll("_", " ");
}

function normalizarTipoReguaFollowUpChat(value = "") {
  const bruto = normalizarTipoMensagemRapida(value)
    .replace(/[\s-]+/g, "_")
    .replace(/__+/g, "_");

  if (
    bruto.includes("lead_fria") ||
    bruto.includes("leadfria") ||
    bruto.includes("chamado_frio")
  ) {
    return "lead_fria";
  }

  if (
    bruto === "follow_up" ||
    bruto === "followup" ||
    bruto.includes("agendamento") ||
    bruto.includes("regua_comercial")
  ) {
    return "followup";
  }

  return "";
}

function detectarTipoRegraItemFollowUpChat(item = {}) {
  if (!item || typeof item !== "object") return "";

  const texto = String(
    item.texto || item._follow_up_texto || item.texto_completo || "",
  );

  if (texto.includes("[followup_lead_fria]")) return "lead_fria";

  const candidatos = [
    item.tipo_regua,
    item.tipoRegra,
    item.regra_tipo,
    item.tipo,
    item._follow_up_tipo_regua,
    item._followup_tipo_regua,
    item._follow_up_titulo,
    item.titulo,
    item.nome,
    item._follow_up_etapa_label,
  ];

  for (const candidato of candidatos) {
    const tipo = normalizarTipoReguaFollowUpChat(candidato);
    if (tipo) return tipo;
  }

  return "";
}

function detectarTipoReguaFollowUpChat(
  conversa = {},
  fluxo = [],
  followUpRegras = [],
) {
  const candidatos = [
    conversa,
    ...(Array.isArray(fluxo) ? fluxo : []),
    ...(Array.isArray(conversa?._followups_historico)
      ? conversa._followups_historico
      : []),
    ...(Array.isArray(conversa?._follow_up_historico)
      ? conversa._follow_up_historico
      : []),
    ...(Array.isArray(conversa?.chamado_followups)
      ? conversa.chamado_followups
      : []),
  ];

  for (const item of candidatos) {
    const tipo = detectarTipoRegraItemFollowUpChat(item);
    if (tipo) return tipo;
  }

  const tiposDasRegras = new Set(
    (Array.isArray(followUpRegras) ? followUpRegras : [])
      .map((regra) => detectarTipoRegraItemFollowUpChat(regra))
      .filter(Boolean),
  );

  return tiposDasRegras.size === 1 ? [...tiposDasRegras][0] : "";
}

function getNomeReguaFollowUpChat(tipoRegua = "") {
  return tipoRegua === "lead_fria"
    ? "Régua Lead Fria"
    : tipoRegua === "followup"
      ? "Régua de Follow-up"
      : "Régua de follow-up";
}

function getRegraFollowUpPorOrdemChat(regras = [], ordem = 0, tipoRegua = "") {
  const ordemNumero = Number(ordem || 0);
  if (!ordemNumero) return null;

  const candidatas = (Array.isArray(regras) ? regras : []).filter((regra) => {
    const ordemRegra = Number(regra?.followup_ordem || regra?.ordem || 0);
    if (ordemRegra !== ordemNumero) return false;

    if (!tipoRegua) return true;

    return detectarTipoRegraItemFollowUpChat(regra) === tipoRegua;
  });

  return candidatas[0] || null;
}

function getCanalDaRegraFollowUpChat(regra = null, fallback = "whatsapp") {
  return String(
    regra?.followup_canal || regra?.canal || regra?.tipo_canal || fallback,
  )
    .trim()
    .toLowerCase();
}

function getTotalEtapasReguaFollowUpChat(conversa = {}, followUpRegras = []) {
  const regrasExternas = Array.isArray(followUpRegras) ? followUpRegras : [];

  const ordensRegrasExternas = regrasExternas
    .map((item) => Number(item?.followup_ordem || item?.ordem || 0))
    .filter((value) => Number.isFinite(value) && value > 0);

  const candidatos = [
    conversa.total_regua,
    conversa.total_regras,
    conversa.total_regua_followup,
    conversa.total_regras_followup,
    conversa.total_etapas_followup,
    conversa.quantidade_followups,
    conversa.followup_total_regras,
    conversa._follow_up_total_regras,
    conversa._followup_total_regua,
    conversa._follow_up_regua_total,
    conversa.regua_followup_total,
    regrasExternas.length,
    ordensRegrasExternas.length ? Math.max(...ordensRegrasExternas) : 0,
  ]
    .map((value) => Number(value))
    .filter((value) => Number.isFinite(value) && value > 0);

  const regras =
    conversa._followup_regras ||
    conversa._follow_up_regras ||
    conversa.followup_regras ||
    conversa.regras_followup ||
    [];

  if (Array.isArray(regras) && regras.length) {
    const ordensInternas = regras
      .map((item) => Number(item?.followup_ordem || item?.ordem || 0))
      .filter((value) => Number.isFinite(value) && value > 0);

    candidatos.push(
      regras.length,
      ordensInternas.length ? Math.max(...ordensInternas) : 0,
    );
  }

  const fluxo =
    conversa._followup_fluxo_completo ||
    conversa._followups_fluxo ||
    conversa._follow_up_fluxo ||
    [];

  if (Array.isArray(fluxo) && fluxo.length) {
    candidatos.push(
      fluxo.length,
      ...fluxo.map((item) =>
        Number(
          item?.followup_ordem || item?.ordem || item?._follow_up_ordem || 0,
        ),
      ),
    );
  }

  const validos = candidatos.filter(
    (value) => Number.isFinite(value) && value > 0,
  );

  return validos.length ? Math.max(...validos) : 1;
}

function getCanalOperacionalFollowUpChat(tipoAcao = "mensagem") {
  const ligacao = String(tipoAcao || "").toLowerCase() === "ligacao";

  return ligacao
    ? {
        tipo: "ligacao",
        emoji: "📞",
        canal: "Ligação",
        acao: "Fazer ligação",
        titulo: "Ligação comercial",
        badgeClass: "border-blue-200 bg-blue-50 text-blue-700",
      }
    : {
        tipo: "whatsapp",
        emoji: "💬",
        canal: "WhatsApp",
        acao: "Enviar mensagem ou áudio",
        titulo: "WhatsApp comercial",
        badgeClass: "border-emerald-200 bg-emerald-50 text-emerald-700",
      };
}

function inferirTipoAcaoPorOrdemFollowUpChat({
  ordem,
  etapaAtual,
  tipoAtual,
  tipoProxima,
}) {
  const n = Number(ordem || 0);
  const atual = Number(etapaAtual || 0);

  if (n === atual) return tipoAtual || "mensagem";
  if (n === atual + 1 && tipoProxima) return tipoProxima;

  // Fallback visual quando o backend ainda não enviou todas as regras da régua.
  // O cadastro real continua vindo de mensagem_rapida.followup_canal.
  return n % 2 === 0 ? "ligacao" : "mensagem";
}

function FollowUpProcessPanel({
  conversa = {},
  mensagens = [],
  followUpRegras = [],
  registrandoLigacao = false,
  gerandoProximaEtapa = false,
  onUsarMensagemEtapa,
  onRegistrarLigacao,
  onGerarProximaEtapa,
}) {
  const [detalhesAberto, setDetalhesAberto] = useState(false);

  if (!temFollowUpRealChat(conversa, mensagens)) return null;

  const info = getFollowUpProcessInfo(conversa, mensagens, followUpRegras);

  if (!info.ativo) return null;

  const statusConfig = getFollowUpVisualStatusConfig(info.statusVisual);
  const temaPainel = getTemaPainelFollowUpChat(info.statusVisual);
  const resumoEtapas = resumirEtapasFollowUpChat(info.etapas);
  const etapaAtual =
    info.etapas.find((etapa) => etapa.key === "atual") || info.etapas[1];
  const etapaAtualLabel = etapaAtual?.label || `Etapa ${info.etapaNumero}`;
  const acaoLigacao = info.tipoAcao === "ligacao";
  const tituloAcao = acaoLigacao
    ? "Registrar ligação"
    : `Usar ${info.etapaTitulo || "mensagem"}`;
  const followUpVencido =
    info.statusVisual === "vencido" || info.statusVisual === "pendente";
  const followUpIdAtual = getFollowUpIdConversa(conversa);
  const statusFollowUpAtual = normalizarTipoMensagemRapida(
    conversa?.status_followup ||
      conversa?._follow_up_status ||
      conversa?.status ||
      "",
  );
  const etapaLigacaoSemRegistroPendente = Boolean(
    acaoLigacao &&
    info.etapaJaEncerrada &&
    !info.acaoDisponivel &&
    (!followUpIdAtual ||
      statusFollowUpAtual.includes("realiz") ||
      statusFollowUpAtual.includes("execut")),
  );

  return (
    <div className="mb-3 flex justify-center">
      <div
        className={`w-full max-w-4xl overflow-hidden rounded-[28px] border-2 bg-white font-sans antialiased shadow-[0_18px_42px_rgba(15,23,42,0.16)] ring-1 ${temaPainel.container}`}
      >
        <div
          className={`relative overflow-hidden border-b bg-gradient-to-br px-4 py-4 ${temaPainel.header}`}
        >
          <div className="pointer-events-none absolute -right-10 -top-14 h-32 w-32 rounded-full bg-orange-300/25 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-16 left-8 h-32 w-32 rounded-full bg-blue-300/15 blur-2xl" />

          <div className="relative flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1.5 rounded-full border-2 border-amber-400 bg-white/95 px-2.5 py-1 text-[10px] font-semibold tracking-normal text-amber-800 shadow-sm">
                  <FaBolt size={11} />
                  {info.nomeRegua || "Régua de follow-up"}
                </span>

                <span
                  className={`inline-flex items-center gap-1.5 rounded-full border-2 px-2.5 py-1 text-[10px] font-semibold tracking-normal shadow-sm ${statusConfig.badge}`}
                  title={statusConfig.title}
                >
                  {statusConfig.icon}
                  {statusConfig.label}
                </span>

                <span
                  className={`inline-flex items-center gap-1.5 rounded-full border-2 px-2.5 py-1 text-[10px] font-semibold tracking-normal shadow-sm ${
                    acaoLigacao
                      ? "border-blue-200 bg-blue-50 text-blue-700"
                      : "border-emerald-200 bg-emerald-50 text-emerald-700"
                  }`}
                >
                  {info.canalOperacional?.emoji || (acaoLigacao ? "📞" : "💬")}
                  {info.canalOperacional?.canal ||
                    (acaoLigacao ? "Ligação" : "WhatsApp")}
                </span>
              </div>

              <div className="mt-3 flex flex-wrap gap-1.5 text-[10px] font-bold">
                {resumoEtapas.realizadas > 0 ? (
                  <span className="rounded-full border border-emerald-200 bg-emerald-50 px-2 py-1 text-emerald-800">
                    ✓ {resumoEtapas.realizadas} concluída
                    {resumoEtapas.realizadas === 1 ? "" : "s"}
                  </span>
                ) : null}
                {resumoEtapas.canceladas > 0 ? (
                  <span className="rounded-full border border-rose-200 bg-rose-50 px-2 py-1 text-rose-800">
                    × {resumoEtapas.canceladas} interrompida
                    {resumoEtapas.canceladas === 1 ? "" : "s"}
                  </span>
                ) : null}
                {resumoEtapas.atrasadas > 0 ? (
                  <span className="rounded-full border border-orange-200 bg-orange-50 px-2 py-1 text-orange-900">
                    ! {resumoEtapas.atrasadas} atrasada
                    {resumoEtapas.atrasadas === 1 ? "" : "s"}
                  </span>
                ) : null}
                {resumoEtapas.aguardando > 0 ? (
                  <span className="rounded-full border border-blue-200 bg-blue-50 px-2 py-1 text-blue-800">
                    ● {resumoEtapas.aguardando} ativa
                    {resumoEtapas.aguardando === 1 ? "" : "s"}
                  </span>
                ) : null}
              </div>

              <div className="mt-3 flex min-w-0 flex-col gap-1">
                <h3 className="truncate text-[15px] font-semibold leading-tight text-slate-950">
                  Tentativa {info.etapaNumero} de {info.totalEtapas}
                </h3>

                <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[12px] font-semibold text-slate-800">
                  <span>{info.canalOperacional?.emoji}</span>
                  <span>{info.canalOperacional?.canal}</span>
                  <span className="text-slate-300">·</span>
                  <span>{info.canalOperacional?.acao}</span>
                </div>

                <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] font-bold text-slate-600">
                  {info.dataEtapa ? (
                    <span className="inline-flex items-center gap-1 text-amber-800">
                      <FaRegClock size={11} />
                      Libera em: {info.dataEtapa}
                    </span>
                  ) : null}
                  {info.dataEtapa ? (
                    <span className="text-amber-300">•</span>
                  ) : null}
                  <span className="text-slate-500">{info.descricao}</span>
                </div>
              </div>
            </div>

            <div className="flex shrink-0 flex-wrap items-center gap-2 lg:justify-end">
              {acaoLigacao ? (
                <div className="flex flex-col items-stretch gap-1.5">
                  <button
                    type="button"
                    onClick={
                      info.acaoDisponivel
                        ? onRegistrarLigacao || onUsarMensagemEtapa
                        : etapaLigacaoSemRegistroPendente
                          ? onGerarProximaEtapa
                          : undefined
                    }
                    disabled={
                      registrandoLigacao ||
                      gerandoProximaEtapa ||
                      (!info.acaoDisponivel && !etapaLigacaoSemRegistroPendente)
                    }
                    className={`inline-flex h-10 items-center justify-center gap-2 rounded-2xl border px-4 text-xs font-semibold shadow-[0_12px_26px_rgba(29,78,216,0.20)] transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:shadow-none ${
                      info.acaoDisponivel
                        ? "border-blue-700 bg-blue-700 text-white hover:bg-blue-800"
                        : etapaLigacaoSemRegistroPendente
                          ? "border-2 border-orange-600 bg-orange-500 text-white hover:bg-orange-600"
                          : "border-slate-300 bg-slate-100 text-slate-500"
                    }`}
                    title={
                      info.acaoDisponivel
                        ? "Registrar data e hora da ligação realizada"
                        : etapaLigacaoSemRegistroPendente
                          ? "Criar ou atualizar a próxima etapa de ligação no follow-up"
                          : info.mensagemBloqueioAcao ||
                            "A ligação ainda não está pendente. Aguarde o prazo vencer."
                    }
                  >
                    <FaPhoneAlt size={13} />
                    {registrandoLigacao
                      ? "Registrando..."
                      : gerandoProximaEtapa
                        ? "Atualizando..."
                        : info.acaoDisponivel
                          ? "Registrar ligação"
                          : etapaLigacaoSemRegistroPendente
                            ? "Gerar etapa de ligação"
                            : "Aguardando liberação"}
                  </button>
                  {!info.acaoDisponivel ? (
                    <span className="text-center text-[10px] font-bold leading-4 text-slate-500">
                      {etapaLigacaoSemRegistroPendente
                        ? "A etapa 1 já foi feita. Clique para criar/carregar a etapa 2 quando ela já estiver vencida."
                        : "A etapa 2 ainda não está criada como pendente. Gere a próxima etapa para liberar o registro."}
                    </span>
                  ) : null}
                </div>
              ) : info.acaoDisponivel ? (
                <button
                  type="button"
                  onClick={onUsarMensagemEtapa}
                  className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl border-2 border-emerald-700 bg-[#25D366] px-4 text-xs font-semibold text-white shadow-[0_12px_26px_rgba(22,163,74,0.20)] transition hover:-translate-y-0.5 hover:bg-[#1FB85A]"
                >
                  <FaCommentDots size={13} />
                  {info.canalOperacional?.acao || tituloAcao}
                </button>
              ) : (
                <span
                  className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl border-2 border-slate-400 bg-white px-4 text-xs font-semibold text-slate-500 shadow-sm"
                  title={info.mensagemBloqueioAcao}
                >
                  <FaRegClock size={13} />
                  Aguardando liberação
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-slate-200 bg-gradient-to-b from-white to-slate-50/60 px-4 py-4">
          <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 xl:grid-cols-5">
            {info.etapas.map((etapa) => (
              <div
                key={etapa.key}
                className={`rounded-[22px] border-2 px-3 py-3 shadow-sm ${etapa.className}`}
                title={etapa.title}
              >
                <div className="flex items-center justify-between gap-2">
                  <div className="truncate text-[10px] font-semibold tracking-normal opacity-75">
                    {etapa.statusIcon} {etapa.ordem}/{info.totalEtapas}
                  </div>
                  <span className="shrink-0 rounded-full bg-white/60 px-2 py-0.5 text-[9px] font-semibold ring-1 ring-black/5">
                    {etapa.badge}
                  </span>
                </div>
                <div className="mt-1.5 truncate text-xs font-semibold">
                  {etapa.emoji} {etapa.canal}
                </div>
                <div className="mt-0.5 truncate text-[11px] font-semibold opacity-85">
                  {etapa.acao}
                </div>
                {etapa.estado === "realizada" ? (
                  <div className="mt-2 inline-flex max-w-full items-center gap-1.5 rounded-xl bg-emerald-600 px-2 py-1 text-[10px] font-black text-white shadow-sm">
                    <FaCheckCircle size={10} />
                    Etapa concluída
                  </div>
                ) : null}
                {etapa.data ? (
                  <div className="mt-1 truncate text-[10px] font-semibold opacity-75">
                    {etapa.data}
                  </div>
                ) : null}
                {etapa.motivo ? (
                  <div
                    className="mt-1 line-clamp-1 text-[10px] font-bold opacity-80"
                    title={etapa.motivo}
                  >
                    {etapa.motivo}
                  </div>
                ) : null}
              </div>
            ))}
          </div>

          {info.tipoAcao === "ligacao" ? (
            <div
              className={`mt-3 rounded-[22px] border-2 px-3 py-3 text-xs font-semibold leading-5 shadow-sm ${info.statusVisual === "vencido" ? "border-orange-300 bg-orange-50 text-orange-900" : "border-blue-300 bg-blue-50 text-blue-800"}`}
            >
              <span className="font-semibold">Ação obrigatória:</span> faça a
              ligação e registre por aqui. O horário fica salvo para conferência
              na central de ligações.
            </div>
          ) : info.textoSugerido ? (
            <div className="mt-3 rounded-[22px] border border-amber-200 bg-white px-3 py-3 text-xs font-semibold leading-5 text-slate-600 shadow-sm">
              <div className="flex items-center justify-between gap-2 border-b border-amber-100 pb-2">
                <span className="font-semibold text-slate-900">
                  Mensagem da etapa
                </span>
                <button
                  type="button"
                  onClick={() => setDetalhesAberto((atual) => !atual)}
                  className="shrink-0 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-[10px] font-semibold text-amber-800 transition hover:border-amber-300 hover:bg-amber-100"
                >
                  {detalhesAberto ? "Ocultar" : "Ver completa"}
                </button>
              </div>

              <div
                className={`mt-2 text-slate-700 ${detalhesAberto ? "whitespace-pre-wrap" : "line-clamp-2"}`}
              >
                {detalhesAberto
                  ? info.textoCompleto || info.textoSugerido
                  : info.textoSugerido}
              </div>
            </div>
          ) : null}

          <details className="mt-3 rounded-[22px] border border-slate-200 bg-white px-3 py-2 text-[11px] font-semibold leading-5 text-slate-600 shadow-sm">
            <summary className="cursor-pointer select-none font-semibold text-slate-800">
              Como esta regra funciona
            </summary>
            <div className="mt-1">
              A régua mostra a tentativa atual, o canal e a ação prática.
              WhatsApp permite mensagem ou áudio. Ligação precisa ser registrada
              com data e hora para avançar a cadência.
            </div>
          </details>
        </div>
      </div>
    </div>
  );
}

function getFollowUpIdConversa(conversa = {}) {
  const statusNormalizado = normalizarTipoMensagemRapida(
    conversa.status_followup ||
      conversa.status ||
      conversa._follow_up_status ||
      "",
  );
  const etapaEncerrada =
    statusNormalizado.includes("execut") ||
    statusNormalizado.includes("realiz") ||
    statusNormalizado.includes("respond");

  if (etapaEncerrada) {
    const proximoId =
      conversa._follow_up_proxima_id ||
      conversa._follow_up_next_id ||
      conversa.proximo_followup_id ||
      conversa.proxima_etapa_id ||
      conversa.next_followup_id ||
      null;

    // Se a etapa atual já foi realizada, nunca reutilize o ID antigo.
    // Registrar novamente o mesmo ID gera "Follow-up não encontrado ou não está pendente".
    return proximoId || null;
  }

  return (
    conversa._followup_chamado_id ||
    conversa._follow_up_id ||
    conversa.followup_id ||
    conversa.followupId ||
    conversa.id_followup ||
    conversa.chamado_followup_id ||
    null
  );
}

function getTipoAcaoFollowUpChat(conversa = {}) {
  const bruto = normalizarTipoMensagemRapida(
    conversa._follow_up_canal ||
      conversa.canal_followup ||
      conversa.tipo_acao ||
      conversa.tipoAcao ||
      conversa._follow_up_tipo_mensagem ||
      conversa._follow_up_mensagem_rapida_tipo ||
      conversa._follow_up_etapa_label ||
      conversa._follow_up_titulo ||
      conversa.status_followup ||
      "",
  );

  if (
    bruto.includes("ligacao") ||
    bruto.includes("telefon") ||
    bruto.includes("call") ||
    bruto.includes("phone")
  ) {
    return "ligacao";
  }

  return "mensagem";
}

async function registrarExecucaoFollowUpChat({
  followUpId,
  empresaId,
  conversa = {},
  realizadoEm,
  resultado = "realizado",
  observacao = "",
}) {
  const payload = {
    empresa_id: empresaId,
    followup_id: followUpId,
    chamado_id: conversa?.chamado_id || conversa?.id_chamado || null,
    lead_id:
      conversa?.lead_contexto_id ||
      conversa?.leadContextoId ||
      conversa?.lead_id ||
      conversa?.leadId ||
      conversa?.lead?.id ||
      null,
    telefone: conversa?.telefone || conversa?.numero || "",
    resultado,
    observacao,
    realizado_em: realizadoEm,
    executado_em: realizadoEm,
    tipo_execucao: "ligacao",
  };

  return requestJsonComFallback(
    [
      `/followup-whatsapp/${followUpId}/realizar`,
      `/api/followup-whatsapp/${followUpId}/realizar`,
      `/followup-whatsapp/${followUpId}/executar`,
      `/api/followup-whatsapp/${followUpId}/executar`,
    ],
    payload,
  );
}

function selecionarCicloLeadFriaAtivoChat(lista = []) {
  const itens = Array.isArray(lista) ? lista.filter(Boolean) : [];

  const ehLeadFria = (item = {}) => {
    const tipo = detectarTipoRegraItemFollowUpChat(item);
    const ciclo = Number(item?.ciclo_id || item?.cicloId || 0);
    const texto = String(item?.texto || item?._follow_up_texto || "");

    return (
      tipo === "lead_fria" ||
      ciclo > 0 ||
      texto.includes("[followup_lead_fria]")
    );
  };

  const itensLeadFria = itens.filter(ehLeadFria);

  if (!itensLeadFria.length) return itens;

  const ordenarMaisRecente = (a, b) => {
    const cicloA = Number(a?.ciclo_id || a?.cicloId || 0);
    const cicloB = Number(b?.ciclo_id || b?.cicloId || 0);
    if (cicloA !== cicloB) return cicloB - cicloA;

    const dataA = parseDataFollowUpChat(
      a?.agendado_para || a?.criado_em || a?.atualizado_em || "",
    );
    const dataB = parseDataFollowUpChat(
      b?.agendado_para || b?.criado_em || b?.atualizado_em || "",
    );

    return dataB - dataA;
  };

  const pendente = itensLeadFria
    .filter((item) =>
      ["pendente", "em_andamento"].includes(
        String(item?.status || "").toLowerCase(),
      ),
    )
    .sort(ordenarMaisRecente)[0];

  const referencia = pendente || [...itensLeadFria].sort(ordenarMaisRecente)[0];
  const cicloAtivo = Number(referencia?.ciclo_id || referencia?.cicloId || 0);

  // Histórico anterior à coluna ciclo_id não pode ser separado com segurança.
  // Nesse caso, preservamos os registros legados para auditoria visual.
  if (!cicloAtivo) return itens;

  // Em ciclos novos, a régua mostra apenas as etapas do ciclo pendente/mais
  // recente. Isso impede que #1 de um ciclo antigo sobrescreva #1 do ciclo
  // atual na mesma timeline.
  return itens.filter(
    (item) =>
      !ehLeadFria(item) ||
      Number(item?.ciclo_id || item?.cicloId || 0) === cicloAtivo,
  );
}

function getFluxoFollowUpOperacionalChat(conversa = {}) {
  if (!temFollowUpRealChat(conversa)) return [];

  const normalizarItemFluxo = (item = {}, origem = "historico") => {
    if (!item) return null;

    const ordem = Number(
      item._follow_up_ordem ||
        item.followup_ordem ||
        item.ordem ||
        item.etapa ||
        0,
    );

    const id =
      item._follow_up_id ||
      item._followup_chamado_id ||
      item.followup_id ||
      item.id ||
      null;

    if (!ordem && !id) return null;

    const status = String(
      item._follow_up_status ||
        item.status_followup ||
        item.status ||
        (origem === "regra" ? "futura" : "pendente"),
    ).toLowerCase();

    const canal = String(
      item._follow_up_canal ||
        item.followup_canal ||
        item.canal ||
        item.tipo_canal ||
        "whatsapp",
    ).toLowerCase();

    return {
      ...item,
      id,
      ordem,
      followup_ordem: ordem,
      canal,
      followup_canal: canal,
      status,
      titulo:
        item._follow_up_titulo ||
        item.titulo ||
        item.nome ||
        `Tentativa ${ordem || ""}`.trim(),
      texto:
        item._follow_up_texto ||
        item.texto ||
        item.mensagem ||
        item.conteudo ||
        "",
      agendado_para:
        item._follow_up_liberado_em ||
        item.agendado_para ||
        item.janela_inicio ||
        item.liberado_em ||
        item.created_at ||
        "",
      realizado_em:
        item._follow_up_realizado_em ||
        item.realizado_em ||
        item.executado_em ||
        null,
      realizado_por:
        item._follow_up_realizado_por ||
        item.realizado_por ||
        item.executado_por ||
        null,
      cancelado_em:
        item._follow_up_cancelado_em ||
        item.cancelado_em ||
        item.cancelled_at ||
        null,
      cancelado_motivo:
        item._follow_up_cancelado_motivo ||
        item.cancelado_motivo ||
        item.cancel_reason ||
        "",
      resultado: item._follow_up_resultado || item.resultado || "",
      observacao: item._follow_up_observacao || item.observacao || "",
      _origem_fluxo: origem,
      _existe_no_banco: Boolean(
        origem === "historico" ||
        item._existe_no_banco === true ||
        item._followup_chamado_id ||
        item._follow_up_id ||
        item.followup_id ||
        item.followupId ||
        item.id_followup ||
        item.chamado_followup_id ||
        item.realizado_em ||
        item.executado_em ||
        item._follow_up_realizado_em,
      ),
    };
  };

  const regrasRaw = [];

  const historicoRaw = [
    ...(Array.isArray(conversa._followups_historico)
      ? conversa._followups_historico
      : []),
    ...(Array.isArray(conversa._follow_up_historico)
      ? conversa._follow_up_historico
      : []),
    ...(Array.isArray(conversa.followups_historico)
      ? conversa.followups_historico
      : []),
    ...(Array.isArray(conversa.chamado_followups)
      ? conversa.chamado_followups
      : []),
  ];

  const fluxoRaw = [
    ...(Array.isArray(conversa._followup_fluxo_completo)
      ? conversa._followup_fluxo_completo
      : []),
    ...(Array.isArray(conversa._followups_fluxo)
      ? conversa._followups_fluxo
      : []),
    ...(Array.isArray(conversa._follow_up_fluxo)
      ? conversa._follow_up_fluxo
      : []),
  ];

  const historicoSelecionado = selecionarCicloLeadFriaAtivoChat(historicoRaw);
  const fluxoSelecionado = selecionarCicloLeadFriaAtivoChat(fluxoRaw);

  const porOrdem = new Map();

  // Regras cadastradas não criam painel de follow-up.
  // O painel só aparece quando existe chamado_followup/histórico real.

  // 2) Depois usa o fluxo vindo do CaptaZap como complemento visual.
  // Não pode sobrescrever histórico real já conhecido com regra "futura".
  for (const bruto of fluxoSelecionado) {
    const item = normalizarItemFluxo(
      bruto,
      bruto?._existe_no_banco ? "historico" : "fluxo",
    );
    if (!item?.ordem) continue;

    const atual = porOrdem.get(item.ordem);
    const itemEhReal = Boolean(
      item._existe_no_banco ||
      ["pendente", "em_andamento", "realizado", "cancelado"].includes(
        item.status,
      ),
    );

    if (!atual || itemEhReal || atual.status === "futura") {
      porOrdem.set(item.ordem, {
        ...(atual || {}),
        ...item,
        titulo: atual?.titulo || item.titulo,
        texto: item.texto || atual?.texto || "",
      });
    }
  }

  // 3) Por último, o histórico real do banco SEMPRE vence.
  // É ele que define ✓ feito, ● atual e datas reais.
  for (const bruto of historicoSelecionado) {
    const item = normalizarItemFluxo(bruto, "historico");
    if (!item?.ordem) continue;

    const atual = porOrdem.get(item.ordem);

    porOrdem.set(item.ordem, {
      ...(atual || {}),
      ...item,
      titulo: atual?.titulo || item.titulo,
      texto: item.texto || atual?.texto || "",
      _existe_no_banco: true,
    });
  }

  // 4) Se não veio lista, usa o próprio objeto da conversa como fallback.
  if (!porOrdem.size) {
    const unico = normalizarItemFluxo(conversa, "historico");
    if (unico?.ordem || unico?.id) {
      porOrdem.set(unico.ordem || 1, unico);
    }
  }

  return [...porOrdem.values()]
    .filter((item) => item.ordem || item.id)
    .sort((a, b) => {
      if (a.ordem !== b.ordem) return a.ordem - b.ordem;
      return Number(a.id || 0) - Number(b.id || 0);
    });
}

function getDetalheCancelamentoFollowUpChat(item = {}) {
  const bruto = String(
    item?.cancelado_motivo ||
      item?._follow_up_cancelado_motivo ||
      item?.observacao ||
      "",
  ).trim();
  const normalizado = normalizarTipoMensagemRapida(bruto);

  if (
    normalizado.includes("cliente respondeu") ||
    normalizado.includes("lead reaquecida") ||
    normalizado.includes("paciente respondeu")
  ) {
    return {
      titulo: "Cliente respondeu",
      detalhe: "Cadência interrompida automaticamente",
    };
  }

  if (
    normalizado.includes("virou lead") ||
    normalizado.includes("convertido em lead") ||
    normalizado.includes("conversao")
  ) {
    return {
      titulo: "Convertido em lead",
      detalhe: "Controle passou para o fluxo do CRM",
    };
  }

  if (normalizado.includes("chamado fechado")) {
    return {
      titulo: "Chamado fechado",
      detalhe: "Cadência encerrada",
    };
  }

  if (
    normalizado.includes("descart") ||
    normalizado.includes("perdid") ||
    normalizado.includes("opt out")
  ) {
    return {
      titulo: "Encerrada",
      detalhe: bruto || "Cadência encerrada manualmente",
    };
  }

  return {
    titulo: "Cancelada",
    detalhe: bruto || "Etapa interrompida",
  };
}

function getEstadoEtapaFollowUpChat({
  status = "",
  isAtual = false,
  agendadoPara = "",
} = {}) {
  const statusNormalizado = String(status || "").toLowerCase();
  const vencimento = parseDataFollowUpChat(agendadoPara);
  const atrasada = Boolean(
    ["pendente", "em_andamento"].includes(statusNormalizado) &&
    vencimento &&
    vencimento < Date.now(),
  );

  if (statusNormalizado === "realizado") return "realizada";
  if (statusNormalizado === "cancelado") return "cancelada";
  if (atrasada) return "atrasada";
  if (isAtual) return "atual";
  if (["pendente", "em_andamento"].includes(statusNormalizado)) {
    return "aguardando";
  }
  return "futura";
}

function getVisualEstadoEtapaFollowUpChat(estado = "futura") {
  const visuais = {
    realizada: {
      badge: "Concluída",
      icon: "✓",
      className:
        "border-emerald-500 bg-emerald-50 text-emerald-950 ring-2 ring-emerald-200",
      title: "Etapa concluída pelo captador",
    },
    cancelada: {
      badge: "Interrompida",
      icon: "×",
      className: "border-rose-400 bg-rose-50 text-rose-950",
      title: "Cadência interrompida",
    },
    atrasada: {
      badge: "Atrasada",
      icon: "!",
      className:
        "border-orange-500 bg-orange-50 text-orange-950 ring-2 ring-orange-200",
      title: "Etapa venceu e precisa de ação agora",
    },
    atual: {
      badge: "Atual",
      icon: "●",
      className:
        "border-blue-500 bg-blue-50 text-blue-950 ring-2 ring-blue-200",
      title: "Etapa atual da cadência",
    },
    aguardando: {
      badge: "Aguardando",
      icon: "◷",
      className: "border-sky-300 bg-sky-50 text-sky-950",
      title: "Etapa criada, aguardando o horário de liberação",
    },
    futura: {
      badge: "Futura",
      icon: "○",
      className: "border-slate-300 bg-slate-50 text-slate-700",
      title: "Etapa que ainda será criada pela cadência",
    },
  };

  return visuais[estado] || visuais.futura;
}

function resumirEtapasFollowUpChat(etapas = []) {
  const resumo = {
    realizadas: 0,
    canceladas: 0,
    atrasadas: 0,
    aguardando: 0,
    futuras: 0,
  };

  for (const etapa of Array.isArray(etapas) ? etapas : []) {
    const estado = String(etapa?.estado || "");
    if (estado === "realizada") resumo.realizadas += 1;
    else if (estado === "cancelada") resumo.canceladas += 1;
    else if (estado === "atrasada") resumo.atrasadas += 1;
    else if (estado === "atual" || estado === "aguardando") {
      resumo.aguardando += 1;
    } else if (estado === "futura") resumo.futuras += 1;
  }

  return resumo;
}

function getTemaPainelFollowUpChat(statusVisual = "aguardando") {
  if (statusVisual === "vencido" || statusVisual === "pendente") {
    return {
      container: "border-orange-400 ring-orange-200",
      header: "from-orange-100 via-amber-50 to-white border-orange-200",
    };
  }

  if (statusVisual === "executado") {
    return {
      container: "border-emerald-400 ring-emerald-200",
      header: "from-emerald-100 via-emerald-50 to-white border-emerald-200",
    };
  }

  return {
    container: "border-blue-300 ring-blue-100",
    header: "from-blue-100 via-sky-50 to-white border-blue-200",
  };
}

function montarEtapasDoHistoricoFollowUpChat({
  fluxo = [],
  atual = null,
  totalEtapas = 0,
  regras = [],
  tipoRegua = "",
  nomeRegua = "Régua de follow-up",
} = {}) {
  const total = Math.max(1, Number(totalEtapas || 1));
  const porOrdem = new Map();

  for (const item of fluxo || []) {
    const ordem = Number(item?.ordem || item?.followup_ordem || 0);
    if (!ordem) continue;
    porOrdem.set(ordem, item);
  }

  const ordemAtual = Number(atual?.ordem || atual?.followup_ordem || 1) || 1;
  const ate = Math.min(
    total,
    Math.max(ordemAtual + 2, ...Array.from(porOrdem.keys(), Number), 5),
  );
  const etapas = [];

  for (let ordem = 1; ordem <= ate; ordem += 1) {
    const regra = getRegraFollowUpPorOrdemChat(regras, ordem, tipoRegua);
    const itemExistente = porOrdem.get(ordem) || null;
    const itemEhReal = Boolean(
      itemExistente?._existe_no_banco ||
      ["pendente", "em_andamento", "realizado", "cancelado"].includes(
        String(itemExistente?.status || "").toLowerCase(),
      ),
    );

    const item = itemExistente || {
      ordem,
      status: "futura",
      canal: getCanalDaRegraFollowUpChat(regra, "whatsapp"),
      titulo: regra?.titulo || `Tentativa ${ordem}`,
      texto: regra?.texto || "",
    };

    const canalBase = itemEhReal
      ? item.canal
      : getCanalDaRegraFollowUpChat(regra, item.canal || "whatsapp");
    const tituloBase = itemEhReal
      ? item.titulo || regra?.titulo
      : regra?.titulo || item.titulo;
    const isAtual =
      atual &&
      String(item.id || item.ordem) === String(atual.id || atual.ordem);
    const estado = getEstadoEtapaFollowUpChat({
      status: item.status,
      isAtual,
      agendadoPara: item.agendado_para,
    });
    const visual = getVisualEstadoEtapaFollowUpChat(estado);
    const cancelamento =
      estado === "cancelada" ? getDetalheCancelamentoFollowUpChat(item) : null;
    const tipoAcao = getTipoAcaoFollowUpChat({
      _follow_up_canal: canalBase,
      _follow_up_titulo: tituloBase,
    });
    const canal = getCanalOperacionalFollowUpChat(tipoAcao);

    let acao = canal.acao;
    let data = "";

    if (estado === "realizada") {
      acao = "Etapa concluída";
      data = item.realizado_em
        ? `Concluída em: ${formatarDataFollowUpChat(item.realizado_em)}`
        : "Conclusão registrada";
    } else if (estado === "cancelada") {
      acao = cancelamento?.titulo || "Etapa interrompida";
      data = item.cancelado_em
        ? `Interrompida em: ${formatarDataFollowUpChat(item.cancelado_em)}`
        : cancelamento?.detalhe || "Cadência interrompida";
    } else if (estado === "atrasada") {
      acao = tipoAcao === "ligacao" ? "Ligar agora" : "Enviar agora";
      data = item.agendado_para
        ? `Venceu em: ${formatarDataFollowUpChat(item.agendado_para)}`
        : "Prazo vencido";
    } else if (estado === "atual" || estado === "aguardando") {
      data = item.agendado_para
        ? `Libera em: ${formatarDataFollowUpChat(item.agendado_para)}`
        : "Aguardando liberação";
    } else {
      data = ordem > ordemAtual ? "Ainda não criada" : "Próxima regra";
    }

    etapas.push({
      key: `fluxo-${item.id || ordem}`,
      ordem,
      estado,
      statusIcon: visual.icon,
      badge: visual.badge,
      label: `Tentativa ${ordem}`,
      titulo: tituloBase || `Tentativa ${ordem}`,
      emoji: canal.emoji,
      canal: canal.canal,
      acao,
      data,
      className: visual.className,
      title: `${ordem}/${total} · ${visual.title} · ${tituloBase || canal.canal}`,
      motivo: cancelamento?.detalhe || "",
    });
  }

  if (ate < total) {
    etapas.push({
      key: "fluxo-restante",
      ordem: ate + 1,
      estado: "futura",
      statusIcon: "…",
      badge: `+${total - ate} próximas`,
      label: "Próximas tentativas",
      titulo: `Continuação · ${nomeRegua}`,
      emoji: "↳",
      canal: nomeRegua,
      acao: `${total - ate} tentativa${total - ate === 1 ? "" : "s"} futura${total - ate === 1 ? "" : "s"}`,
      data: "Serão criadas conforme a cadência",
      className: "border-slate-300 bg-slate-50 text-slate-600",
      title: `Restam ${total - ate} etapas em ${nomeRegua}`,
      motivo: "",
    });
  }

  return etapas;
}

function getFollowUpProcessInfoFromFluxo(
  conversa = {},
  mensagens = [],
  fluxo = [],
  followUpRegras = [],
) {
  const agora = Date.now();
  const tipoRegua = detectarTipoReguaFollowUpChat(
    conversa,
    fluxo,
    followUpRegras,
  );
  const nomeRegua = getNomeReguaFollowUpChat(tipoRegua);
  const pendentes = fluxo.filter((item) =>
    ["pendente", "em_andamento"].includes(
      String(item.status || "").toLowerCase(),
    ),
  );
  const realizados = fluxo.filter(
    (item) => String(item.status || "").toLowerCase() === "realizado",
  );

  // Sem etapa pendente/em andamento não existe ação operacional para o captador.
  // Etapas canceladas por paciente_respondeu/chamado_fechado/opt_out ficam só
  // como histórico e não devem abrir o painel de régua ativa.
  if (!pendentes.length) return null;
  const ultimaOrdemRealizada = Math.max(
    0,
    ...realizados.map((item) => Number(item.ordem || item.followup_ordem || 0)),
  );

  // A etapa atual deve ser a primeira pendente depois da última concluída.
  // Isso impede voltar para "Tentativa 1" quando já existem etapas realizadas.
  const pendenteDepoisDaUltimaRealizada = pendentes.find(
    (item) =>
      Number(item.ordem || item.followup_ordem || 0) > ultimaOrdemRealizada,
  );

  const atual =
    pendenteDepoisDaUltimaRealizada ||
    pendentes[0] ||
    fluxo.find(
      (item) =>
        String(item.status || "").toLowerCase() === "futura" &&
        Number(item.ordem || item.followup_ordem || 0) > ultimaOrdemRealizada,
    ) ||
    realizados[realizados.length - 1] ||
    fluxo[0];

  if (!atual) return null;

  const liberadoTimestamp = parseDataFollowUpChat(atual.agendado_para);
  const vencido = liberadoTimestamp ? liberadoTimestamp <= agora : true;
  const statusAtual = String(atual.status || "pendente").toLowerCase();
  const tipoAcao = getTipoAcaoFollowUpChat({
    _follow_up_canal: atual.canal,
    _follow_up_titulo: atual.titulo,
    _follow_up_tipo_mensagem: atual.titulo,
  });
  const canalOperacional = getCanalOperacionalFollowUpChat(tipoAcao);
  const totalEtapas = Math.max(
    fluxo.length,
    ...fluxo.map((item) => Number(item.ordem || 0)),
    getTotalEtapasReguaFollowUpChat(conversa, followUpRegras),
  );

  let statusVisual = "aguardando";
  if (statusAtual === "realizado") statusVisual = "executado";
  else if (statusAtual === "cancelado") statusVisual = "perdido";
  else if (vencido) statusVisual = "vencido";

  const etapaNumero = Number(atual.ordem || 1);
  const textoCompleto = limparMarcadoresTecnicosFollowUpChat(atual.texto || "");
  const etapas = montarEtapasDoHistoricoFollowUpChat({
    fluxo,
    atual,
    totalEtapas,
    regras: followUpRegras,
    tipoRegua,
    nomeRegua,
  });
  const dataEtapa = atual.agendado_para
    ? formatarDataFollowUpChat(atual.agendado_para)
    : "";

  return {
    ativo: true,
    followupId: atual.id || atual.followup_id || null,
    cicloId: atual.ciclo_id || atual.cicloId || null,
    etapaNumero,
    etapaTitulo: atual.titulo || `Tentativa ${etapaNumero}`,
    tipoRegua,
    nomeRegua,
    totalEtapas,
    canalOperacional,
    statusVisual,
    descricao:
      statusVisual === "vencido"
        ? `Etapa atrasada — ${canalOperacional.acao.toLowerCase()} agora.`
        : statusVisual === "aguardando"
          ? "A próxima ação ainda não liberou."
          : statusVisual === "executado"
            ? "Tentativa concluída."
            : "Cadência chegou em ponto de decisão.",
    dataEtapa,
    textoSugerido: limitarTextoFollowUpChat(textoCompleto, 180),
    textoCompleto,
    tipoMensagem: atual.titulo || `Tentativa ${etapaNumero}`,
    tipoAcao,
    etapas,
    acaoDisponivel: Boolean(
      statusVisual === "vencido" && (tipoAcao === "ligacao" || textoCompleto),
    ),
    mensagemBloqueioAcao:
      statusVisual === "aguardando"
        ? "A etapa ainda não venceu. Ela só deve ser executada quando aparecer como pendente."
        : "Esta etapa não está disponível para execução.",
    etapaJaEncerrada: statusVisual === "executado",
  };
}

function getFollowUpProcessInfo(
  conversa = {},
  mensagens = [],
  followUpRegras = [],
) {
  if (!temFollowUpRealChat(conversa, mensagens)) {
    return { ativo: false };
  }

  const fluxoOperacional = getFluxoFollowUpOperacionalChat(conversa);
  if (fluxoOperacional.length > 0) {
    const infoFluxo = getFollowUpProcessInfoFromFluxo(
      conversa,
      mensagens,
      fluxoOperacional,
      followUpRegras,
    );
    if (infoFluxo?.ativo) return infoFluxo;
  }

  const ativo = Boolean(
    conversa?._follow_up_pendente ||
    conversa?._followup_chamado_id ||
    conversa?._follow_up_id ||
    conversa?._follow_up_etapa ||
    conversa?._follow_up_titulo ||
    conversa?.status_followup,
  );

  if (!ativo) return { ativo: false };

  const etapaNumeroBase =
    Number(conversa._follow_up_etapa || conversa.followup_ordem || 1) || 1;
  const tipoRegua = detectarTipoReguaFollowUpChat(conversa, [], followUpRegras);
  const nomeRegua = getNomeReguaFollowUpChat(tipoRegua);
  const regraAtual = getRegraFollowUpPorOrdemChat(
    followUpRegras,
    etapaNumeroBase,
    tipoRegua,
  );
  const totalEtapas = getTotalEtapasReguaFollowUpChat(conversa, followUpRegras);

  const statusNormalizado = normalizarTipoMensagemRapida(
    conversa.status_followup ||
      conversa.status ||
      conversa._follow_up_status ||
      "",
  );

  if (
    statusNormalizado.includes("cancel") ||
    statusNormalizado.includes("realiz") ||
    statusNormalizado.includes("execut") ||
    statusNormalizado.includes("respond")
  ) {
    return { ativo: false };
  }

  const liberadoEmBase =
    conversa._follow_up_liberado_em ||
    conversa.agendado_para ||
    conversa.janela_inicio ||
    conversa.updated_at ||
    conversa.created_at ||
    "";
  const liberadoTimestamp = parseDataFollowUpChat(liberadoEmBase);
  const agora = Date.now();
  const vencido = liberadoTimestamp ? liberadoTimestamp <= agora : true;
  const ultimaMensagem = getUltimaMensagemFollowUpChat(mensagens, conversa);
  const clienteRespondeu = ultimaMensagem
    ? isMensagemClienteFollowUpChat(ultimaMensagem)
    : false;
  const operadorExecutou = ultimaMensagem
    ? isMensagemOperadorFollowUpChat(ultimaMensagem)
    : false;
  const perdidoSugerido = Boolean(conversa._follow_up_perdido_sugerido);

  let statusVisual = "pendente";
  if (perdidoSugerido || statusNormalizado.includes("perdid")) {
    statusVisual = "perdido";
  } else if (clienteRespondeu || statusNormalizado.includes("respond")) {
    statusVisual = "respondido";
  } else if (
    statusNormalizado.includes("execut") ||
    statusNormalizado.includes("realiz")
  ) {
    statusVisual = "executado";
  } else if (operadorExecutou && !conversa?._follow_up_pendente) {
    statusVisual = "executado";
  } else if (vencido) {
    statusVisual = "vencido";
  } else {
    statusVisual = "aguardando";
  }

  const etapaJaEncerrada = ["executado", "respondido"].includes(statusVisual);
  const etapaAtualAcionavel = ["vencido", "pendente", "perdido"].includes(
    statusVisual,
  );

  const proximaNumero = etapaNumeroBase + 1;
  const proximaTitulo = getPrimeiroValorTexto([
    conversa._follow_up_proxima_titulo,
    conversa._follow_up_next_titulo,
    conversa.proximo_followup_titulo,
    conversa.proxima_etapa_titulo,
    conversa.next_followup_title,
    etapaJaEncerrada
      ? getRegraFollowUpPorOrdemChat(followUpRegras, proximaNumero, tipoRegua)
          ?.titulo || `Follow-up ${proximaNumero}`
      : "",
  ]);
  const regraProxima = getRegraFollowUpPorOrdemChat(
    followUpRegras,
    proximaNumero,
    tipoRegua,
  );
  const proximaCanal = getPrimeiroValorTexto([
    conversa._follow_up_proxima_canal,
    conversa._follow_up_next_canal,
    conversa.proximo_followup_canal,
    conversa.proxima_etapa_canal,
    conversa.next_followup_channel,
    getCanalDaRegraFollowUpChat(regraProxima, ""),
  ]);
  const proximaTexto = getPrimeiroValorTexto([
    conversa._follow_up_proxima_texto,
    conversa._follow_up_next_texto,
    conversa.proximo_followup_texto,
    conversa.proxima_etapa_texto,
    conversa.next_followup_text,
  ]);
  const proximaDataRaw = getPrimeiroValorTexto([
    conversa._follow_up_proxima_liberado_em,
    conversa._follow_up_next_liberado_em,
    conversa.proximo_agendado_para,
    conversa.proxima_etapa_em,
    conversa.next_followup_at,
  ]);
  const proximaTimestamp = parseDataFollowUpChat(proximaDataRaw);
  const proximaVencida = proximaTimestamp ? proximaTimestamp <= agora : false;

  const etapaNumero = etapaJaEncerrada ? proximaNumero : etapaNumeroBase;
  const etapaTitulo = etapaJaEncerrada
    ? proximaTitulo || `Follow-up ${proximaNumero}`
    : conversa._follow_up_etapa_label ||
      conversa._follow_up_titulo ||
      regraAtual?.titulo ||
      conversa.status_followup ||
      `Follow-up ${etapaNumeroBase}`;

  const dataEtapa = etapaJaEncerrada
    ? proximaDataRaw
      ? formatarDataFollowUpChat(proximaDataRaw)
      : "Aguarda próxima regra"
    : formatarDataFollowUpChat(liberadoEmBase);

  const textoCompleto = etapaJaEncerrada
    ? limparMarcadoresTecnicosFollowUpChat(proximaTexto || "")
    : limparMarcadoresTecnicosFollowUpChat(
        conversa._follow_up_texto ||
          conversa.texto ||
          conversa.mensagem ||
          conversa.preview ||
          regraAtual?.texto ||
          "",
      );
  const textoSugerido = limitarTextoFollowUpChat(textoCompleto, 180);

  const tipoMensagem = etapaJaEncerrada
    ? proximaTitulo || `Follow-up ${proximaNumero}`
    : conversa._follow_up_tipo_mensagem ||
      conversa._follow_up_mensagem_rapida_tipo ||
      etapaTitulo ||
      "Follow-up";

  const tipoAcao = etapaJaEncerrada
    ? getTipoAcaoFollowUpChat({
        _follow_up_canal: proximaCanal,
        _follow_up_tipo_mensagem: proximaTitulo,
        _follow_up_titulo: proximaTitulo,
      })
    : getTipoAcaoFollowUpChat({
        ...conversa,
        _follow_up_canal:
          conversa?._follow_up_canal ||
          conversa?.canal_followup ||
          getCanalDaRegraFollowUpChat(regraAtual, "whatsapp"),
        _follow_up_titulo:
          conversa?._follow_up_titulo || regraAtual?.titulo || "",
      });

  const canalOperacional = getCanalOperacionalFollowUpChat(tipoAcao);
  const tipoAcaoProxima = proximaCanal
    ? getTipoAcaoFollowUpChat({ _follow_up_canal: proximaCanal })
    : null;

  const statusDoPainel = etapaJaEncerrada
    ? proximaVencida
      ? "vencido"
      : "aguardando"
    : statusVisual;

  const acaoDisponivel = Boolean(
    (!etapaJaEncerrada &&
      etapaAtualAcionavel &&
      (tipoAcao === "ligacao" || textoCompleto)) ||
    (etapaJaEncerrada &&
      proximaVencida &&
      tipoAcao === "ligacao" &&
      Boolean(
        conversa._follow_up_proxima_id ||
        conversa._follow_up_next_id ||
        conversa.proximo_followup_id ||
        conversa.proxima_etapa_id ||
        conversa.next_followup_id,
      )),
  );

  const mensagemBloqueioAcao = etapaJaEncerrada
    ? proximaVencida
      ? tipoAcao === "ligacao"
        ? "A próxima ligação só pode ser registrada quando existir uma etapa pendente criada no banco. Atualize ou gere a próxima etapa de follow-up."
        : "A próxima etapa venceu. Atualize a fila de follow-up para carregar a nova ordem."
      : "Esta etapa já foi executada/respondida. Aguarde a próxima regra vencer para voltar aos pendentes."
    : statusDoPainel === "aguardando"
      ? "A etapa ainda não venceu. Ela só deve ser executada quando aparecer como pendente."
      : tipoAcao === "mensagem" && !textoCompleto
        ? "Não encontrei o texto cadastrado para esta etapa. Verifique a regra de follow-up."
        : "Esta etapa não está disponível para execução.";

  const descricao = etapaJaEncerrada
    ? `Tentativa anterior concluída. Próxima ação: ${canalOperacional.acao}.`
    : conversa._follow_up_descricao ||
      conversa.status_followup_detalhe ||
      (statusDoPainel === "respondido"
        ? "Cliente respondeu. Este item volta para Minhas."
        : statusDoPainel === "vencido"
          ? `${canalOperacional.acao} agora.`
          : statusDoPainel === "executado"
            ? "Tentativa concluída. Aguardando próxima ação da régua."
            : statusDoPainel === "perdido"
              ? "Cadência chegou em ponto de decisão."
              : "A próxima ação ainda não liberou.");

  const etapas = montarEtapasFollowUpChat({
    etapaNumeroBase,
    etapaNumero,
    etapaTitulo,
    dataEtapa,
    statusVisual: statusDoPainel,
    etapaJaEncerrada,
    tipoAcao,
    tipoAcaoProxima,
    totalEtapas,
    proximaTitulo,
    proximaData: proximaDataRaw
      ? formatarDataFollowUpChat(proximaDataRaw)
      : "Aguarda próxima regra",
    regras: followUpRegras,
    tipoRegua,
    nomeRegua,
  });

  return {
    ativo: true,
    followupId: getFollowUpIdConversa(conversa),
    cicloId: conversa?.ciclo_id || conversa?.cicloId || null,
    etapaNumero,
    etapaTitulo,
    tipoRegua,
    nomeRegua,
    totalEtapas,
    canalOperacional,
    statusVisual: statusDoPainel,
    descricao,
    dataEtapa,
    textoSugerido,
    textoCompleto,
    tipoMensagem,
    tipoAcao,
    etapas,
    acaoDisponivel,
    mensagemBloqueioAcao,
    etapaJaEncerrada,
  };
}

function montarEtapasFollowUpChat({
  etapaNumeroBase = 1,
  etapaNumero = 1,
  etapaTitulo = "Follow-up",
  dataEtapa = "",
  statusVisual = "pendente",
  etapaJaEncerrada = false,
  tipoAcao = "mensagem",
  tipoAcaoProxima = null,
  totalEtapas = 10,
  proximaTitulo = "",
  proximaData = "Aguarda próxima regra",
  regras = [],
  tipoRegua = "",
  nomeRegua = "Régua de follow-up",
} = {}) {
  const total = Math.max(Number(totalEtapas || 1), etapaNumero || 1);
  const atualVencido =
    statusVisual === "vencido" || statusVisual === "pendente";
  const atualRespondido = statusVisual === "respondido";
  const atualExecutado = statusVisual === "executado";
  const atualPerdido = statusVisual === "perdido";
  const atualAguardando = statusVisual === "aguardando";

  const inicio = Math.max(
    1,
    Math.min(etapaNumero > 3 ? etapaNumero - 2 : 1, Math.max(1, total - 4)),
  );
  const fim = Math.min(total, inicio + 4);
  const etapas = [];

  for (let ordem = inicio; ordem <= fim; ordem += 1) {
    const passada = ordem < etapaNumero;
    const atual = ordem === etapaNumero;
    const futura = ordem > etapaNumero;
    const regra = getRegraFollowUpPorOrdemChat(regras, ordem, tipoRegua);

    const tipoDaEtapa = regra
      ? getTipoAcaoFollowUpChat({
          _follow_up_canal: getCanalDaRegraFollowUpChat(regra, "whatsapp"),
          _follow_up_titulo: regra?.titulo || "",
        })
      : inferirTipoAcaoPorOrdemFollowUpChat({
          ordem,
          etapaAtual: etapaNumero,
          tipoAtual: tipoAcao,
          tipoProxima: tipoAcaoProxima,
        });
    const canal = getCanalOperacionalFollowUpChat(tipoDaEtapa);
    const tituloRegra = regra?.titulo || (atual ? etapaTitulo : "");

    let badge = "Futura";
    let statusIcon = "○";
    let data = futura
      ? ordem === etapaNumero + 1
        ? proximaData
        : "Próxima regra"
      : "";
    let className = "border-slate-200 bg-slate-50 text-slate-600";
    let title = `Tentativa futura · ${nomeRegua}`;

    if (passada) {
      badge = "Feita";
      statusIcon = "✓";
      data = "Já cumprida";
      className = "border-emerald-400 bg-emerald-50 text-emerald-900";
      title = "Tentativa já concluída";
    }

    if (atual) {
      statusIcon = atualExecutado || atualRespondido ? "✓" : "●";
      badge = atualVencido
        ? "Agora"
        : atualRespondido
          ? "Respondido"
          : atualExecutado
            ? "Feita"
            : atualPerdido
              ? "Decisão"
              : atualAguardando
                ? "Aguardando"
                : "Atual";
      data = dataEtapa;
      className = atualVencido
        ? "border-red-300 bg-red-50 text-red-800 ring-1 ring-red-200"
        : atualRespondido
          ? "border-blue-400 bg-blue-50 text-blue-900"
          : atualExecutado
            ? "border-emerald-400 bg-emerald-50 text-emerald-900"
            : atualPerdido
              ? "border-slate-300 bg-slate-900 text-white"
              : "border-orange-200 bg-orange-50 text-orange-800";
      title = `Tentativa atual · ${nomeRegua}`;
    }

    etapas.push({
      key: `etapa-${ordem}`,
      ordem,
      label: `${ordem}/${total}`,
      titulo: tituloRegra || `${canal.emoji} ${canal.canal}`,
      emoji: canal.emoji,
      canal: canal.canal,
      acao: canal.acao,
      badge,
      statusIcon,
      data,
      className,
      title,
    });
  }

  return etapas;
}

function getFollowUpVisualStatusConfig(status = "pendente") {
  if (status === "vencido" || status === "pendente") {
    return {
      label: "Etapa atrasada",
      title: "O prazo venceu e o captador precisa agir agora",
      badge: "bg-orange-100 text-orange-900 ring-orange-300",
      icon: <FaRegClock size={11} />,
    };
  }

  if (status === "respondido") {
    return {
      label: "Cliente respondeu",
      title: "Sai do follow-up e volta para Minhas",
      badge: "bg-blue-100 text-blue-800 ring-blue-200",
      icon: <FaCommentDots size={11} />,
    };
  }

  if (status === "executado") {
    return {
      label: "Etapa executada",
      title: "Aguardando próxima ordem vencer",
      badge: "bg-emerald-100 text-emerald-800 ring-emerald-200",
      icon: <FaPaperPlane size={11} />,
    };
  }

  if (status === "perdido") {
    return {
      label: "Avaliar perdido",
      title: "Cadência chegou ao ponto de decisão",
      badge: "bg-slate-900 text-white ring-slate-700",
      icon: <FaTimes size={11} />,
    };
  }

  return {
    label: "Aguardando liberação",
    title: "Ainda não venceu",
    badge: "bg-orange-100 text-orange-800 ring-orange-200",
    icon: <FaRegClock size={11} />,
  };
}

function isMensagemSistemaOuAutomacaoFollowUpChat(mensagem = {}) {
  const autor = normalizarTipoMensagemRapida(
    mensagem.autor ||
      mensagem.de ||
      mensagem.from ||
      mensagem.remetente ||
      mensagem.sender ||
      mensagem.tipo_autor ||
      "",
  );

  const direcao = normalizarTipoMensagemRapida(
    mensagem.direcao || mensagem.direction || mensagem.sentido || "",
  );

  const origem = normalizarTipoMensagemRapida(
    mensagem.origem ||
      mensagem.origem_envio ||
      mensagem.tipo_envio ||
      mensagem.automacao_tipo ||
      "",
  );

  const automacaoFlag =
    mensagem.automacao === true ||
    mensagem.automacao === 1 ||
    String(mensagem.automacao || "").toLowerCase() === "true" ||
    Boolean(mensagem.automacao_tipo);

  return Boolean(
    automacaoFlag ||
    autor.includes("sistema") ||
    autor.includes("bot") ||
    autor.includes("automat") ||
    direcao.includes("interno") ||
    origem.includes("automat") ||
    origem.includes("sistema") ||
    origem.includes("bot"),
  );
}

function getUltimaMensagemFollowUpChat(mensagens = [], conversa = {}) {
  const lista =
    Array.isArray(mensagens) && mensagens.length
      ? mensagens
      : conversa?.mensagens || [];

  const operacionais = [...(lista || [])]
    .filter(Boolean)
    .filter((mensagem) => !isMensagemSistemaOuAutomacaoFollowUpChat(mensagem))
    .sort(
      (a, b) =>
        parseDataFollowUpChat(b.datahora || b.created_at || b.timestamp) -
        parseDataFollowUpChat(a.datahora || a.created_at || a.timestamp),
    );

  if (operacionais.length) return operacionais[0];

  return null;
}

function isMensagemClienteFollowUpChat(mensagem = {}) {
  const direcao = normalizarTipoMensagemRapida(
    mensagem.direcao || mensagem.direction || "",
  );
  const autor = normalizarTipoMensagemRapida(
    mensagem.autor || mensagem.de || mensagem.from || "",
  );
  const fromMe = mensagem.fromMe === true || mensagem.from_me === true;

  if (fromMe) return false;

  return (
    direcao.includes("recebid") ||
    direcao.includes("entrada") ||
    autor.includes("cliente") ||
    autor.includes("contato") ||
    autor.includes("lead")
  );
}

function isMensagemOperadorFollowUpChat(mensagem = {}) {
  if (isMensagemSistemaOuAutomacaoFollowUpChat(mensagem)) return false;

  const direcao = normalizarTipoMensagemRapida(
    mensagem.direcao || mensagem.direction || "",
  );
  const autor = normalizarTipoMensagemRapida(
    mensagem.autor || mensagem.de || mensagem.from || "",
  );
  const fromMe = mensagem.fromMe === true || mensagem.from_me === true;

  return (
    fromMe ||
    autor.includes("operador") ||
    autor.includes("atendente") ||
    autor.includes("captador") ||
    autor.includes("usuario") ||
    (direcao.includes("enviad") && !autor) ||
    (direcao.includes("saida") && !autor)
  );
}

function parseDataFollowUpChat(value) {
  if (!value) return 0;
  if (value instanceof Date)
    return Number.isNaN(value.getTime()) ? 0 : value.getTime();
  if (typeof value === "number")
    return value < 10000000000 ? value * 1000 : value;

  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
}

function formatarDataFollowUpChat(value) {
  const timestamp = parseDataFollowUpChat(value);
  if (!timestamp) return "Sem data definida";

  return new Date(timestamp).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function limparMarcadoresTecnicosFollowUpChat(value = "") {
  // A régua usa metadados entre colchetes para controle interno. Eles nunca
  // pertencem ao texto mostrado ou enviado ao paciente.
  return String(value ?? "")
    .replace(/\uFEFF/g, "")
    .replace(/\r\n?/g, "\n")
    .replace(/\[(?:followup[\s_-]*lead[\s_-]*fria|lead[\s_-]*fria)\]/gi, "")
    .replace(/\[ordem\s*:\s*\d+\]/gi, "")
    .replace(/\[ciclo(?:_id)?\s*:\s*[^\]]*\]/gi, "")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .replace(/^[ \t]*\n+/g, "")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n[ \t]+/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

function limitarTextoFollowUpChat(value = "", limite = 180) {
  const texto = limparMarcadoresTecnicosFollowUpChat(value)
    .replace(/\s+/g, " ")
    .trim();
  if (!texto) return "";
  if (texto.length <= limite) return texto;
  return `${texto.slice(0, limite).trim()}...`;
}

function ConversationContext({ conversa, canalStyle }) {
  // Bloco removido para priorizar espaço de conversa.
  // Dados de origem/CRM continuam disponíveis no painel lateral/detalhes.
  return null;
}

function getOrigemAnuncioConversa(conversa = {}) {
  const lead = conversa.lead || {};

  const direta = normalizarOrigemAdsChat(
    conversa.origem_ads ||
      conversa.origemAds ||
      conversa.whatsapp_ads_origem ||
      conversa.whatsappAdsOrigem ||
      conversa.ads_origem ||
      conversa.adsOrigem ||
      conversa.meta_ads_origem ||
      conversa.metaAdsOrigem ||
      conversa.anuncio ||
      conversa.ad ||
      conversa.ultimo_anuncio ||
      conversa.ultimoAnuncio ||
      lead.origem_ads ||
      lead.origemAds || {
        titulo:
          conversa.ads_titulo ||
          conversa.ad_titulo ||
          conversa.anuncio_titulo ||
          conversa.nome_anuncio ||
          conversa.ad_name ||
          lead.ads_titulo ||
          lead.ad_titulo ||
          lead.nome_anuncio,
        corpo:
          conversa.ads_corpo ||
          conversa.ad_corpo ||
          conversa.anuncio_corpo ||
          conversa.descricao_anuncio ||
          lead.ads_corpo ||
          lead.ad_corpo,
        thumbnail_url:
          conversa.thumbnail_url ||
          conversa.ads_thumbnail_url ||
          conversa.ad_thumbnail_url ||
          conversa.anuncio_thumbnail_url ||
          lead.thumbnail_url ||
          lead.ads_thumbnail_url,
        source_id:
          conversa.source_id ||
          conversa.sourceId ||
          conversa.ad_id ||
          conversa.ads_source_id ||
          conversa.anuncio_id ||
          conversa.ctwa_clid ||
          lead.source_id ||
          lead.ad_id,
        source_type:
          conversa.source_type || conversa.ads_source_type || lead.source_type,
        source_url:
          conversa.source_url ||
          conversa.sourceUrl ||
          conversa.ad_source_url ||
          conversa.anuncio_url ||
          conversa.url_anuncio ||
          conversa.link_anuncio ||
          lead.source_url,
        campanha:
          conversa.campanha_ads ||
          conversa.ads_campanha ||
          conversa.campaign_name ||
          conversa.campanha_nome ||
          lead.campanha_ads ||
          lead.ads_campanha ||
          lead.campaign_name ||
          lead.campanha_nome,
      },
  );

  if (!direta) return null;

  return {
    url: direta.sourceUrl,
    titulo: direta.titulo || direta.campanha || direta.sourceId,
    corpo: direta.corpo,
    source_id: direta.sourceId,
    thumbnailUrl: direta.thumbnailUrl,
    campanha: direta.campanha,
  };
}

function normalizarOrigemAdsChat(origem = null) {
  if (!origem || typeof origem !== "object") return null;

  const payload = parsePayloadJsonAdsChat(
    origem.payload_json || origem.payloadJson,
  );

  const titulo = getPrimeiroValorTexto([
    origem.titulo,
    origem.title,
    origem.headline,
    origem.nome_anuncio,
    origem.nomeAnuncio,
    origem.ad_name,
    origem.adName,
    payload?.title,
    payload?.headline,
    payload?.source?.title,
    payload?.referral?.headline,
  ]);

  const corpo = getPrimeiroValorTexto([
    origem.corpo,
    origem.body,
    origem.texto,
    origem.description,
    origem.descricao,
    payload?.body,
    payload?.description,
    payload?.source?.body,
    payload?.referral?.body,
  ]);

  const thumbnailUrl = getPrimeiroValorTexto([
    origem.thumbnail_url,
    origem.thumbnailUrl,
    origem.image_url,
    origem.imageUrl,
    origem.imagem_url,
    origem.imagemUrl,
    payload?.thumbnail_url,
    payload?.thumbnailUrl,
    payload?.image_url,
    payload?.source?.thumbnail_url,
    payload?.referral?.thumbnail_url,
  ]);

  const sourceId = getPrimeiroValorTexto([
    origem.source_id,
    origem.sourceId,
    origem.ad_id,
    origem.adId,
    origem.anuncio_id,
    origem.ctwa_clid,
    origem.ctwaClid,
    payload?.source_id,
    payload?.source?.id,
    payload?.referral?.source_id,
  ]);

  const sourceType = getPrimeiroValorTexto([
    origem.source_type,
    origem.sourceType,
    payload?.source_type,
    payload?.source?.type,
    payload?.referral?.source_type,
  ]);

  const sourceUrl = getPrimeiroValorTexto([
    origem.source_url,
    origem.sourceUrl,
    origem.url,
    origem.link,
    origem.url_anuncio,
    origem.link_anuncio,
    payload?.source_url,
    payload?.source?.url,
    payload?.referral?.source_url,
  ]);

  const campanha = getPrimeiroValorTexto([
    origem.campanha,
    origem.campanha_nome,
    origem.nome_campanha,
    origem.campaign_name,
    origem.campaign,
    origem.utm_campaign,
    payload?.campaign_name,
    payload?.campaign,
    payload?.utm_campaign,
    payload?.source?.campaign_name,
    payload?.referral?.campaign_name,
  ]);

  if (
    !titulo &&
    !corpo &&
    !thumbnailUrl &&
    !sourceId &&
    !sourceUrl &&
    !campanha
  ) {
    return null;
  }

  return {
    titulo,
    corpo,
    thumbnailUrl,
    sourceId,
    sourceType,
    sourceUrl,
    campanha,
  };
}

function parsePayloadJsonAdsChat(value) {
  if (!value) return null;
  if (typeof value === "object") return value;

  try {
    return JSON.parse(String(value));
  } catch {
    return null;
  }
}

async function buscarOrigemAdsConversaChat(
  conversa = {},
  empresaIdFallback = null,
) {
  const empresaId =
    conversa.empresa_id ||
    conversa.empresaId ||
    conversa.lead?.empresa_id ||
    empresaIdFallback;

  const telefone = normalizarTelefoneCaptaZap(
    conversa.numero ||
      conversa.telefone ||
      conversa.phone ||
      conversa.lead?.telefone1 ||
      conversa.lead?.telefone ||
      conversa.lead?.celular ||
      conversa.lead?.whatsapp,
  );

  if (!empresaId || !telefone) return null;

  const params = new URLSearchParams();
  params.set("empresa_id", String(empresaId));
  params.set("telefone", telefone);

  const data = await requestJson(
    `/whatsapp/captazap/origem-ads?${params.toString()}`,
  );

  const origem = normalizarOrigemAdsChat(
    data?.origem || data?.data || data?.ads || data,
  );

  if (!origem) return null;

  return {
    url: origem.sourceUrl,
    titulo: origem.titulo || origem.campanha || origem.sourceId,
    corpo: origem.corpo,
    source_id: origem.sourceId,
    thumbnailUrl: origem.thumbnailUrl,
    campanha: origem.campanha,
  };
}

function normalizarTelefoneCaptaZap(value = "") {
  return String(value || "").replace(/\D/g, "");
}

function mensagemPertenceTelefoneConversaCaptaZap(
  mensagem = {},
  telefoneConversa = "",
) {
  const telefoneAtual = normalizarTelefoneCaptaZap(telefoneConversa);

  if (!telefoneAtual) return true;

  const telefoneMensagem = normalizarTelefoneCaptaZap(
    mensagem.telefone ||
      mensagem.numero ||
      mensagem.phone ||
      mensagem.whatsapp ||
      mensagem.from ||
      mensagem.to ||
      "",
  );

  // Mensagens locais recém-enviadas ou registros antigos podem não carregar
  // telefone no payload. Nesses casos, mantemos a mensagem. Se houver telefone
  // explícito e ele for diferente, bloqueamos para evitar vazamento visual de
  // outra conversa.
  if (!telefoneMensagem) return true;

  return telefoneMensagem === telefoneAtual;
}

function normalizarTextoAnuncioHeader(value = "") {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function getLabelAnuncioHeader(anuncio = {}) {
  const campanha = String(anuncio?.campanha || "").trim();
  const campanhaNormalizada = normalizarTextoAnuncioHeader(campanha);

  if (
    campanha &&
    campanhaNormalizada !== "nao informada" &&
    campanhaNormalizada !== "nao informado" &&
    campanhaNormalizada !== "sem campanha" &&
    campanhaNormalizada !== "campanha nao informada"
  ) {
    return `Anúncio · ${campanha}`;
  }

  return "Anúncio";
}

function AnuncioHeaderCard({ anuncio }) {
  if (!anuncio) return null;

  const campanha = String(anuncio.campanha || "").trim();
  const title = [
    "Anúncio",
    campanha ? `Campanha: ${campanha}` : "Origem Meta Ads",
  ]
    .filter(Boolean)
    .join(" · ");
  const content = (
    <>
      {anuncio.thumbnailUrl ? (
        <img
          src={anuncio.thumbnailUrl}
          alt="Imagem do anúncio"
          loading="lazy"
          className="h-6 w-6 shrink-0 rounded-md object-cover ring-1 ring-blue-200"
          onError={(event) => {
            event.currentTarget.style.display = "none";
          }}
        />
      ) : (
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-blue-100 text-blue-700 ring-1 ring-blue-200">
          <FaBolt size={12} />
        </span>
      )}

      <span className="min-w-0 text-left">
        <span className="block text-[9px] font-black uppercase tracking-wide text-blue-700">
          Anúncio
        </span>
        {campanha ? (
          <span className="block max-w-[105px] truncate text-[8.5px] font-bold leading-tight text-slate-500">
            {campanha}
          </span>
        ) : (
          <span className="block max-w-[105px] truncate text-[8.5px] font-bold leading-tight text-slate-500">
            Meta Ads
          </span>
        )}
      </span>
    </>
  );

  const className =
    "hidden h-8 max-w-[150px] items-center gap-1.5 rounded-lg border border-blue-200 bg-blue-50/80 px-1.5 transition hover:border-blue-400 hover:bg-blue-100 md:inline-flex";

  if (anuncio.url) {
    return (
      <a
        href={anuncio.url}
        target="_blank"
        rel="noreferrer"
        className={className}
        title={title}
      >
        {content}
      </a>
    );
  }

  return (
    <div className={className} title={title}>
      {content}
    </div>
  );
}

function formatTelefoneHeader(value = "") {
  const digits = normalizarTelefoneCaptaZap(value);

  if (digits.length >= 11) {
    const local = digits.slice(-11);
    return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
  }

  if (digits.length >= 10) {
    const local = digits.slice(-10);
    return `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`;
  }

  return String(value || "");
}

function EmptyConversation() {
  return (
    <div className="flex h-full items-center justify-center bg-[#F8FAFD] px-8">
      <div className="max-w-sm rounded-[30px] border border-slate-300 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-3xl bg-emerald-50 text-[#25D366] ring-1 ring-emerald-200">
          <FaWhatsapp size={26} />
        </div>

        <h2 className="text-lg font-bold text-slate-950">
          Nenhuma conversa selecionada
        </h2>

        <p className="mt-2 text-sm leading-6 text-slate-500">
          Selecione um atendimento na lista para visualizar o histórico e
          responder o contato.
        </p>
      </div>
    </div>
  );
}

function LoadingMessages({ canal }) {
  const canalStyle = getCanalStyle(canal);

  return (
    <div className="relative flex h-full items-center justify-center">
      <div className="max-w-sm rounded-[30px] border border-slate-300 bg-white p-8 text-center shadow-sm">
        <div
          className={`mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-3xl ring-1 ${canalStyle.avatarBg}`}
        >
          <CanalIcon canal={canal} size={25} />
        </div>

        <h3 className="text-base font-bold text-slate-800">
          Carregando mensagens...
        </h3>

        <p className="mt-2 text-sm leading-6 text-slate-500">
          Buscando o histórico deste atendimento.
        </p>

        <div className="mx-auto mt-5 h-2 w-32 overflow-hidden rounded-full bg-slate-100">
          <div className="h-full w-1/2 animate-pulse rounded-full bg-blue-500" />
        </div>
      </div>
    </div>
  );
}

function EmptyMessages({ canal }) {
  const canalStyle = getCanalStyle(canal);

  return (
    <div className="relative flex h-full items-center justify-center">
      <div className="max-w-sm rounded-[30px] border border-slate-300 bg-white p-8 text-center shadow-sm">
        <div
          className={`mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-3xl ring-1 ${canalStyle.avatarBg}`}
        >
          <CanalIcon canal={canal} size={25} />
        </div>

        <h3 className="text-base font-bold text-slate-800">
          Nenhuma mensagem ainda
        </h3>

        <p className="mt-2 text-sm leading-6 text-slate-500">
          Quando houver mensagens neste atendimento, elas aparecerão aqui.
        </p>
      </div>
    </div>
  );
}

function EmpresaMismatch({ conversa, empresaId }) {
  return (
    <div className="flex h-full items-center justify-center bg-slate-50 px-8">
      <div className="max-w-md rounded-[32px] border border-red-200 bg-white p-8 text-center shadow-xl">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-3xl bg-red-50 text-red-600 ring-1 ring-red-200">
          <FaLock size={24} />
        </div>

        <h2 className="text-lg font-bold text-slate-950">
          Conversa bloqueada para esta empresa
        </h2>

        <p className="mt-2 text-sm leading-6 text-slate-500">
          Esta conversa pertence a outra empresa ou não possui vínculo válido
          com a empresa ativa.
        </p>

        <div className="mt-5 rounded-2xl bg-slate-50 px-4 py-3 text-left text-xs text-slate-500 ring-1 ring-slate-200">
          <div>
            <span className="font-bold text-slate-700">Empresa ativa:</span>{" "}
            {empresaId || "não identificada"}
          </div>

          <div className="mt-1">
            <span className="font-bold text-slate-700">
              Empresa da conversa:
            </span>{" "}
            {conversa?.empresa_id || conversa?.empresaId || "não informada"}
          </div>
        </div>
      </div>
    </div>
  );
}

function CanalIcon({ canal, size = 14 }) {
  const normalized = String(canal || "").toLowerCase();

  if (normalized.includes("whatsapp")) {
    return <FaWhatsapp className="text-[#25D366]" size={size} />;
  }

  if (normalized.includes("instagram")) {
    return <FaInstagram className="text-[#C13584]" size={size} />;
  }

  if (normalized.includes("facebook") || normalized.includes("messenger")) {
    return <FaFacebookMessenger className="text-[#1877F2]" size={size} />;
  }

  if (normalized.includes("telegram")) {
    return <FaTelegramPlane className="text-[#229ED9]" size={size} />;
  }

  return <FaWhatsapp className="text-[#25D366]" size={size} />;
}

function getCanalStyle(canal) {
  const normalized = String(canal || "").toLowerCase();

  if (normalized.includes("whatsapp")) {
    return {
      accent: "bg-[#25D366]",
      avatarRing: "ring-emerald-300",
      avatarBg: "bg-emerald-50 text-[#128C7E] ring-emerald-200",
      iconBg: "bg-emerald-50",
      badge: "border-emerald-200 bg-emerald-50 text-[#128C7E]",
      sendButton: "bg-[#25D366] hover:bg-[#1FB85A] shadow-emerald-700/20",
      audioButton:
        "border-[#25D366] bg-[#25D366] hover:bg-[#1FB85A] shadow-emerald-700/20",
      softChip: "border-emerald-200 bg-emerald-50 text-emerald-700",
    };
  }

  if (normalized.includes("instagram")) {
    return {
      accent: "bg-gradient-to-r from-[#833AB4] via-[#E1306C] to-[#FCAF45]",
      avatarRing: "ring-pink-300",
      avatarBg:
        "bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 text-[#C13584] ring-pink-200",
      iconBg: "bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50",
      badge:
        "border-pink-200 bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 text-[#C13584]",
      sendButton:
        "bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#FCAF45] hover:brightness-95 shadow-pink-700/20",
      audioButton:
        "border-pink-400 bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#FCAF45] hover:brightness-95 shadow-pink-700/20",
      softChip:
        "border-pink-200 bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 text-[#C13584]",
    };
  }

  if (normalized.includes("facebook") || normalized.includes("messenger")) {
    return {
      accent: "bg-[#1877F2]",
      avatarRing: "ring-blue-300",
      avatarBg: "bg-blue-50 text-[#1877F2] ring-blue-200",
      iconBg: "bg-blue-50",
      badge: "border-blue-200 bg-blue-50 text-[#1877F2]",
      sendButton: "bg-[#1877F2] hover:bg-[#0F66D0] shadow-blue-700/20",
      audioButton:
        "border-[#1877F2] bg-[#1877F2] hover:bg-[#0F66D0] shadow-blue-700/20",
      softChip: "border-blue-200 bg-blue-50 text-blue-700",
    };
  }

  if (normalized.includes("telegram")) {
    return {
      accent: "bg-[#229ED9]",
      avatarRing: "ring-sky-300",
      avatarBg: "bg-sky-50 text-[#229ED9] ring-sky-200",
      iconBg: "bg-sky-50",
      badge: "border-sky-200 bg-sky-50 text-[#229ED9]",
      sendButton: "bg-[#229ED9] hover:bg-[#168AC2] shadow-sky-700/20",
      audioButton:
        "border-[#229ED9] bg-[#229ED9] hover:bg-[#168AC2] shadow-sky-700/20",
      softChip: "border-sky-200 bg-sky-50 text-sky-700",
    };
  }

  return {
    accent: "bg-blue-600",
    avatarRing: "ring-blue-300",
    avatarBg: "bg-blue-50 text-blue-700 ring-blue-200",
    iconBg: "bg-blue-50",
    badge: "border-blue-200 bg-blue-50 text-blue-700",
    sendButton: "bg-blue-600 hover:bg-blue-700 shadow-blue-700/20",
    audioButton:
      "border-blue-600 bg-blue-600 hover:bg-blue-700 shadow-blue-700/20",
    softChip: "border-blue-200 bg-blue-50 text-blue-700",
  };
}

function getMessageKey(mensagem, index, empresaId, conversaKey) {
  const mensagemEmpresa =
    mensagem?.empresa_id || mensagem?.empresaId || empresaId;
  const mensagemId =
    mensagem?.id ||
    mensagem?.message_id ||
    mensagem?.whatsapp_id ||
    mensagem?.msgid ||
    mensagem?.messageId;
  const telefoneMensagem = normalizarTelefoneCaptaZap(
    mensagem?.telefone ||
      mensagem?.numero ||
      mensagem?.phone ||
      mensagem?.whatsapp ||
      "",
  );

  return `${mensagemEmpresa}-${conversaKey}-${telefoneMensagem || "sem-tel"}-${mensagemId || index}`;
}

function getTelefoneContextoPacienteKeyCaptaZap(value = "") {
  const digits = normalizarTelefoneCaptaZap(value);
  if (!digits) return "sem-telefone";

  // A API pode alternar entre 61999999999 e 5561999999999 após refresh.
  // Usar os 11 últimos dígitos mantém a mesma chave para o mesmo WhatsApp BR.
  return digits.length >= 11 ? digits.slice(-11) : digits;
}

function getLeadIdPersistidoValidoCaptaZap(key = "", idsValidos = null) {
  const salvo = getLeadContextoLocalCaptaZap(key);
  const texto = String(salvo || "");

  if (!texto) return null;
  if (idsValidos && idsValidos.size > 0 && !idsValidos.has(texto)) return null;

  return texto;
}

function getLeadIdPersistidoValidoPorTelefoneCaptaZap(
  key = "",
  leads = [],
  telefone = "",
) {
  const salvo = getLeadContextoLocalCaptaZap(key);
  const texto = String(salvo || "");

  if (!texto) return null;

  const lista = Array.isArray(leads) ? leads.filter(Boolean) : [];

  // Durante refresh, a lista pode vir vazia por alguns instantes. Mantém o
  // valor salvo para não derrubar o contexto entre um envio e outro. Quando a
  // lista voltar, a validação por telefone passa a ser aplicada.
  if (!lista.length) return texto;

  const lead = lista.find(
    (item) => String(getLeadIdGenerico(item) || "") === texto,
  );

  if (!lead) return null;

  return leadPertenceAoTelefoneCaptaZap(lead, telefone) ? texto : null;
}

function getLeadsVinculadasConversa(conversa = {}) {
  const candidatos = [
    conversa.leads_vinculadas,
    conversa.leadsVinculadas,
    conversa.leads_relacionadas,
    conversa.leadsRelacionadas,
    conversa.telefone_leads,
    conversa.telefoneLeads,
  ];

  for (const lista of candidatos) {
    if (Array.isArray(lista) && lista.length) return lista.filter(Boolean);
  }

  if (conversa.lead) return [conversa.lead].filter(Boolean);

  return [];
}

function getLeadContextoIdConversa(conversa = {}) {
  return getLeadContextoSeguroConversa(conversa);
}

function getTelefonePrincipalConversaCaptaZap(conversa = {}) {
  return (
    conversa?.telefone ||
    conversa?.numero ||
    conversa?.phone ||
    conversa?.whatsapp ||
    ""
  );
}

function getUltimos8TelefoneCaptaZap(value = "") {
  return String(value || "")
    .replace(/\D/g, "")
    .slice(-8);
}

function leadPertenceAoTelefoneCaptaZap(lead = {}, telefone = "") {
  const telConversa = getUltimos8TelefoneCaptaZap(telefone);

  if (!telConversa) return false;

  const telefonesLead = [
    lead.telefone1,
    lead.telefone2,
    lead.telefone,
    lead.celular,
    lead.whatsapp,
    lead.numero,
  ]
    .map(getUltimos8TelefoneCaptaZap)
    .filter(Boolean);

  return telefonesLead.includes(telConversa);
}

function getLeadContextoSeguroConversa(conversa = {}) {
  const telefone = getTelefonePrincipalConversaCaptaZap(conversa);
  const leads = getLeadsVinculadasConversa(conversa);

  const contextoDireto =
    conversa.lead_contexto_id ||
    conversa.leadContextoId ||
    conversa.lead_contexto?.id ||
    conversa.leadContexto?.id ||
    null;

  if (contextoDireto && leads.length) {
    const leadContexto = leads.find(
      (lead) => String(getLeadIdGenerico(lead)) === String(contextoDireto),
    );

    if (
      leadContexto &&
      leadPertenceAoTelefoneCaptaZap(leadContexto, telefone)
    ) {
      return contextoDireto;
    }

    return null;
  }

  if (leads.length === 1) {
    const unica = leads[0];

    if (leadPertenceAoTelefoneCaptaZap(unica, telefone)) {
      return getLeadIdGenerico(unica);
    }

    return null;
  }

  if (leads.length > 1) return null;

  const leadDireta = conversa.lead || null;
  const leadDiretaId =
    conversa.lead_id || conversa.leadId || conversa.id_lead || leadDireta?.id;

  if (leadDireta && leadDiretaId) {
    if (leadPertenceAoTelefoneCaptaZap(leadDireta, telefone)) {
      return leadDiretaId;
    }

    return null;
  }

  return null;
}

function getLeadIdGenerico(lead = {}) {
  return lead.id || lead.lead_id || lead.leadId || lead.id_lead || null;
}

function getLeadContextoLocalCaptaZap(key = "") {
  if (!key || typeof window === "undefined") return null;

  try {
    const value = window.localStorage?.getItem(key);
    return value ? Number(value) || value : null;
  } catch {
    return null;
  }
}

function salvarLeadContextoLocalCaptaZap(key = "", leadId = null) {
  if (!key || !leadId || typeof window === "undefined") return;

  try {
    window.localStorage?.setItem(key, String(leadId));
  } catch {
    // localStorage indisponível: mantém apenas estado em memória.
  }
}

function getNomeLeadVinculada(lead = {}) {
  return (
    lead.nome_lead ||
    lead.nomeLead ||
    lead.nome ||
    lead.nome_cliente ||
    lead.paciente ||
    lead.telefone1 ||
    lead.telefone ||
    `Lead #${getLeadIdGenerico(lead) || ""}`.trim()
  );
}

function formatStatus(status) {
  return String(status || "")
    .replaceAll("_", " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
